// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { actionRecommendationAppInboxRecommendationsRecommendationIdActionPost, assignAccountsAppAccountsAssignPost, authBearerLoginAuthBearerLoginPost, authBearerLogoutAuthBearerLogoutPost, authCookieLoginAuthLoginPost, authCookieLogoutAuthLogoutPost, chatAuthAppChatAuthGet, checkBatchStatusAppAccountsProcessingStatusBatchAccountIdGet, checkMultipleBatchStatusAppAccountsProcessingStatusBatchPost, claimLeadsAppScoutClaimPost, completeDebriefConversationAppDebriefDebriefIdConversationCompletePost, completeDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPost, createAccountFromCompanyDataAppAccountsQuickCreatePost, createAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPost, createAccountFromSupplierAppAccountsQuickCreateFromSupplierPost, createBuyerProfileAppBuyerProfilesPost, createDistributorRelationshipAppOrganizationDistributorRelationshipsPost, createMarketResearchReportAppMarketResearchReportsPost, createMemberAppOrganizationOrganizationsMembersPost, createMergeLinkTokenAppIntegrationsMergeLinkTokenPost, createNoteAppAccountsNotesAccountIdPost, createOrganizationSuperuserCreatePost, createPersonaAppOrganizationPersonasPost, createProductAppProductsPost, customExportClearTemplateAppAccountsExportCustomExportTemplateDelete, customExportDownloadAppAccountsExportCustomExportDownloadPost, customExportGetSourceFieldsAppAccountsExportCustomExportFieldsGet, customExportGetTemplateAppAccountsExportCustomExportTemplateGet, customExportParseTemplateAppAccountsExportCustomExportParseTemplatePost, customExportPreviewAppAccountsExportCustomExportPreviewPost, customExportSaveTemplateAppAccountsExportCustomExportTemplatePut, deleteAccountsAppAccountsDelete, deleteBuyerProfileAppBuyerProfilesTagIdDelete, deleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDelete, deleteFeedback, deleteMarketResearchReportAppMarketResearchReportsReportIdDelete, deleteMemberAppOrganizationOrganizationsMembersUserIdDelete, deleteNoteAppAccountsNotesAccountIdNoteIdDelete, deleteOrdersAppOrdersDelete, deletePersonaAppOrganizationPersonasPersonaIdDelete, deleteProductAppProductsProductIdDelete, demodaySignupAppDemodaySignupPost, devLoginDevLoginEmailPost, disconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPost, dismissRecommendationAppInboxRecommendationsRecommendationIdDismissPost, downloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGet, emailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPost, emailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePost, endConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPost, enrichByLinkedinUrlAppLinkedinEnrichPost, enrichContactAppAccountsContactsAccountIdEnrichPersonIdPost, exchangeTokenAppIntegrationsMergeExchangeTokenPost, executeBatchUploadAppAccountsBatchUploadsExecutePost, executeBatchUploadSuperuserBatchUploadsExecutePost, exportAccountsAppAccountsExportExportPost, exportContactsAppAccountsExportContactsPost, exportRenewalReportAppAccountActionsActivityRenewalReportExportPost, fetchMoreContactsAppAccountsContactsAccountIdFetchMorePost, generateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPost, generateEmailAppAccountActionsEmailGenerationPost, generateTamReportSuperuserTamReportsPost, getAccountContactsAppAccountsContactsAccountIdGet, getAccountContactsFullAppAccountsContactsAccountIdFullGet, getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGet, getAccountDetailsAppAccountsAccountsAccountIdGet, getAccountFacetOptionsAppAccountsFilterOptionsFacetPost, getAccountHistoryAppAccountsHistoryAccountIdGet, getAccountProcessingStatusAppAccountsProcessingStatusAccountIdGet, getAccountsHeatMapAppAccountsHeatMapsPost, getAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGet, getActivityLeaderboardAppAccountActionsActivityLeaderboardGet, getActivityLogAppAccountActionsActivityLogGet, getActivityStatsAppAccountActionsActivityStatsGet, getActivityTimelineAppAccountActionsActivityTimelineGet, getAgentRunAppAgentRunsRunIdGet, getAllOrganizationsSuperuserOrganizationsGet, getAssignableUsersAppOrganizationOrganizationsAssignableUsersGet, getBackfillInboxStatusSuperuserBackfillInboxStatusGet, getBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGet, getCompanyInfoAppOrganizationCompanyInfoGet, getCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGet, getContactDetailAppAccountsContactsAccountIdDetailPersonIdGet, getConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGet, getCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGet, getCrmContactsAppAccountsAccountsAccountIdCrmContactsGet, getCrmUsersAppIntegrationsMergeCrmUsersGet, getDashboardAppScoutDashboardGet, getDealEventsAppOrdersDealsDealIdEventsGet, getDebriefHistoryAppDebriefHistoryGet, getDistributorsAppOrganizationOrganizationsDistributorsGet, getEmailPreferences, getEnrichmentFreshnessSuperuserFreshnessGet, getEnrichmentStatusSuperuserEnrichmentStatusGet, getExportEmailsAppAccountsExportEmailsPost, getFeedback, getGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGet, getImpersonationStatusSuperuserImpersonationCurrentGet, getInboundAddressAppOrdersInboundAddressGet, getInboundConfigAppOrganizationOrganizationsMeInboundConfigGet, getIntegrationStatusAppIntegrationsMergeStatusGet, getMapPointsAppAccountsAccountsMapPointsPost, getMarketResearchReportAppMarketResearchReportsReportIdGet, getMarketResearchReportsAppMarketResearchReportsGet, getNewsfeedAppInboxNewsfeedGet, getOrderAppOrdersOrderIdGet, getOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGet, getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGet, getOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGet, getOrderPreviewAppOrdersOrderIdPreviewGet, getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGet, getOrganizationInfoAppOrganizationOrganizationsInfoGet, getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGet, getPartnersAppOnboardingPartnersGet, getPersonasAppOrganizationPersonasGet, getProductAppProductsProductIdGet, getRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGet, getRecommendationCountAppInboxRecommendationsCountGet, getRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGet, getResearchingAccountsCountAppAccountActionsActivityResearchingCountGet, getSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGet, getSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGet, getTamReportAppTamReportsReportIdGet, getTamReportsAppTamReportsGet, getUserSuperuserUsersUserIdGet, getVectorTileAppAccountsAccountsTilesZXYPbfGet, healthCheckHealthGet, healthDetailedHealthDetailedGet, inboundEmailWebhooksInboundEmailPost, joinAppDemodayJoinPost, joinCompleteAppOnboardingJoinCompletePost, joinInfoAppOnboardingJoinInfoGet, launchAgentRunAppAgentRunsLaunchPost, leaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPost, listAgentRunsAppAgentRunsGet, listBuyerProfilesAppBuyerProfilesGet, listDealsAppOrdersDealsGet, listDemodayOrgsAppDemodayOrgsGet, listDevUsersDevUsersGet, listImpersonationSessionsSuperuserImpersonationSessionsGet, listNotesAppAccountsNotesAccountIdGet, listOrdersAppOrdersGet, listProductsAppProductsGet, listRecommendationsAppInboxRecommendationsGet, listSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGet, logActivityActionsAppAccountActionsActivityActionsPost, magicLinkAuthMagicLinkPost, magicLinkCallbackAuthMagicLinkCallbackPost, mailpitInboundWebhooksMailpitInboundPost, markReadAppInboxRecommendationsRecommendationIdReadPost, markUnreadAppInboxRecommendationsRecommendationIdUnreadPost, onboardingActivateAppOnboardingActivateGet, onboardingCompleteAppOnboardingCompletePost, onboardingExchangeTokenAppOnboardingExchangeTokenPost, type Options, orderStatsAppOrdersStatsGet, parseFiltersAppAccountsParseFiltersPost, parseTerritoryAppOnboardingParseTerritoryPost, parseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPost, parseValidateFileAppAccountsBatchUploadsParseValidateFilePost, parseValidateJsonAppAccountsBatchUploadsParseValidateJsonPost, parseValidateSuperuserBatchUploadsParseValidatePost, partnerInviteCreateAppOnboardingPartnerInviteCreatePost, partnerInviteInfoAppOnboardingPartnerInviteInfoGet, queryAccountsByDomainAppAccountsAccountsListDomainDomainPost, queryAccountsListAppAccountsAccountsListPost, queryAccountsListGroupedAppAccountsAccountsListGroupedPost, quickTrialCreateSuperuserCreateQuickPost, regenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePost, reportDataIssue, reprocessOrderAppOrdersOrderIdReprocessPost, rerunTriageAnalysisSuperuserRerunTriagePost, resendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPost, resetForgotPasswordAuthForgotPasswordPost, resetResetPasswordAuthResetPasswordPost, resetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPost, respondToAgentRunAppAgentRunsRunIdRespondPost, retryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPost, retryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPost, retryOrderAppOrdersOrderIdRetryPost, revokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDelete, rollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPost, saveDebriefAppDebriefSavePost, setPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPut, shareAccountsAppAccountsSharePost, shareAccountViaEmailAppAccountsShareAccountIdEmailPost, startBackfillInboxSuperuserBackfillInboxPost, startDebriefConversationAppDebriefDebriefIdConversationStartPost, startImpersonationSuperuserImpersonationStartPost, startNewDebriefConversationAppDebriefConversationStartPost, stopImpersonationSuperuserImpersonationStopPost, streamAgentRunAppAgentRunsRunIdStreamGet, submitTurnAppAccountsLeadDiscoveryTurnPost, syncCrmSuperuserOrganizationsOrganizationIdSyncCrmPost, syncMergeAccountsAppIntegrationsMergeSyncPost, trackAccountViewAppAccountsAccountsAccountIdViewPost, transcribeDebriefAppDebriefTranscribePost, transitionDealStageAppOrdersDealsDealIdStagePost, triggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPost, triggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPost, unassignAccountsAppAccountsAssignDelete, unsetPrimaryContactAppAccountsContactsAccountIdPrimaryDelete, updateBuyerProfileAppBuyerProfilesTagIdPatch, updateCompanyInfoAppOrganizationCompanyInfoPatch, updateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatch, updateEmailPreferences, updateInboundConfigAppOrganizationOrganizationsMeInboundConfigPut, updateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatch, updateOrderAppOrdersOrderIdPatch, updateOrganizationAppOrganizationOrganizationsOrgIdPatch, updateOrganizationSuperuserOrganizationsOrganizationIdPost, updateProductAppProductsProductIdPatch, updateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPut, updateTagAssociationsAppBuyerProfilesAssociationsPatch, updateUserSuperuserUsersUserIdPatch, usersCurrentUserAuthUsersMeGet, usersDeleteUserAuthUsersIdDelete, usersPatchCurrentUserAuthUsersMePatch, usersPatchUserAuthUsersIdPatch, usersUserAuthUsersIdGet, verifyRequestTokenAuthRequestVerifyTokenPost, verifyVerifyAuthVerifyPost } from '../sdk.gen';
import type { ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostData, ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostError, ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostResponse, AssignAccountsAppAccountsAssignPostData, AssignAccountsAppAccountsAssignPostError, AssignAccountsAppAccountsAssignPostResponse, AuthBearerLoginAuthBearerLoginPostData, AuthBearerLoginAuthBearerLoginPostError, AuthBearerLoginAuthBearerLoginPostResponse, AuthBearerLogoutAuthBearerLogoutPostData, AuthCookieLoginAuthLoginPostData, AuthCookieLoginAuthLoginPostError, AuthCookieLoginAuthLoginPostResponse, AuthCookieLogoutAuthLogoutPostData, AuthCookieLogoutAuthLogoutPostResponse, ChatAuthAppChatAuthGetData, ChatAuthAppChatAuthGetResponse, CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetData, CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetError, CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetResponse, CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostData, CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostError, CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostResponse, ClaimLeadsAppScoutClaimPostData, ClaimLeadsAppScoutClaimPostResponse, CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostData, CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostError, CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostResponse, CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostData, CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostError, CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostResponse, CreateAccountFromCompanyDataAppAccountsQuickCreatePostData, CreateAccountFromCompanyDataAppAccountsQuickCreatePostError, CreateAccountFromCompanyDataAppAccountsQuickCreatePostResponse, CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostData, CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostError, CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostResponse, CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostData, CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostError, CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostResponse, CreateBuyerProfileAppBuyerProfilesPostData, CreateBuyerProfileAppBuyerProfilesPostError, CreateBuyerProfileAppBuyerProfilesPostResponse, CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostData, CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostError, CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostResponse, CreateMarketResearchReportAppMarketResearchReportsPostData, CreateMarketResearchReportAppMarketResearchReportsPostError, CreateMarketResearchReportAppMarketResearchReportsPostResponse, CreateMemberAppOrganizationOrganizationsMembersPostData, CreateMemberAppOrganizationOrganizationsMembersPostError, CreateMemberAppOrganizationOrganizationsMembersPostResponse, CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostData, CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostError, CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostResponse, CreateNoteAppAccountsNotesAccountIdPostData, CreateNoteAppAccountsNotesAccountIdPostError, CreateNoteAppAccountsNotesAccountIdPostResponse, CreateOrganizationSuperuserCreatePostData, CreateOrganizationSuperuserCreatePostError, CreateOrganizationSuperuserCreatePostResponse, CreatePersonaAppOrganizationPersonasPostData, CreatePersonaAppOrganizationPersonasPostError, CreatePersonaAppOrganizationPersonasPostResponse, CreateProductAppProductsPostData, CreateProductAppProductsPostError, CreateProductAppProductsPostResponse, CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteData, CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteResponse, CustomExportDownloadAppAccountsExportCustomExportDownloadPostData, CustomExportDownloadAppAccountsExportCustomExportDownloadPostError, CustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetData, CustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetResponse, CustomExportGetTemplateAppAccountsExportCustomExportTemplateGetData, CustomExportGetTemplateAppAccountsExportCustomExportTemplateGetResponse, CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostData, CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostError, CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostResponse, CustomExportPreviewAppAccountsExportCustomExportPreviewPostData, CustomExportPreviewAppAccountsExportCustomExportPreviewPostError, CustomExportPreviewAppAccountsExportCustomExportPreviewPostResponse, CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutData, CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutError, CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutResponse, DeleteAccountsAppAccountsDeleteData, DeleteAccountsAppAccountsDeleteError, DeleteAccountsAppAccountsDeleteResponse, DeleteBuyerProfileAppBuyerProfilesTagIdDeleteData, DeleteBuyerProfileAppBuyerProfilesTagIdDeleteError, DeleteBuyerProfileAppBuyerProfilesTagIdDeleteResponse, DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteData, DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteError, DeleteFeedbackData, DeleteFeedbackError, DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteData, DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteError, DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteData, DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteError, DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteResponse, DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteData, DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteError, DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteResponse, DeleteOrdersAppOrdersDeleteData, DeleteOrdersAppOrdersDeleteError, DeleteOrdersAppOrdersDeleteResponse, DeletePersonaAppOrganizationPersonasPersonaIdDeleteData, DeletePersonaAppOrganizationPersonasPersonaIdDeleteError, DeleteProductAppProductsProductIdDeleteData, DeleteProductAppProductsProductIdDeleteError, DeleteProductAppProductsProductIdDeleteResponse, DemodaySignupAppDemodaySignupPostData, DemodaySignupAppDemodaySignupPostError, DemodaySignupAppDemodaySignupPostResponse, DevLoginDevLoginEmailPostData, DevLoginDevLoginEmailPostError, DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostData, DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostError, DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostResponse, DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostData, DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostError, DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostResponse, DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetData, DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetError, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostData, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostError, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostResponse, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostData, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostError, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostResponse, EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostData, EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostError, EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostResponse, EnrichByLinkedinUrlAppLinkedinEnrichPostData, EnrichByLinkedinUrlAppLinkedinEnrichPostError, EnrichByLinkedinUrlAppLinkedinEnrichPostResponse, EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostData, EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostError, EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostResponse, ExchangeTokenAppIntegrationsMergeExchangeTokenPostData, ExchangeTokenAppIntegrationsMergeExchangeTokenPostError, ExchangeTokenAppIntegrationsMergeExchangeTokenPostResponse, ExecuteBatchUploadAppAccountsBatchUploadsExecutePostData, ExecuteBatchUploadAppAccountsBatchUploadsExecutePostError, ExecuteBatchUploadAppAccountsBatchUploadsExecutePostResponse, ExecuteBatchUploadSuperuserBatchUploadsExecutePostData, ExecuteBatchUploadSuperuserBatchUploadsExecutePostError, ExecuteBatchUploadSuperuserBatchUploadsExecutePostResponse, ExportAccountsAppAccountsExportExportPostData, ExportAccountsAppAccountsExportExportPostError, ExportContactsAppAccountsExportContactsPostData, ExportContactsAppAccountsExportContactsPostError, ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostData, ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostError, ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostResponse, FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostData, FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostError, FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostResponse, GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostData, GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostError, GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostResponse, GenerateEmailAppAccountActionsEmailGenerationPostData, GenerateEmailAppAccountActionsEmailGenerationPostError, GenerateEmailAppAccountActionsEmailGenerationPostResponse, GenerateTamReportSuperuserTamReportsPostData, GenerateTamReportSuperuserTamReportsPostError, GenerateTamReportSuperuserTamReportsPostResponse, GetAccountContactsAppAccountsContactsAccountIdGetData, GetAccountContactsAppAccountsContactsAccountIdGetError, GetAccountContactsAppAccountsContactsAccountIdGetResponse, GetAccountContactsFullAppAccountsContactsAccountIdFullGetData, GetAccountContactsFullAppAccountsContactsAccountIdFullGetError, GetAccountContactsFullAppAccountsContactsAccountIdFullGetResponse, GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetData, GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetError, GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetResponse, GetAccountDetailsAppAccountsAccountsAccountIdGetData, GetAccountDetailsAppAccountsAccountsAccountIdGetError, GetAccountDetailsAppAccountsAccountsAccountIdGetResponse, GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostData, GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostError, GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostResponse, GetAccountHistoryAppAccountsHistoryAccountIdGetData, GetAccountHistoryAppAccountsHistoryAccountIdGetError, GetAccountHistoryAppAccountsHistoryAccountIdGetResponse, GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetData, GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetError, GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetResponse, GetAccountsHeatMapAppAccountsHeatMapsPostData, GetAccountsHeatMapAppAccountsHeatMapsPostError, GetAccountsHeatMapAppAccountsHeatMapsPostResponse, GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetData, GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetError, GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetResponse, GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetData, GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetError, GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetResponse, GetActivityLogAppAccountActionsActivityLogGetData, GetActivityLogAppAccountActionsActivityLogGetError, GetActivityLogAppAccountActionsActivityLogGetResponse, GetActivityStatsAppAccountActionsActivityStatsGetData, GetActivityStatsAppAccountActionsActivityStatsGetError, GetActivityStatsAppAccountActionsActivityStatsGetResponse, GetActivityTimelineAppAccountActionsActivityTimelineGetData, GetActivityTimelineAppAccountActionsActivityTimelineGetError, GetActivityTimelineAppAccountActionsActivityTimelineGetResponse, GetAgentRunAppAgentRunsRunIdGetData, GetAgentRunAppAgentRunsRunIdGetError, GetAgentRunAppAgentRunsRunIdGetResponse, GetAllOrganizationsSuperuserOrganizationsGetData, GetAllOrganizationsSuperuserOrganizationsGetResponse, GetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetData, GetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetResponse, GetBackfillInboxStatusSuperuserBackfillInboxStatusGetData, GetBackfillInboxStatusSuperuserBackfillInboxStatusGetError, GetBackfillInboxStatusSuperuserBackfillInboxStatusGetResponse, GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetData, GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetError, GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetResponse, GetCompanyInfoAppOrganizationCompanyInfoGetData, GetCompanyInfoAppOrganizationCompanyInfoGetResponse, GetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetData, GetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetResponse, GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetData, GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetError, GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetResponse, GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetData, GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetError, GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetResponse, GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetData, GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetError, GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetResponse, GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetData, GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetError, GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetResponse, GetCrmUsersAppIntegrationsMergeCrmUsersGetData, GetCrmUsersAppIntegrationsMergeCrmUsersGetResponse, GetDashboardAppScoutDashboardGetData, GetDashboardAppScoutDashboardGetResponse, GetDealEventsAppOrdersDealsDealIdEventsGetData, GetDealEventsAppOrdersDealsDealIdEventsGetError, GetDealEventsAppOrdersDealsDealIdEventsGetResponse, GetDebriefHistoryAppDebriefHistoryGetData, GetDebriefHistoryAppDebriefHistoryGetError, GetDebriefHistoryAppDebriefHistoryGetResponse, GetDistributorsAppOrganizationOrganizationsDistributorsGetData, GetDistributorsAppOrganizationOrganizationsDistributorsGetResponse, GetEmailPreferencesData, GetEmailPreferencesResponse, GetEnrichmentFreshnessSuperuserFreshnessGetData, GetEnrichmentFreshnessSuperuserFreshnessGetResponse, GetEnrichmentStatusSuperuserEnrichmentStatusGetData, GetEnrichmentStatusSuperuserEnrichmentStatusGetResponse, GetExportEmailsAppAccountsExportEmailsPostData, GetExportEmailsAppAccountsExportEmailsPostError, GetExportEmailsAppAccountsExportEmailsPostResponse, GetFeedbackData, GetFeedbackError, GetFeedbackResponse2, GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetData, GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetError, GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetResponse, GetImpersonationStatusSuperuserImpersonationCurrentGetData, GetImpersonationStatusSuperuserImpersonationCurrentGetResponse, GetInboundAddressAppOrdersInboundAddressGetData, GetInboundAddressAppOrdersInboundAddressGetResponse, GetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetData, GetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetResponse, GetIntegrationStatusAppIntegrationsMergeStatusGetData, GetIntegrationStatusAppIntegrationsMergeStatusGetResponse, GetMapPointsAppAccountsAccountsMapPointsPostData, GetMapPointsAppAccountsAccountsMapPointsPostError, GetMapPointsAppAccountsAccountsMapPointsPostResponse, GetMarketResearchReportAppMarketResearchReportsReportIdGetData, GetMarketResearchReportAppMarketResearchReportsReportIdGetError, GetMarketResearchReportAppMarketResearchReportsReportIdGetResponse, GetMarketResearchReportsAppMarketResearchReportsGetData, GetMarketResearchReportsAppMarketResearchReportsGetResponse, GetNewsfeedAppInboxNewsfeedGetData, GetNewsfeedAppInboxNewsfeedGetError, GetNewsfeedAppInboxNewsfeedGetResponse, GetOrderAppOrdersOrderIdGetData, GetOrderAppOrdersOrderIdGetError, GetOrderAppOrdersOrderIdGetResponse, GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetData, GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetError, GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetData, GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetError, GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetData, GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetError, GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetResponse, GetOrderPreviewAppOrdersOrderIdPreviewGetData, GetOrderPreviewAppOrdersOrderIdPreviewGetError, GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetData, GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetError, GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetResponse, GetOrganizationInfoAppOrganizationOrganizationsInfoGetData, GetOrganizationInfoAppOrganizationOrganizationsInfoGetResponse, GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetData, GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetError, GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetResponse, GetPartnersAppOnboardingPartnersGetData, GetPartnersAppOnboardingPartnersGetResponse, GetPersonasAppOrganizationPersonasGetData, GetPersonasAppOrganizationPersonasGetResponse, GetProductAppProductsProductIdGetData, GetProductAppProductsProductIdGetError, GetProductAppProductsProductIdGetResponse, GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetData, GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetError, GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetResponse, GetRecommendationCountAppInboxRecommendationsCountGetData, GetRecommendationCountAppInboxRecommendationsCountGetResponse, GetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetData, GetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetResponse, GetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetData, GetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetResponse, GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetData, GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetError, GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetResponse, GetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetData, GetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetResponse, GetTamReportAppTamReportsReportIdGetData, GetTamReportAppTamReportsReportIdGetError, GetTamReportAppTamReportsReportIdGetResponse, GetTamReportsAppTamReportsGetData, GetTamReportsAppTamReportsGetResponse, GetUserSuperuserUsersUserIdGetData, GetUserSuperuserUsersUserIdGetError, GetUserSuperuserUsersUserIdGetResponse, GetVectorTileAppAccountsAccountsTilesZxyPbfGetData, GetVectorTileAppAccountsAccountsTilesZxyPbfGetError, HealthCheckHealthGetData, HealthCheckHealthGetResponse, HealthDetailedHealthDetailedGetData, HealthDetailedHealthDetailedGetResponse, InboundEmailWebhooksInboundEmailPostData, InboundEmailWebhooksInboundEmailPostResponse, JoinAppDemodayJoinPostData, JoinAppDemodayJoinPostError, JoinAppDemodayJoinPostResponse, JoinCompleteAppOnboardingJoinCompletePostData, JoinCompleteAppOnboardingJoinCompletePostError, JoinInfoAppOnboardingJoinInfoGetData, JoinInfoAppOnboardingJoinInfoGetError, JoinInfoAppOnboardingJoinInfoGetResponse, LaunchAgentRunAppAgentRunsLaunchPostData, LaunchAgentRunAppAgentRunsLaunchPostError, LaunchAgentRunAppAgentRunsLaunchPostResponse, LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostData, LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostError, ListAgentRunsAppAgentRunsGetData, ListAgentRunsAppAgentRunsGetError, ListAgentRunsAppAgentRunsGetResponse, ListBuyerProfilesAppBuyerProfilesGetData, ListBuyerProfilesAppBuyerProfilesGetResponse, ListDealsAppOrdersDealsGetData, ListDealsAppOrdersDealsGetError, ListDealsAppOrdersDealsGetResponse, ListDemodayOrgsAppDemodayOrgsGetData, ListDemodayOrgsAppDemodayOrgsGetResponse, ListDevUsersDevUsersGetData, ListDevUsersDevUsersGetResponse, ListImpersonationSessionsSuperuserImpersonationSessionsGetData, ListImpersonationSessionsSuperuserImpersonationSessionsGetResponse, ListNotesAppAccountsNotesAccountIdGetData, ListNotesAppAccountsNotesAccountIdGetError, ListNotesAppAccountsNotesAccountIdGetResponse, ListOrdersAppOrdersGetData, ListOrdersAppOrdersGetError, ListOrdersAppOrdersGetResponse, ListProductsAppProductsGetData, ListProductsAppProductsGetError, ListProductsAppProductsGetResponse, ListRecommendationsAppInboxRecommendationsGetData, ListRecommendationsAppInboxRecommendationsGetError, ListRecommendationsAppInboxRecommendationsGetResponse, ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetData, ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetError, ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetResponse, LogActivityActionsAppAccountActionsActivityActionsPostData, LogActivityActionsAppAccountActionsActivityActionsPostError, LogActivityActionsAppAccountActionsActivityActionsPostResponse, MagicLinkAuthMagicLinkPostData, MagicLinkAuthMagicLinkPostError, MagicLinkCallbackAuthMagicLinkCallbackPostData, MagicLinkCallbackAuthMagicLinkCallbackPostError, MailpitInboundWebhooksMailpitInboundPostData, MailpitInboundWebhooksMailpitInboundPostResponse, MarkReadAppInboxRecommendationsRecommendationIdReadPostData, MarkReadAppInboxRecommendationsRecommendationIdReadPostError, MarkReadAppInboxRecommendationsRecommendationIdReadPostResponse, MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostData, MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostError, MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostResponse, OnboardingActivateAppOnboardingActivateGetData, OnboardingActivateAppOnboardingActivateGetError, OnboardingCompleteAppOnboardingCompletePostData, OnboardingCompleteAppOnboardingCompletePostError, OnboardingCompleteAppOnboardingCompletePostResponse, OnboardingExchangeTokenAppOnboardingExchangeTokenPostData, OnboardingExchangeTokenAppOnboardingExchangeTokenPostError, OrderStatsAppOrdersStatsGetData, OrderStatsAppOrdersStatsGetResponse, ParseFiltersAppAccountsParseFiltersPostData, ParseFiltersAppAccountsParseFiltersPostError, ParseFiltersAppAccountsParseFiltersPostResponse, ParseTerritoryAppOnboardingParseTerritoryPostData, ParseTerritoryAppOnboardingParseTerritoryPostError, ParseTerritoryAppOnboardingParseTerritoryPostResponse, ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostData, ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostError, ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostResponse, ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostData, ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostError, ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostResponse, ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostData, ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostError, ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostResponse, ParseValidateSuperuserBatchUploadsParseValidatePostData, ParseValidateSuperuserBatchUploadsParseValidatePostError, ParseValidateSuperuserBatchUploadsParseValidatePostResponse, PartnerInviteCreateAppOnboardingPartnerInviteCreatePostData, PartnerInviteCreateAppOnboardingPartnerInviteCreatePostError, PartnerInviteCreateAppOnboardingPartnerInviteCreatePostResponse, PartnerInviteInfoAppOnboardingPartnerInviteInfoGetData, PartnerInviteInfoAppOnboardingPartnerInviteInfoGetError, PartnerInviteInfoAppOnboardingPartnerInviteInfoGetResponse, QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostData, QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostError, QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostResponse, QueryAccountsListAppAccountsAccountsListPostData, QueryAccountsListAppAccountsAccountsListPostError, QueryAccountsListAppAccountsAccountsListPostResponse, QueryAccountsListGroupedAppAccountsAccountsListGroupedPostData, QueryAccountsListGroupedAppAccountsAccountsListGroupedPostError, QueryAccountsListGroupedAppAccountsAccountsListGroupedPostResponse, QuickTrialCreateSuperuserCreateQuickPostData, QuickTrialCreateSuperuserCreateQuickPostError, QuickTrialCreateSuperuserCreateQuickPostResponse, RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostData, RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostError, RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostResponse, ReportDataIssueData, ReportDataIssueError, ReportDataIssueResponse2, ReprocessOrderAppOrdersOrderIdReprocessPostData, ReprocessOrderAppOrdersOrderIdReprocessPostError, ReprocessOrderAppOrdersOrderIdReprocessPostResponse, RerunTriageAnalysisSuperuserRerunTriagePostData, RerunTriageAnalysisSuperuserRerunTriagePostError, RerunTriageAnalysisSuperuserRerunTriagePostResponse, ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostData, ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostError, ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostResponse, ResetForgotPasswordAuthForgotPasswordPostData, ResetForgotPasswordAuthForgotPasswordPostError, ResetResetPasswordAuthResetPasswordPostData, ResetResetPasswordAuthResetPasswordPostError, ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostData, ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostError, ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostResponse, RespondToAgentRunAppAgentRunsRunIdRespondPostData, RespondToAgentRunAppAgentRunsRunIdRespondPostError, RespondToAgentRunAppAgentRunsRunIdRespondPostResponse, RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostData, RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostError, RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostResponse, RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostData, RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostError, RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostResponse, RetryOrderAppOrdersOrderIdRetryPostData, RetryOrderAppOrdersOrderIdRetryPostError, RetryOrderAppOrdersOrderIdRetryPostResponse, RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteData, RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteError, RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostData, RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostError, RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostResponse, SaveDebriefAppDebriefSavePostData, SaveDebriefAppDebriefSavePostError, SaveDebriefAppDebriefSavePostResponse, SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutData, SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutError, SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutResponse, ShareAccountsAppAccountsSharePostData, ShareAccountsAppAccountsSharePostError, ShareAccountsAppAccountsSharePostResponse, ShareAccountViaEmailAppAccountsShareAccountIdEmailPostData, ShareAccountViaEmailAppAccountsShareAccountIdEmailPostError, ShareAccountViaEmailAppAccountsShareAccountIdEmailPostResponse, StartBackfillInboxSuperuserBackfillInboxPostData, StartBackfillInboxSuperuserBackfillInboxPostError, StartBackfillInboxSuperuserBackfillInboxPostResponse, StartDebriefConversationAppDebriefDebriefIdConversationStartPostData, StartDebriefConversationAppDebriefDebriefIdConversationStartPostError, StartDebriefConversationAppDebriefDebriefIdConversationStartPostResponse, StartImpersonationSuperuserImpersonationStartPostData, StartImpersonationSuperuserImpersonationStartPostError, StartNewDebriefConversationAppDebriefConversationStartPostData, StartNewDebriefConversationAppDebriefConversationStartPostResponse, StopImpersonationSuperuserImpersonationStopPostData, StreamAgentRunAppAgentRunsRunIdStreamGetData, StreamAgentRunAppAgentRunsRunIdStreamGetError, SubmitTurnAppAccountsLeadDiscoveryTurnPostData, SubmitTurnAppAccountsLeadDiscoveryTurnPostError, SubmitTurnAppAccountsLeadDiscoveryTurnPostResponse, SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostData, SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostError, SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostResponse, SyncMergeAccountsAppIntegrationsMergeSyncPostData, SyncMergeAccountsAppIntegrationsMergeSyncPostError, SyncMergeAccountsAppIntegrationsMergeSyncPostResponse, TrackAccountViewAppAccountsAccountsAccountIdViewPostData, TrackAccountViewAppAccountsAccountsAccountIdViewPostError, TranscribeDebriefAppDebriefTranscribePostData, TranscribeDebriefAppDebriefTranscribePostError, TranscribeDebriefAppDebriefTranscribePostResponse, TransitionDealStageAppOrdersDealsDealIdStagePostData, TransitionDealStageAppOrdersDealsDealIdStagePostError, TransitionDealStageAppOrdersDealsDealIdStagePostResponse, TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostData, TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostError, TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostResponse, TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostData, TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostError, TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostResponse, UnassignAccountsAppAccountsAssignDeleteData, UnassignAccountsAppAccountsAssignDeleteError, UnassignAccountsAppAccountsAssignDeleteResponse, UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteData, UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteError, UpdateBuyerProfileAppBuyerProfilesTagIdPatchData, UpdateBuyerProfileAppBuyerProfilesTagIdPatchError, UpdateBuyerProfileAppBuyerProfilesTagIdPatchResponse, UpdateCompanyInfoAppOrganizationCompanyInfoPatchData, UpdateCompanyInfoAppOrganizationCompanyInfoPatchError, UpdateCompanyInfoAppOrganizationCompanyInfoPatchResponse, UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchData, UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchError, UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchResponse, UpdateEmailPreferencesData, UpdateEmailPreferencesError, UpdateEmailPreferencesResponse, UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutData, UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutError, UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutResponse, UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchData, UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchError, UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchResponse, UpdateOrderAppOrdersOrderIdPatchData, UpdateOrderAppOrdersOrderIdPatchError, UpdateOrderAppOrdersOrderIdPatchResponse, UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchData, UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchError, UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchResponse, UpdateOrganizationSuperuserOrganizationsOrganizationIdPostData, UpdateOrganizationSuperuserOrganizationsOrganizationIdPostError, UpdateOrganizationSuperuserOrganizationsOrganizationIdPostResponse, UpdateProductAppProductsProductIdPatchData, UpdateProductAppProductsProductIdPatchError, UpdateProductAppProductsProductIdPatchResponse, UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutData, UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutError, UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutResponse, UpdateTagAssociationsAppBuyerProfilesAssociationsPatchData, UpdateTagAssociationsAppBuyerProfilesAssociationsPatchError, UpdateTagAssociationsAppBuyerProfilesAssociationsPatchResponse, UpdateUserSuperuserUsersUserIdPatchData, UpdateUserSuperuserUsersUserIdPatchError, UpdateUserSuperuserUsersUserIdPatchResponse, UsersCurrentUserAuthUsersMeGetData, UsersCurrentUserAuthUsersMeGetResponse, UsersDeleteUserAuthUsersIdDeleteData, UsersDeleteUserAuthUsersIdDeleteError, UsersDeleteUserAuthUsersIdDeleteResponse, UsersPatchCurrentUserAuthUsersMePatchData, UsersPatchCurrentUserAuthUsersMePatchError, UsersPatchCurrentUserAuthUsersMePatchResponse, UsersPatchUserAuthUsersIdPatchData, UsersPatchUserAuthUsersIdPatchError, UsersPatchUserAuthUsersIdPatchResponse, UsersUserAuthUsersIdGetData, UsersUserAuthUsersIdGetError, UsersUserAuthUsersIdGetResponse, VerifyRequestTokenAuthRequestVerifyTokenPostData, VerifyRequestTokenAuthRequestVerifyTokenPostError, VerifyVerifyAuthVerifyPostData, VerifyVerifyAuthVerifyPostError, VerifyVerifyAuthVerifyPostResponse } from '../types.gen';

/**
 * Query Accounts List
 *
 * Query accounts using Postgres full-text search.
 *
 * Testing note: Integration tests can only verify request/response shape since we
 * mock the search service at the service level. The actual filtering, visibility, and pagination
 * logic lives in query_builder.py and should be unit tested there.
 *
 * Returns:
 * Page[AccountListItem] instance.
 */
export const queryAccountsListAppAccountsAccountsListPostMutation = (options?: Partial<Options<QueryAccountsListAppAccountsAccountsListPostData>>): UseMutationOptions<QueryAccountsListAppAccountsAccountsListPostResponse, QueryAccountsListAppAccountsAccountsListPostError, Options<QueryAccountsListAppAccountsAccountsListPostData>> => {
    const mutationOptions: UseMutationOptions<QueryAccountsListAppAccountsAccountsListPostResponse, QueryAccountsListAppAccountsAccountsListPostError, Options<QueryAccountsListAppAccountsAccountsListPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await queryAccountsListAppAccountsAccountsListPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Query Accounts List Grouped
 *
 * Query accounts grouped by website domain with aggregated stats.
 *
 * Returns domain groups paginated by group count, sorted by the requested
 * sort column applied to each group's aggregate (default: best fit score).
 * Each group includes: domain, logo, account count, best/avg fit score,
 * participant count, and location list.
 *
 * Returns:
 * GroupedAccountsPage with groups and pagination metadata.
 */
export const queryAccountsListGroupedAppAccountsAccountsListGroupedPostMutation = (options?: Partial<Options<QueryAccountsListGroupedAppAccountsAccountsListGroupedPostData>>): UseMutationOptions<QueryAccountsListGroupedAppAccountsAccountsListGroupedPostResponse, QueryAccountsListGroupedAppAccountsAccountsListGroupedPostError, Options<QueryAccountsListGroupedAppAccountsAccountsListGroupedPostData>> => {
    const mutationOptions: UseMutationOptions<QueryAccountsListGroupedAppAccountsAccountsListGroupedPostResponse, QueryAccountsListGroupedAppAccountsAccountsListGroupedPostError, Options<QueryAccountsListGroupedAppAccountsAccountsListGroupedPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await queryAccountsListGroupedAppAccountsAccountsListGroupedPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Query Accounts By Domain
 *
 * Fetch all accounts for a specific website domain.
 *
 * Used when expanding a group row in the grouped accounts view.
 * Respects the same filters as the grouped list, returning only
 * matching accounts within the domain.
 *
 * Returns:
 * List of AccountListItem for the domain.
 */
export const queryAccountsByDomainAppAccountsAccountsListDomainDomainPostMutation = (options?: Partial<Options<QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostData>>): UseMutationOptions<QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostResponse, QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostError, Options<QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostData>> => {
    const mutationOptions: UseMutationOptions<QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostResponse, QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostError, Options<QueryAccountsByDomainAppAccountsAccountsListDomainDomainPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await queryAccountsByDomainAppAccountsAccountsListDomainDomainPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getAccountDetailsAppAccountsAccountsAccountIdGetQueryKey = (options: Options<GetAccountDetailsAppAccountsAccountsAccountIdGetData>) => createQueryKey('getAccountDetailsAppAccountsAccountsAccountIdGet', options);

/**
 * Get Account Details
 *
 * Get comprehensive account details with optional enrichment data.
 *
 * This endpoint:
 * 1. Retrieves complete account and company information
 * 2. Uses SQLAlchemy for efficient data fetching
 * 3. Enforces organization-level access control
 *
 * Returns:
 * AccountDetailsResponse instance.
 *
 * Raises:
 * HTTPException: If account not found (404).
 */
export const getAccountDetailsAppAccountsAccountsAccountIdGetOptions = (options: Options<GetAccountDetailsAppAccountsAccountsAccountIdGetData>) => queryOptions<GetAccountDetailsAppAccountsAccountsAccountIdGetResponse, GetAccountDetailsAppAccountsAccountsAccountIdGetError, GetAccountDetailsAppAccountsAccountsAccountIdGetResponse, ReturnType<typeof getAccountDetailsAppAccountsAccountsAccountIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccountDetailsAppAccountsAccountsAccountIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccountDetailsAppAccountsAccountsAccountIdGetQueryKey(options)
});

/**
 * Get Map Points
 *
 * Get map points for accounts as GeoJSON FeatureCollection.
 *
 * Returns lightweight point data for the accounts visible in the requested
 * viewport. Only includes accounts with coordinates. Shares its visibility
 * and filter definition with the vector tile endpoint so the pins on the map
 * and the accounts in the list can never disagree (ENG-3632).
 *
 * Returns:
 * MapPointsResponse with GeoJSON features.
 */
export const getMapPointsAppAccountsAccountsMapPointsPostMutation = (options?: Partial<Options<GetMapPointsAppAccountsAccountsMapPointsPostData>>): UseMutationOptions<GetMapPointsAppAccountsAccountsMapPointsPostResponse, GetMapPointsAppAccountsAccountsMapPointsPostError, Options<GetMapPointsAppAccountsAccountsMapPointsPostData>> => {
    const mutationOptions: UseMutationOptions<GetMapPointsAppAccountsAccountsMapPointsPostResponse, GetMapPointsAppAccountsAccountsMapPointsPostError, Options<GetMapPointsAppAccountsAccountsMapPointsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getMapPointsAppAccountsAccountsMapPointsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetQueryKey = (options: Options<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetData>) => createQueryKey('getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGet', options);

/**
 * Get Other Locations
 *
 * Get paginated other locations for an account.
 *
 * Returns:
 * OtherLocationsResponse with paginated locations and total count.
 */
export const getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetOptions = (options: Options<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetData>) => queryOptions<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetResponse, GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetError, GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetResponse, ReturnType<typeof getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetInfiniteQueryKey = (options: Options<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetData>): QueryKey<Options<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetData>> => createQueryKey('getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGet', options, true);

/**
 * Get Other Locations
 *
 * Get paginated other locations for an account.
 *
 * Returns:
 * OtherLocationsResponse with paginated locations and total count.
 */
export const getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetInfiniteOptions = (options: Options<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetData>) => {
    const opts = infiniteQueryOptions<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetResponse, GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetError, InfiniteData<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetResponse>, QueryKey<Options<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetData>>, number | Pick<QueryKey<Options<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOtherLocationsAppAccountsAccountsAccountIdOtherLocationsGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetQueryKey = (options: Options<GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetData>) => createQueryKey('getSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGet', options);

/**
 * Get Sibling Locations
 *
 * Get map points for sibling locations (same domain OR same explorium_id).
 *
 * Finds all accounts that share the same website_domain OR belong to companies
 * with the same explorium_business_id as this account's company.
 *
 * Returns:
 * MapPointsResponse with GeoJSON features.
 *
 * Raises:
 * HTTPException: If account not found (404) or forbidden (403).
 */
export const getSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetOptions = (options: Options<GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetData>) => queryOptions<GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetResponse, GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetError, GetSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetResponse, ReturnType<typeof getSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSiblingLocationsAppAccountsAccountsAccountIdSiblingLocationsGetQueryKey(options)
});

export const getCrmContactsAppAccountsAccountsAccountIdCrmContactsGetQueryKey = (options: Options<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetData>) => createQueryKey('getCrmContactsAppAccountsAccountsAccountIdCrmContactsGet', options);

/**
 * Get Crm Contacts
 *
 * Get CRM contacts for an account.
 *
 * Returns paginated CRM contacts linked via the account's CRM account.
 *
 * Returns:
 * Page[CrmContactDetails] with contacts from the linked CRM account.
 *
 * Raises:
 * HTTPException: If not authorized (403).
 */
export const getCrmContactsAppAccountsAccountsAccountIdCrmContactsGetOptions = (options: Options<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetData>) => queryOptions<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetResponse, GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetError, GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetResponse, ReturnType<typeof getCrmContactsAppAccountsAccountsAccountIdCrmContactsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCrmContactsAppAccountsAccountsAccountIdCrmContactsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCrmContactsAppAccountsAccountsAccountIdCrmContactsGetQueryKey(options)
});

export const getCrmContactsAppAccountsAccountsAccountIdCrmContactsGetInfiniteQueryKey = (options: Options<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetData>): QueryKey<Options<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetData>> => createQueryKey('getCrmContactsAppAccountsAccountsAccountIdCrmContactsGet', options, true);

/**
 * Get Crm Contacts
 *
 * Get CRM contacts for an account.
 *
 * Returns paginated CRM contacts linked via the account's CRM account.
 *
 * Returns:
 * Page[CrmContactDetails] with contacts from the linked CRM account.
 *
 * Raises:
 * HTTPException: If not authorized (403).
 */
export const getCrmContactsAppAccountsAccountsAccountIdCrmContactsGetInfiniteOptions = (options: Options<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetData>) => {
    const opts = infiniteQueryOptions<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetResponse, GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetError, InfiniteData<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetResponse>, QueryKey<Options<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetData>>, number | Pick<QueryKey<Options<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCrmContactsAppAccountsAccountsAccountIdCrmContactsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getCrmContactsAppAccountsAccountsAccountIdCrmContactsGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCrmContactsAppAccountsAccountsAccountIdCrmContactsGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetQueryKey = (options: Options<GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetData>) => createQueryKey('getCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGet', options);

/**
 * Get Crm Accounts
 *
 * Get linked CRM accounts for the View in CRM dialog.
 *
 * Finds all CrmAccounts in the same org + integration as the account's
 * linked CRM account, so the user can deep-link into the CRM.
 *
 * Returns:
 * CrmAccountsResponse with locations and CRM integration info.
 *
 * Raises:
 * HTTPException: If not authorized (403) or account not found (404).
 */
export const getCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetOptions = (options: Options<GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetData>) => queryOptions<GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetResponse, GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetError, GetCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetResponse, ReturnType<typeof getCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCrmAccountsAppAccountsAccountsAccountIdCrmAccountsGetQueryKey(options)
});

/**
 * Unassign Accounts
 *
 * Remove specific users from account assignments.
 *
 * Supports two modes:
 * 1. Remove from specific accounts by providing accountIds
 * 2. Bulk remove by providing filters (removes from all accounts matching filters)
 *
 * Returns:
 * AssignAccountsResponse with count of removed assignments.
 *
 * Raises:
 * HTTPException: If permission denied (400).
 */
export const unassignAccountsAppAccountsAssignDeleteMutation = (options?: Partial<Options<UnassignAccountsAppAccountsAssignDeleteData>>): UseMutationOptions<UnassignAccountsAppAccountsAssignDeleteResponse, UnassignAccountsAppAccountsAssignDeleteError, Options<UnassignAccountsAppAccountsAssignDeleteData>> => {
    const mutationOptions: UseMutationOptions<UnassignAccountsAppAccountsAssignDeleteResponse, UnassignAccountsAppAccountsAssignDeleteError, Options<UnassignAccountsAppAccountsAssignDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unassignAccountsAppAccountsAssignDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign Accounts
 *
 * Assign accounts to one or more users (deal participants).
 *
 * Supports two modes:
 * 1. Assign specific accounts by providing accountIds
 * 2. Bulk assign by providing filters (assigns all accounts matching filters)
 *
 * Pass either target_user_id (single) or target_user_ids (multi).
 * When assigning to a user in a distributor organization, set auto_share=True
 * to automatically share unshared accounts with that org before assignment.
 *
 * Returns:
 * AssignAccountsResponse instance.
 *
 * Raises:
 * HTTPException: If an error occurs during assignment (400) or target user not found (404).
 */
export const assignAccountsAppAccountsAssignPostMutation = (options?: Partial<Options<AssignAccountsAppAccountsAssignPostData>>): UseMutationOptions<AssignAccountsAppAccountsAssignPostResponse, AssignAccountsAppAccountsAssignPostError, Options<AssignAccountsAppAccountsAssignPostData>> => {
    const mutationOptions: UseMutationOptions<AssignAccountsAppAccountsAssignPostResponse, AssignAccountsAppAccountsAssignPostError, Options<AssignAccountsAppAccountsAssignPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignAccountsAppAccountsAssignPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAccountHistoryAppAccountsHistoryAccountIdGetQueryKey = (options: Options<GetAccountHistoryAppAccountsHistoryAccountIdGetData>) => createQueryKey('getAccountHistoryAppAccountsHistoryAccountIdGet', options);

/**
 * Get Account History
 *
 * Get account history including company events and account actions.
 *
 * This endpoint:
 * 1. Retrieves account with company and business_id in one query
 * 2. Fetches company events and account actions with pagination
 * 3. Uses SQLAlchemy for efficient batched queries
 * 4. Enforces organization-level access control
 *
 * Args:
 * account_id: The ID of the account
 * db: The database session
 * current_user: The current user
 * permissions_service: The permissions service for access control
 * events_limit: Max events to return (1-500, default 100)
 * actions_limit: Max actions to return (1-500, default 100)
 *
 * Returns:
 * AccountHistoryResponse with company events and account actions
 *
 * Raises:
 * HTTPException: If account not found or access denied.
 */
export const getAccountHistoryAppAccountsHistoryAccountIdGetOptions = (options: Options<GetAccountHistoryAppAccountsHistoryAccountIdGetData>) => queryOptions<GetAccountHistoryAppAccountsHistoryAccountIdGetResponse, GetAccountHistoryAppAccountsHistoryAccountIdGetError, GetAccountHistoryAppAccountsHistoryAccountIdGetResponse, ReturnType<typeof getAccountHistoryAppAccountsHistoryAccountIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccountHistoryAppAccountsHistoryAccountIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccountHistoryAppAccountsHistoryAccountIdGetQueryKey(options)
});

/**
 * Parse Validate File
 *
 * Parse and validate a CSV or Excel file upload.
 *
 * Returns:
 * ParseValidateResponse with validation results.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const parseValidateFileAppAccountsBatchUploadsParseValidateFilePostMutation = (options?: Partial<Options<ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostData>>): UseMutationOptions<ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostResponse, ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostError, Options<ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostData>> => {
    const mutationOptions: UseMutationOptions<ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostResponse, ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostError, Options<ParseValidateFileAppAccountsBatchUploadsParseValidateFilePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parseValidateFileAppAccountsBatchUploadsParseValidateFilePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Parse Validate Csv Text
 *
 * Parse and validate pasted CSV text.
 *
 * Returns:
 * ParseValidateResponse with validation results.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const parseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostMutation = (options?: Partial<Options<ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostData>>): UseMutationOptions<ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostResponse, ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostError, Options<ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostData>> => {
    const mutationOptions: UseMutationOptions<ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostResponse, ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostError, Options<ParseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parseValidateCsvTextAppAccountsBatchUploadsParseValidateCsvTextPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Parse Validate Json
 *
 * Parse and validate JSON company data from form entry.
 *
 * Returns:
 * ParseValidateResponse with validation results.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const parseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostMutation = (options?: Partial<Options<ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostData>>): UseMutationOptions<ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostResponse, ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostError, Options<ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostData>> => {
    const mutationOptions: UseMutationOptions<ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostResponse, ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostError, Options<ParseValidateJsonAppAccountsBatchUploadsParseValidateJsonPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parseValidateJsonAppAccountsBatchUploadsParseValidateJsonPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Execute Batch Upload
 *
 * Execute the batch upload by creating batch upload, companies and accounts.
 *
 * This is the second step after parse-validate.
 * Processes companies in chunks to avoid large transactions.
 *
 * Args:
 * request: ExecuteRequest containing:
 * - new_leads: List of new leads from parse-validate
 * - matches_with_existing_companies: List of matches with existing companies from parse-validate
 * - duplicate_with_existing_accounts: List of duplicates with existing accounts from parse-validate
 * - tags: Optional list of tag assignments with:
 * - company_index: Index in companies array (row_index in first three arguments)
 * - tag_id: Buyer profile ID to assign
 * - batch_upload_data: Metadata for batch upload record
 * - validation_token: Opaque token returned by parse-validate for this payload
 * session: AsyncSession for transactional operations
 * current_user: Authenticated user from JWT token (must match context.user_id)
 * permissions_service: Permission service for authorization checks
 * temporal: Temporal client for starting enrichment workflows
 * redis: Stores short-lived validation tokens from parse-validate
 *
 * Returns:
 * ExecuteResponse with:
 * - stats: Processing statistics:
 * - accounts_processed: Total accounts created
 * - new_accounts: Newly created accounts
 * - new_companies_created: Companies added to database
 * - existing_companies_found: Companies already in database
 * - companies_with_errors: Invalid companies skipped
 * - accounts: List of created account records with:
 * - id: Account UUID
 * - account_name: Name of the account
 * - company_id: Associated company UUID
 * - tag_assignment: If tags provided, contains:
 * - assigned: Number of tag associations created
 * - accounts: Number of accounts tagged
 * - tags: Number of unique tags used
 * - message: Human-readable success message
 *
 * Raises:
 * HTTPException: If permission denied (403), organization not found, or validation token invalid.
 */
export const executeBatchUploadAppAccountsBatchUploadsExecutePostMutation = (options?: Partial<Options<ExecuteBatchUploadAppAccountsBatchUploadsExecutePostData>>): UseMutationOptions<ExecuteBatchUploadAppAccountsBatchUploadsExecutePostResponse, ExecuteBatchUploadAppAccountsBatchUploadsExecutePostError, Options<ExecuteBatchUploadAppAccountsBatchUploadsExecutePostData>> => {
    const mutationOptions: UseMutationOptions<ExecuteBatchUploadAppAccountsBatchUploadsExecutePostResponse, ExecuteBatchUploadAppAccountsBatchUploadsExecutePostError, Options<ExecuteBatchUploadAppAccountsBatchUploadsExecutePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await executeBatchUploadAppAccountsBatchUploadsExecutePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Account From Company Data
 *
 * Create an account from company data (name/website/address).
 *
 * This endpoint:
 * 1. Matches to existing company by (domain, name, address) or creates new
 * 2. Creates an account linked to that company (or returns existing)
 * 3. All operations happen atomically in a single database transaction
 *
 * Returns:
 * tuple[AccountModel, str] - account and status message.
 *
 * Raises:
 * HTTPException: If organization not found.
 */
export const createAccountFromCompanyDataAppAccountsQuickCreatePostMutation = (options?: Partial<Options<CreateAccountFromCompanyDataAppAccountsQuickCreatePostData>>): UseMutationOptions<CreateAccountFromCompanyDataAppAccountsQuickCreatePostResponse, CreateAccountFromCompanyDataAppAccountsQuickCreatePostError, Options<CreateAccountFromCompanyDataAppAccountsQuickCreatePostData>> => {
    const mutationOptions: UseMutationOptions<CreateAccountFromCompanyDataAppAccountsQuickCreatePostResponse, CreateAccountFromCompanyDataAppAccountsQuickCreatePostError, Options<CreateAccountFromCompanyDataAppAccountsQuickCreatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAccountFromCompanyDataAppAccountsQuickCreatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Account From Company Id
 *
 * Create an account from an existing company ID.
 *
 * This endpoint:
 * 1. Verifies the company exists
 * 2. Checks if account already exists for this company in the org
 * 3. Creates account if needed, or returns existing
 * 4. Triggers enrichment workflow
 *
 * Returns:
 * tuple[AccountModel, str] - account and status message.
 *
 * Raises:
 * HTTPException: If organization not found or company not found.
 */
export const createAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostMutation = (options?: Partial<Options<CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostData>>): UseMutationOptions<CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostResponse, CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostError, Options<CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostData>> => {
    const mutationOptions: UseMutationOptions<CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostResponse, CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostError, Options<CreateAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAccountFromCompanyIdAppAccountsQuickCreateFromCompanyCompanyIdPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Account From Supplier
 *
 * Create an account from supplier lookup data.
 *
 * This endpoint mirrors the company-data quick-create flow but records
 * the addition as a supplier add (LeadSource.SUPPLIERS) instead of a
 * competitor add, and tracks which account's supplier lookup triggered it.
 *
 * Returns:
 * tuple[AccountModel | None, str] - account and status message.
 *
 * Raises:
 * HTTPException: If organization not found.
 */
export const createAccountFromSupplierAppAccountsQuickCreateFromSupplierPostMutation = (options?: Partial<Options<CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostData>>): UseMutationOptions<CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostResponse, CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostError, Options<CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostData>> => {
    const mutationOptions: UseMutationOptions<CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostResponse, CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostError, Options<CreateAccountFromSupplierAppAccountsQuickCreateFromSupplierPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAccountFromSupplierAppAccountsQuickCreateFromSupplierPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit Turn
 *
 * Submit a user message to a conversation (existing or new).
 *
 * Returns once Temporal has durably accepted the message — typically
 * within a few hundred ms. The browser then polls
 * ``GET /conversations/{id}/state`` for the agent's reply.
 *
 * Returns:
 * :class:`TurnAcceptedResponse` with the conversation id (newly
 * allocated for fresh conversations, echoed back for refinements).
 *
 * Raises:
 * HTTPException: 400 if no organization or empty ``userMessage``;
 * 403 if the caller lacks ``can_import_accounts`` or the
 * ``conversationId`` doesn't belong to the caller's org;
 * 404 if a supplied ``conversationId`` no longer exists;
 * 409 if the validator rejected the update (conversation
 * ended or too many pending turns); 503 on transient Temporal update
 * RPC failures; 500 on other Temporal failures or uuid4 collision.
 */
export const submitTurnAppAccountsLeadDiscoveryTurnPostMutation = (options?: Partial<Options<SubmitTurnAppAccountsLeadDiscoveryTurnPostData>>): UseMutationOptions<SubmitTurnAppAccountsLeadDiscoveryTurnPostResponse, SubmitTurnAppAccountsLeadDiscoveryTurnPostError, Options<SubmitTurnAppAccountsLeadDiscoveryTurnPostData>> => {
    const mutationOptions: UseMutationOptions<SubmitTurnAppAccountsLeadDiscoveryTurnPostResponse, SubmitTurnAppAccountsLeadDiscoveryTurnPostError, Options<SubmitTurnAppAccountsLeadDiscoveryTurnPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitTurnAppAccountsLeadDiscoveryTurnPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetQueryKey = (options: Options<GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetData>) => createQueryKey('getConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGet', options);

/**
 * Get Conversation State
 *
 * Return the current transcript, payload, and processing flag.
 *
 * The browser polls this endpoint on a smart interval (1 s while a turn
 * is in flight, 10 s while idle) and stops polling once ``ended`` is true.
 *
 * Returns:
 * Current :class:`ChatState` snapshot from the workflow's
 * ``get_chat_state`` query.
 *
 * Raises:
 * HTTPException: 400 if no organization; 403 if the caller lacks
 * ``can_import_accounts`` or the ``conversationId`` doesn't
 * belong to the caller's org; 404 if the workflow has been
 * garbage-collected; 500 on any other Temporal failure.
 * RPCError: re-raised on non-NOT_FOUND Temporal RPC errors so FastAPI
 * translates them to 500.
 */
export const getConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetOptions = (options: Options<GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetData>) => queryOptions<GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetResponse, GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetError, GetConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetResponse, ReturnType<typeof getConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConversationStateAppAccountsLeadDiscoveryConversationsConversationIdStateGetQueryKey(options)
});

/**
 * End Conversation
 *
 * Signal the workflow to complete.
 *
 * Idempotent: an already-ended conversation still returns 204 — the
 * frontend fires this on dialog close and shouldn't have to know the
 * precise workflow state.
 *
 * Raises:
 * HTTPException: 400 if no organization; 403 if the
 * ``conversationId`` doesn't belong to the caller's org;
 * 500 on a non-NOT_FOUND Temporal RPC error.
 * RPCError: re-raised on non-NOT_FOUND Temporal RPC errors so FastAPI
 * translates them to 500.
 */
export const endConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostMutation = (options?: Partial<Options<EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostData>>): UseMutationOptions<EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostResponse, EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostError, Options<EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostData>> => {
    const mutationOptions: UseMutationOptions<EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostResponse, EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostError, Options<EndConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await endConversationAppAccountsLeadDiscoveryConversationsConversationIdEndPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetQueryKey = (options: Options<GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetData>) => createQueryKey('getAccountProcessingStatusAppAccountsProcessingStatusAccountIdGet', options);

/**
 * Get Account Processing Status
 *
 * Get processing workflow status for a specific account.
 *
 * Status is read directly from the DB processing_status column.
 *
 * Args:
 * account_id: The account ID to check status for.
 * session: SQLAlchemy async session.
 * permissions_service: Permissions service.
 *
 * Returns:
 * AccountProcessingStatusResponse with per-entity status information.
 *
 * Raises:
 * HTTPException: If account not found or user lacks access.
 */
export const getAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetOptions = (options: Options<GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetData>) => queryOptions<GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetResponse, GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetError, GetAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetResponse, ReturnType<typeof getAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccountProcessingStatusAppAccountsProcessingStatusAccountIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccountProcessingStatusAppAccountsProcessingStatusAccountIdGetQueryKey(options)
});

export const checkBatchStatusAppAccountsProcessingStatusBatchAccountIdGetQueryKey = (options: Options<CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetData>) => createQueryKey('checkBatchStatusAppAccountsProcessingStatusBatchAccountIdGet', options);

/**
 * Check Batch Status
 *
 * Check the overall processing status of an account's enrichment.
 *
 * Args:
 * account_id: The account ID to check.
 * session: SQLAlchemy async session.
 *
 * Returns:
 * Batch processing status.
 *
 * Raises:
 * HTTPException: If account not found.
 */
export const checkBatchStatusAppAccountsProcessingStatusBatchAccountIdGetOptions = (options: Options<CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetData>) => queryOptions<CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetResponse, CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetError, CheckBatchStatusAppAccountsProcessingStatusBatchAccountIdGetResponse, ReturnType<typeof checkBatchStatusAppAccountsProcessingStatusBatchAccountIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkBatchStatusAppAccountsProcessingStatusBatchAccountIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkBatchStatusAppAccountsProcessingStatusBatchAccountIdGetQueryKey(options)
});

/**
 * Check Multiple Batch Status
 *
 * Check multiple batch processing statuses efficiently.
 *
 * Args:
 * account_ids: List of account IDs to check.
 * session: SQLAlchemy async session.
 *
 * Returns:
 * List of batch processing statuses.
 */
export const checkMultipleBatchStatusAppAccountsProcessingStatusBatchPostMutation = (options?: Partial<Options<CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostData>>): UseMutationOptions<CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostResponse, CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostError, Options<CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostData>> => {
    const mutationOptions: UseMutationOptions<CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostResponse, CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostError, Options<CheckMultipleBatchStatusAppAccountsProcessingStatusBatchPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkMultipleBatchStatusAppAccountsProcessingStatusBatchPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry Company Enrichment
 *
 * Retry enrichment for a company.
 *
 * Starts an EnrichmentDAGWorkflow in selective_refresh mode with no node_names
 * (runs all non-disabled nodes) for the given company. Also runs fit_analysis
 * for related accounts after company enrichment.
 *
 * Args:
 * company_id: The company ID to re-enrich.
 * session: SQLAlchemy async session.
 * temporal: Temporal client.
 *
 * Returns:
 * EnrichmentRetryResponse with workflow ID.
 *
 * Raises:
 * HTTPException: If enrichment is already in progress (409).
 */
export const retryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostMutation = (options?: Partial<Options<RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostData>>): UseMutationOptions<RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostResponse, RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostError, Options<RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostData>> => {
    const mutationOptions: UseMutationOptions<RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostResponse, RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostError, Options<RetryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryCompanyEnrichmentAppAccountsProcessingStatusRetryCompanyCompanyIdPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry Account Enrichment
 *
 * Retry enrichment for an account.
 *
 * Starts an EnrichmentDAGWorkflow with mode="initial_populate" for the account.
 * This will enrich the company and then run fit_analysis for the account.
 *
 * Args:
 * account_id: The account ID to re-enrich.
 * session: SQLAlchemy async session.
 * temporal: Temporal client.
 *
 * Returns:
 * EnrichmentRetryResponse with workflow ID.
 *
 * Raises:
 * HTTPException: If account not found (404) or enrichment already in progress (409).
 */
export const retryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostMutation = (options?: Partial<Options<RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostData>>): UseMutationOptions<RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostResponse, RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostError, Options<RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostData>> => {
    const mutationOptions: UseMutationOptions<RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostResponse, RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostError, Options<RetryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryAccountEnrichmentAppAccountsProcessingStatusRetryAccountAccountIdPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Export Accounts
 *
 * Export accounts or contacts to CSV or Excel format.
 *
 * This endpoint supports two modes:
 * - accounts: One row per account (default)
 * - contacts: One row per contact with account data denormalized
 *
 * Args:
 * request: The request body containing the export request.
 * pg_search_service: The Postgres search service for querying accounts.
 * user_action_service: Service for logging user actions.
 * session: Database session for contact queries.
 * email_service: Email service for notifications.
 * permissions_service: Permissions service for tier gating.
 *
 * Returns:
 * CSV or Excel file containing the data.
 *
 * Raises:
 * HTTPException: If the user's organization is not on a paid tier.
 */
export const exportAccountsAppAccountsExportExportPostMutation = (options?: Partial<Options<ExportAccountsAppAccountsExportExportPostData>>): UseMutationOptions<unknown, ExportAccountsAppAccountsExportExportPostError, Options<ExportAccountsAppAccountsExportExportPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, ExportAccountsAppAccountsExportExportPostError, Options<ExportAccountsAppAccountsExportExportPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exportAccountsAppAccountsExportExportPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Export Contacts
 *
 * Export contacts for an account to CSV or Excel format.
 *
 * This endpoint:
 * 1. Verifies user has access to the account
 * 2. Queries contacts for the account
 * 3. Optionally filters to selected contact IDs
 * 4. Formats data with account context (denormalized)
 * 5. Returns CSV or Excel file
 *
 * Returns:
 * CSV or Excel file containing the contacts for the account.
 *
 * Raises:
 * HTTPException: If the account is not found or the user does not have access to the account.
 */
export const exportContactsAppAccountsExportContactsPostMutation = (options?: Partial<Options<ExportContactsAppAccountsExportContactsPostData>>): UseMutationOptions<unknown, ExportContactsAppAccountsExportContactsPostError, Options<ExportContactsAppAccountsExportContactsPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, ExportContactsAppAccountsExportContactsPostError, Options<ExportContactsAppAccountsExportContactsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exportContactsAppAccountsExportContactsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Export Emails
 *
 * Get email addresses for filtered accounts (for bulk email mailto).
 *
 * Returns a lightweight JSON response with unique professional email addresses
 * for all contacts linked to the filtered accounts.
 *
 * Args:
 * request: The request body containing filters.
 * pg_search_service: The Postgres search service for querying accounts.
 * session: Database session for contact queries.
 * permissions_service: Permissions service for tier gating.
 *
 * Returns:
 * ExportEmailsResponse with email addresses and counts.
 *
 * Raises:
 * HTTPException: If the user's organization is not on a paid tier.
 */
export const getExportEmailsAppAccountsExportEmailsPostMutation = (options?: Partial<Options<GetExportEmailsAppAccountsExportEmailsPostData>>): UseMutationOptions<GetExportEmailsAppAccountsExportEmailsPostResponse, GetExportEmailsAppAccountsExportEmailsPostError, Options<GetExportEmailsAppAccountsExportEmailsPostData>> => {
    const mutationOptions: UseMutationOptions<GetExportEmailsAppAccountsExportEmailsPostResponse, GetExportEmailsAppAccountsExportEmailsPostError, Options<GetExportEmailsAppAccountsExportEmailsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getExportEmailsAppAccountsExportEmailsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const customExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetQueryKey = (options?: Options<CustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetData>) => createQueryKey('customExportGetSourceFieldsAppAccountsExportCustomExportFieldsGet', options);

/**
 * Custom Export Get Source Fields
 *
 * Return all SUPPLYCO fields available as a custom export template source field.
 *
 * Returns:
 * Source fields keyed by their export-row alias, with display labels.
 *
 * Raises:
 * HTTPException: 403 if the org cannot export.
 */
export const customExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetOptions = (options?: Options<CustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetData>) => queryOptions<CustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetResponse, DefaultError, CustomExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetResponse, ReturnType<typeof customExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await customExportGetSourceFieldsAppAccountsExportCustomExportFieldsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: customExportGetSourceFieldsAppAccountsExportCustomExportFieldsGetQueryKey(options)
});

/**
 * Custom Export Parse Template
 *
 * Parse an uploaded template CSV/Excel and return the header names.
 *
 * Only the header row is meaningful — data rows are ignored. Header parsing
 * is delegated to `DataExporter.parse_custom_export_headers`, which raises a
 * 400 on empty or headerless input.
 *
 * Returns:
 * The parsed column headers as plain strings.
 *
 * Raises:
 * HTTPException: 403 if the org cannot export.
 */
export const customExportParseTemplateAppAccountsExportCustomExportParseTemplatePostMutation = (options?: Partial<Options<CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostData>>): UseMutationOptions<CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostResponse, CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostError, Options<CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostData>> => {
    const mutationOptions: UseMutationOptions<CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostResponse, CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostError, Options<CustomExportParseTemplateAppAccountsExportCustomExportParseTemplatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await customExportParseTemplateAppAccountsExportCustomExportParseTemplatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Custom Export Clear Template
 *
 * Clear the org's custom export template.
 *
 * Returns:
 * Empty 204 response.
 *
 * Raises:
 * HTTPException: 403 if the org cannot export.
 */
export const customExportClearTemplateAppAccountsExportCustomExportTemplateDeleteMutation = (options?: Partial<Options<CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteData>>): UseMutationOptions<CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteResponse, DefaultError, Options<CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteData>> => {
    const mutationOptions: UseMutationOptions<CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteResponse, DefaultError, Options<CustomExportClearTemplateAppAccountsExportCustomExportTemplateDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await customExportClearTemplateAppAccountsExportCustomExportTemplateDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const customExportGetTemplateAppAccountsExportCustomExportTemplateGetQueryKey = (options?: Options<CustomExportGetTemplateAppAccountsExportCustomExportTemplateGetData>) => createQueryKey('customExportGetTemplateAppAccountsExportCustomExportTemplateGet', options);

/**
 * Custom Export Get Template
 *
 * Return the org's saved custom export template, or null columns if unset.
 *
 * Returns:
 * Template response with the saved columns or null.
 *
 * Raises:
 * HTTPException: 403 if the org cannot export.
 */
export const customExportGetTemplateAppAccountsExportCustomExportTemplateGetOptions = (options?: Options<CustomExportGetTemplateAppAccountsExportCustomExportTemplateGetData>) => queryOptions<CustomExportGetTemplateAppAccountsExportCustomExportTemplateGetResponse, DefaultError, CustomExportGetTemplateAppAccountsExportCustomExportTemplateGetResponse, ReturnType<typeof customExportGetTemplateAppAccountsExportCustomExportTemplateGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await customExportGetTemplateAppAccountsExportCustomExportTemplateGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: customExportGetTemplateAppAccountsExportCustomExportTemplateGetQueryKey(options)
});

/**
 * Custom Export Save Template
 *
 * Upsert the org's custom export template.
 *
 * Args:
 * template: Validated template payload.
 * user: The current org user.
 * session: Database session.
 * permissions_service: Permissions check for tier gating.
 *
 * Returns:
 * The saved template echoed back.
 *
 * Raises:
 * HTTPException: 400 if any source_field references an unknown SUPPLYCO key.
 */
export const customExportSaveTemplateAppAccountsExportCustomExportTemplatePutMutation = (options?: Partial<Options<CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutData>>): UseMutationOptions<CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutResponse, CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutError, Options<CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutData>> => {
    const mutationOptions: UseMutationOptions<CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutResponse, CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutError, Options<CustomExportSaveTemplateAppAccountsExportCustomExportTemplatePutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await customExportSaveTemplateAppAccountsExportCustomExportTemplatePut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Custom Export Preview
 *
 * Return populated grid rows for the given account scope and saved template.
 *
 * See ``_load_custom_export_data`` for the 403 / 409 error contract shared
 * with the download endpoint.
 *
 * Returns:
 * Preview rows keyed by template target headers.
 */
export const customExportPreviewAppAccountsExportCustomExportPreviewPostMutation = (options?: Partial<Options<CustomExportPreviewAppAccountsExportCustomExportPreviewPostData>>): UseMutationOptions<CustomExportPreviewAppAccountsExportCustomExportPreviewPostResponse, CustomExportPreviewAppAccountsExportCustomExportPreviewPostError, Options<CustomExportPreviewAppAccountsExportCustomExportPreviewPostData>> => {
    const mutationOptions: UseMutationOptions<CustomExportPreviewAppAccountsExportCustomExportPreviewPostResponse, CustomExportPreviewAppAccountsExportCustomExportPreviewPostError, Options<CustomExportPreviewAppAccountsExportCustomExportPreviewPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await customExportPreviewAppAccountsExportCustomExportPreviewPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Custom Export Download
 *
 * Stream the final custom export file (CSV or Excel) with user edits applied.
 *
 * See ``_load_custom_export_data`` for the 403 / 409 error contract shared
 * with the preview endpoint.
 *
 * Returns:
 * StreamingResponse containing the populated file, or 204 if no accounts match.
 */
export const customExportDownloadAppAccountsExportCustomExportDownloadPostMutation = (options?: Partial<Options<CustomExportDownloadAppAccountsExportCustomExportDownloadPostData>>): UseMutationOptions<unknown, CustomExportDownloadAppAccountsExportCustomExportDownloadPostError, Options<CustomExportDownloadAppAccountsExportCustomExportDownloadPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, CustomExportDownloadAppAccountsExportCustomExportDownloadPostError, Options<CustomExportDownloadAppAccountsExportCustomExportDownloadPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await customExportDownloadAppAccountsExportCustomExportDownloadPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Account Facet Options
 *
 * Get options for a single account filter facet.
 *
 * Returns:
 * Option values for the requested facet.
 */
export const getAccountFacetOptionsAppAccountsFilterOptionsFacetPostMutation = (options?: Partial<Options<GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostData>>): UseMutationOptions<GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostResponse, GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostError, Options<GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostData>> => {
    const mutationOptions: UseMutationOptions<GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostResponse, GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostError, Options<GetAccountFacetOptionsAppAccountsFilterOptionsFacetPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getAccountFacetOptionsAppAccountsFilterOptionsFacetPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get Accounts Heat Map
 *
 * Aggregate account applications into an application x NAICS-subsector grid.
 *
 * Returns:
 * Non-empty cells with weighted, stated and raw account counts.
 *
 * Raises:
 * HTTPException: If the user has no organization.
 */
export const getAccountsHeatMapAppAccountsHeatMapsPostMutation = (options?: Partial<Options<GetAccountsHeatMapAppAccountsHeatMapsPostData>>): UseMutationOptions<GetAccountsHeatMapAppAccountsHeatMapsPostResponse, GetAccountsHeatMapAppAccountsHeatMapsPostError, Options<GetAccountsHeatMapAppAccountsHeatMapsPostData>> => {
    const mutationOptions: UseMutationOptions<GetAccountsHeatMapAppAccountsHeatMapsPostResponse, GetAccountsHeatMapAppAccountsHeatMapsPostError, Options<GetAccountsHeatMapAppAccountsHeatMapsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getAccountsHeatMapAppAccountsHeatMapsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Parse Filters
 *
 * Parse a natural language query into structured account filters.
 *
 * Returns:
 * ParseFiltersResponse with extracted filters.
 *
 * Raises:
 * HTTPException: If organization not found (400) or AI unavailable (503).
 */
export const parseFiltersAppAccountsParseFiltersPostMutation = (options?: Partial<Options<ParseFiltersAppAccountsParseFiltersPostData>>): UseMutationOptions<ParseFiltersAppAccountsParseFiltersPostResponse, ParseFiltersAppAccountsParseFiltersPostError, Options<ParseFiltersAppAccountsParseFiltersPostData>> => {
    const mutationOptions: UseMutationOptions<ParseFiltersAppAccountsParseFiltersPostResponse, ParseFiltersAppAccountsParseFiltersPostError, Options<ParseFiltersAppAccountsParseFiltersPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parseFiltersAppAccountsParseFiltersPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getVectorTileAppAccountsAccountsTilesZxyPbfGetQueryKey = (options: Options<GetVectorTileAppAccountsAccountsTilesZxyPbfGetData>) => createQueryKey('getVectorTileAppAccountsAccountsTilesZXYPbfGet', options);

/**
 * Get Vector Tile
 *
 * Get vector tile for map visualization.
 *
 * Generates clustered 'clusters' and 'points' layers using PostGIS ST_AsMVT
 * over the accounts returned by the shared map query, so the pins here always
 * match the accounts ``/map-points`` lists for the same filters.
 *
 * Returns:
 * Response: MVT protobuf content.
 *
 * Raises:
 * HTTPException: If organization not found or query fails.
 */
export const getVectorTileAppAccountsAccountsTilesZxyPbfGetOptions = (options: Options<GetVectorTileAppAccountsAccountsTilesZxyPbfGetData>) => queryOptions<unknown, GetVectorTileAppAccountsAccountsTilesZxyPbfGetError, unknown, ReturnType<typeof getVectorTileAppAccountsAccountsTilesZxyPbfGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getVectorTileAppAccountsAccountsTilesZXYPbfGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getVectorTileAppAccountsAccountsTilesZxyPbfGetQueryKey(options)
});

/**
 * Share Accounts
 *
 * Share accounts with a distributor organization.
 *
 * This endpoint:
 * 1. Validates user has permission to share the accounts
 * 2. Verifies target organization is a distributor of the user's organization
 * 3. Creates share records with the distributor organization
 * 4. Sends email notification to the distributor organization
 *
 * Supports two modes:
 * 1. Share specific accounts by providing account IDs
 * 2. Bulk share by providing filters (shares all accounts matching filters)
 *
 * Returns:
 * ShareAccountsResponse instance.
 *
 * Raises:
 * HTTPException: If distributor organization is not found (404)
 */
export const shareAccountsAppAccountsSharePostMutation = (options?: Partial<Options<ShareAccountsAppAccountsSharePostData>>): UseMutationOptions<ShareAccountsAppAccountsSharePostResponse, ShareAccountsAppAccountsSharePostError, Options<ShareAccountsAppAccountsSharePostData>> => {
    const mutationOptions: UseMutationOptions<ShareAccountsAppAccountsSharePostResponse, ShareAccountsAppAccountsSharePostError, Options<ShareAccountsAppAccountsSharePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareAccountsAppAccountsSharePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Share Account Via Email
 *
 * Render email template for sharing account details via a client-side mailto link.
 *
 * Returns:
 * ShareAccountViaEmailResponse with rendered subject/text/html.
 */
export const shareAccountViaEmailAppAccountsShareAccountIdEmailPostMutation = (options?: Partial<Options<ShareAccountViaEmailAppAccountsShareAccountIdEmailPostData>>): UseMutationOptions<ShareAccountViaEmailAppAccountsShareAccountIdEmailPostResponse, ShareAccountViaEmailAppAccountsShareAccountIdEmailPostError, Options<ShareAccountViaEmailAppAccountsShareAccountIdEmailPostData>> => {
    const mutationOptions: UseMutationOptions<ShareAccountViaEmailAppAccountsShareAccountIdEmailPostResponse, ShareAccountViaEmailAppAccountsShareAccountIdEmailPostError, Options<ShareAccountViaEmailAppAccountsShareAccountIdEmailPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareAccountViaEmailAppAccountsShareAccountIdEmailPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAccountContactsAppAccountsContactsAccountIdGetQueryKey = (options: Options<GetAccountContactsAppAccountsContactsAccountIdGetData>) => createQueryKey('getAccountContactsAppAccountsContactsAccountIdGet', options);

/**
 * Get Account Contacts
 *
 * Get contacts for an account.
 *
 * Returns:
 * Page[ContactDetails] instance.
 *
 * Raises:
 * HTTPException: If account not found or user lacks permission
 */
export const getAccountContactsAppAccountsContactsAccountIdGetOptions = (options: Options<GetAccountContactsAppAccountsContactsAccountIdGetData>) => queryOptions<GetAccountContactsAppAccountsContactsAccountIdGetResponse, GetAccountContactsAppAccountsContactsAccountIdGetError, GetAccountContactsAppAccountsContactsAccountIdGetResponse, ReturnType<typeof getAccountContactsAppAccountsContactsAccountIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccountContactsAppAccountsContactsAccountIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccountContactsAppAccountsContactsAccountIdGetQueryKey(options)
});

export const getAccountContactsAppAccountsContactsAccountIdGetInfiniteQueryKey = (options: Options<GetAccountContactsAppAccountsContactsAccountIdGetData>): QueryKey<Options<GetAccountContactsAppAccountsContactsAccountIdGetData>> => createQueryKey('getAccountContactsAppAccountsContactsAccountIdGet', options, true);

/**
 * Get Account Contacts
 *
 * Get contacts for an account.
 *
 * Returns:
 * Page[ContactDetails] instance.
 *
 * Raises:
 * HTTPException: If account not found or user lacks permission
 */
export const getAccountContactsAppAccountsContactsAccountIdGetInfiniteOptions = (options: Options<GetAccountContactsAppAccountsContactsAccountIdGetData>) => {
    const opts = infiniteQueryOptions<GetAccountContactsAppAccountsContactsAccountIdGetResponse, GetAccountContactsAppAccountsContactsAccountIdGetError, InfiniteData<GetAccountContactsAppAccountsContactsAccountIdGetResponse>, QueryKey<Options<GetAccountContactsAppAccountsContactsAccountIdGetData>>, number | Pick<QueryKey<Options<GetAccountContactsAppAccountsContactsAccountIdGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAccountContactsAppAccountsContactsAccountIdGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAccountContactsAppAccountsContactsAccountIdGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAccountContactsAppAccountsContactsAccountIdGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getAccountContactsFullAppAccountsContactsAccountIdFullGetQueryKey = (options: Options<GetAccountContactsFullAppAccountsContactsAccountIdFullGetData>) => createQueryKey('getAccountContactsFullAppAccountsContactsAccountIdFullGet', options);

/**
 * Get Account Contacts Full
 *
 * Get all contacts for an account, fetching from Explorium if needed.
 *
 * Returns:
 * Page of ContactDetails for the account
 *
 * Raises:
 * HTTPException: If account not found or user lacks permission
 */
export const getAccountContactsFullAppAccountsContactsAccountIdFullGetOptions = (options: Options<GetAccountContactsFullAppAccountsContactsAccountIdFullGetData>) => queryOptions<GetAccountContactsFullAppAccountsContactsAccountIdFullGetResponse, GetAccountContactsFullAppAccountsContactsAccountIdFullGetError, GetAccountContactsFullAppAccountsContactsAccountIdFullGetResponse, ReturnType<typeof getAccountContactsFullAppAccountsContactsAccountIdFullGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccountContactsFullAppAccountsContactsAccountIdFullGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccountContactsFullAppAccountsContactsAccountIdFullGetQueryKey(options)
});

export const getAccountContactsFullAppAccountsContactsAccountIdFullGetInfiniteQueryKey = (options: Options<GetAccountContactsFullAppAccountsContactsAccountIdFullGetData>): QueryKey<Options<GetAccountContactsFullAppAccountsContactsAccountIdFullGetData>> => createQueryKey('getAccountContactsFullAppAccountsContactsAccountIdFullGet', options, true);

/**
 * Get Account Contacts Full
 *
 * Get all contacts for an account, fetching from Explorium if needed.
 *
 * Returns:
 * Page of ContactDetails for the account
 *
 * Raises:
 * HTTPException: If account not found or user lacks permission
 */
export const getAccountContactsFullAppAccountsContactsAccountIdFullGetInfiniteOptions = (options: Options<GetAccountContactsFullAppAccountsContactsAccountIdFullGetData>) => {
    const opts = infiniteQueryOptions<GetAccountContactsFullAppAccountsContactsAccountIdFullGetResponse, GetAccountContactsFullAppAccountsContactsAccountIdFullGetError, InfiniteData<GetAccountContactsFullAppAccountsContactsAccountIdFullGetResponse>, QueryKey<Options<GetAccountContactsFullAppAccountsContactsAccountIdFullGetData>>, number | Pick<QueryKey<Options<GetAccountContactsFullAppAccountsContactsAccountIdFullGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAccountContactsFullAppAccountsContactsAccountIdFullGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAccountContactsFullAppAccountsContactsAccountIdFullGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAccountContactsFullAppAccountsContactsAccountIdFullGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetQueryKey = (options: Options<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetData>) => createQueryKey('getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGet', options);

/**
 * Get Account Contacts Summary
 *
 * Get lightweight contact summaries for an account table view.
 *
 * Returns only the fields needed for the contacts table, omitting heavy
 * array fields (skills, experience, interests, functions, emails) to
 * reduce HTTP payload size.
 *
 * Returns:
 * Page of ContactSummary for the account
 *
 * Raises:
 * HTTPException: If account not found or user lacks permission
 */
export const getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetOptions = (options: Options<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetData>) => queryOptions<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetResponse, GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetError, GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetResponse, ReturnType<typeof getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetQueryKey(options)
});

export const getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetInfiniteQueryKey = (options: Options<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetData>): QueryKey<Options<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetData>> => createQueryKey('getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGet', options, true);

/**
 * Get Account Contacts Summary
 *
 * Get lightweight contact summaries for an account table view.
 *
 * Returns only the fields needed for the contacts table, omitting heavy
 * array fields (skills, experience, interests, functions, emails) to
 * reduce HTTP payload size.
 *
 * Returns:
 * Page of ContactSummary for the account
 *
 * Raises:
 * HTTPException: If account not found or user lacks permission
 */
export const getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetInfiniteOptions = (options: Options<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetData>) => {
    const opts = infiniteQueryOptions<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetResponse, GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetError, InfiniteData<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetResponse>, QueryKey<Options<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetData>>, number | Pick<QueryKey<Options<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAccountContactsSummaryAppAccountsContactsAccountIdSummaryGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getContactDetailAppAccountsContactsAccountIdDetailPersonIdGetQueryKey = (options: Options<GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetData>) => createQueryKey('getContactDetailAppAccountsContactsAccountIdDetailPersonIdGet', options);

/**
 * Get Contact Detail
 *
 * Get full contact details for a single person.
 *
 * Used by the contact detail sheet to lazy-load all fields for one contact.
 *
 * Returns:
 * ContactDetails with all fields for the person.
 *
 * Raises:
 * HTTPException: If account/person not found, permission denied, or person doesn't belong to account.
 */
export const getContactDetailAppAccountsContactsAccountIdDetailPersonIdGetOptions = (options: Options<GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetData>) => queryOptions<GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetResponse, GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetError, GetContactDetailAppAccountsContactsAccountIdDetailPersonIdGetResponse, ReturnType<typeof getContactDetailAppAccountsContactsAccountIdDetailPersonIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContactDetailAppAccountsContactsAccountIdDetailPersonIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContactDetailAppAccountsContactsAccountIdDetailPersonIdGetQueryKey(options)
});

/**
 * Fetch More Contacts
 *
 * Fetch the next batch of contacts from Explorium for an account.
 *
 * Returns:
 * Page of newly fetched ContactDetails.
 *
 * Raises:
 * HTTPException: If account not found, no business ID, or permission denied.
 */
export const fetchMoreContactsAppAccountsContactsAccountIdFetchMorePostMutation = (options?: Partial<Options<FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostData>>): UseMutationOptions<FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostResponse, FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostError, Options<FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostData>> => {
    const mutationOptions: UseMutationOptions<FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostResponse, FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostError, Options<FetchMoreContactsAppAccountsContactsAccountIdFetchMorePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fetchMoreContactsAppAccountsContactsAccountIdFetchMorePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enrich Contact
 *
 * Enrich a single contact with email/phone data from Explorium.
 *
 * Returns:
 * ContactDetails with enriched data.
 *
 * Raises:
 * HTTPException: If account/person not found, permission denied, or person doesn't belong to account.
 */
export const enrichContactAppAccountsContactsAccountIdEnrichPersonIdPostMutation = (options?: Partial<Options<EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostData>>): UseMutationOptions<EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostResponse, EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostError, Options<EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostData>> => {
    const mutationOptions: UseMutationOptions<EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostResponse, EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostError, Options<EnrichContactAppAccountsContactsAccountIdEnrichPersonIdPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enrichContactAppAccountsContactsAccountIdEnrichPersonIdPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Primary Contact
 *
 * Set a contact as the primary contact for an account.
 *
 * Replaces any existing primary contact for this account.
 *
 * Returns:
 * ContactDetails for the newly set primary contact.
 *
 * Raises:
 * HTTPException: If account/person not found, permission denied, or person doesn't belong to account.
 */
export const setPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutMutation = (options?: Partial<Options<SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutData>>): UseMutationOptions<SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutResponse, SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutError, Options<SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutData>> => {
    const mutationOptions: UseMutationOptions<SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutResponse, SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutError, Options<SetPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setPrimaryContactAppAccountsContactsAccountIdPrimaryPersonIdPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unset Primary Contact
 *
 * Remove the primary contact designation for an account.
 *
 * Returns:
 * 204 No Content on success.
 *
 * Raises:
 * HTTPException: If account not found or permission denied.
 */
export const unsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteMutation = (options?: Partial<Options<UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteData>>): UseMutationOptions<unknown, UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteError, Options<UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteError, Options<UnsetPrimaryContactAppAccountsContactsAccountIdPrimaryDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await unsetPrimaryContactAppAccountsContactsAccountIdPrimaryDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listNotesAppAccountsNotesAccountIdGetQueryKey = (options: Options<ListNotesAppAccountsNotesAccountIdGetData>) => createQueryKey('listNotesAppAccountsNotesAccountIdGet', options);

/**
 * List Notes
 *
 * List notes for an account, sorted by most recent first.
 *
 * Returns:
 * List of account notes.
 *
 * Raises:
 * HTTPException: 400 if no org, 403 if no access.
 */
export const listNotesAppAccountsNotesAccountIdGetOptions = (options: Options<ListNotesAppAccountsNotesAccountIdGetData>) => queryOptions<ListNotesAppAccountsNotesAccountIdGetResponse, ListNotesAppAccountsNotesAccountIdGetError, ListNotesAppAccountsNotesAccountIdGetResponse, ReturnType<typeof listNotesAppAccountsNotesAccountIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listNotesAppAccountsNotesAccountIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listNotesAppAccountsNotesAccountIdGetQueryKey(options)
});

/**
 * Create Note
 *
 * Create a note on an account.
 *
 * Returns:
 * The created note.
 *
 * Raises:
 * HTTPException: 400 if no org, 403 if no access.
 */
export const createNoteAppAccountsNotesAccountIdPostMutation = (options?: Partial<Options<CreateNoteAppAccountsNotesAccountIdPostData>>): UseMutationOptions<CreateNoteAppAccountsNotesAccountIdPostResponse, CreateNoteAppAccountsNotesAccountIdPostError, Options<CreateNoteAppAccountsNotesAccountIdPostData>> => {
    const mutationOptions: UseMutationOptions<CreateNoteAppAccountsNotesAccountIdPostResponse, CreateNoteAppAccountsNotesAccountIdPostError, Options<CreateNoteAppAccountsNotesAccountIdPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createNoteAppAccountsNotesAccountIdPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Note
 *
 * Soft-delete a note. Only the note author can delete their own notes.
 *
 * Returns:
 * The soft-deleted note.
 *
 * Raises:
 * HTTPException: 400 if no org, 403 if not author, 404 if not found.
 */
export const deleteNoteAppAccountsNotesAccountIdNoteIdDeleteMutation = (options?: Partial<Options<DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteData>>): UseMutationOptions<DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteResponse, DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteError, Options<DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteResponse, DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteError, Options<DeleteNoteAppAccountsNotesAccountIdNoteIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteNoteAppAccountsNotesAccountIdNoteIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Accounts
 *
 * Delete multiple accounts (soft delete).
 *
 * This endpoint:
 * 1. Validates user has permission to delete the accounts
 * 2. Soft deletes accounts by setting deleted_at timestamp
 * 3. Returns confirmation of deletion
 *
 * Supports two modes:
 * 1. Delete specific accounts by providing account IDs
 * 2. Bulk delete by providing filters (deletes all accounts matching filters)
 *
 * Returns:
 * DeleteAccountsResponse instance.
 *
 * Raises:
 * HTTPException: If accounts not found (404) or user lacks permission (403).
 */
export const deleteAccountsAppAccountsDeleteMutation = (options?: Partial<Options<DeleteAccountsAppAccountsDeleteData>>): UseMutationOptions<DeleteAccountsAppAccountsDeleteResponse, DeleteAccountsAppAccountsDeleteError, Options<DeleteAccountsAppAccountsDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteAccountsAppAccountsDeleteResponse, DeleteAccountsAppAccountsDeleteError, Options<DeleteAccountsAppAccountsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAccountsAppAccountsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Trigger Supplier Lookup
 *
 * Trigger a Gemini grounded search for suppliers of the account's company.
 *
 * Returns immediately with a PENDING lookup; the search runs in the background.
 *
 * Returns:
 * The pending supplier lookup record.
 *
 * Raises:
 * HTTPException: 400 if no org, 403 if no access, 404 if no company.
 */
export const triggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostMutation = (options?: Partial<Options<TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostData>>): UseMutationOptions<TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostResponse, TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostError, Options<TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostData>> => {
    const mutationOptions: UseMutationOptions<TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostResponse, TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostError, Options<TriggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triggerSupplierLookupAppAccountsAccountsAccountIdSupplierLookupPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetQueryKey = (options: Options<ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetData>) => createQueryKey('listSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGet', options);

/**
 * List Supplier Lookups
 *
 * List previous supplier lookups for an account.
 *
 * Returns:
 * List of supplier lookups, most recent first.
 *
 * Raises:
 * HTTPException: 400 if no org, 403 if no access.
 */
export const listSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetOptions = (options: Options<ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetData>) => queryOptions<ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetResponse, ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetError, ListSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetResponse, ReturnType<typeof listSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSupplierLookupsAppAccountsAccountsAccountIdSupplierLookupsGetQueryKey(options)
});

/**
 * Track Account View
 *
 * Track that a user viewed an account page.
 *
 * Creates a new action record each time, allowing for view count analytics.
 *
 * Raises:
 * HTTPException: If the account is not found or doesn't belong to user's org.
 */
export const trackAccountViewAppAccountsAccountsAccountIdViewPostMutation = (options?: Partial<Options<TrackAccountViewAppAccountsAccountsAccountIdViewPostData>>): UseMutationOptions<unknown, TrackAccountViewAppAccountsAccountsAccountIdViewPostError, Options<TrackAccountViewAppAccountsAccountsAccountIdViewPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, TrackAccountViewAppAccountsAccountsAccountIdViewPostError, Options<TrackAccountViewAppAccountsAccountsAccountIdViewPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trackAccountViewAppAccountsAccountsAccountIdViewPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetQueryKey = (options: Options<GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetData>) => createQueryKey('getBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGet', options);

/**
 * Get Building Footprint
 *
 * Get the building footprint for an account's company, if one is matched.
 *
 * Returns:
 * BuildingFootprintResponse | None: The footprint polygon and
 * attributes, or null when no footprint has been matched.
 *
 * Raises:
 * HTTPException: 404 if the account is not found in the user's org.
 */
export const getBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetOptions = (options: Options<GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetData>) => queryOptions<GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetResponse, GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetError, GetBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetResponse, ReturnType<typeof getBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBuildingFootprintAppAccountsAccountsAccountIdBuildingFootprintGetQueryKey(options)
});

export const listAgentRunsAppAgentRunsGetQueryKey = (options?: Options<ListAgentRunsAppAgentRunsGetData>) => createQueryKey('listAgentRunsAppAgentRunsGet', options);

/**
 * List Agent Runs
 *
 * Return the most recent agent runs for the actor's organization.
 *
 * Returns:
 * Up to ``limit`` runs, newest first.
 *
 * Raises:
 * HTTPException: 403 if the actor has no organization context.
 */
export const listAgentRunsAppAgentRunsGetOptions = (options?: Options<ListAgentRunsAppAgentRunsGetData>) => queryOptions<ListAgentRunsAppAgentRunsGetResponse, ListAgentRunsAppAgentRunsGetError, ListAgentRunsAppAgentRunsGetResponse, ReturnType<typeof listAgentRunsAppAgentRunsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAgentRunsAppAgentRunsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAgentRunsAppAgentRunsGetQueryKey(options)
});

/**
 * Launch Agent Run
 *
 * Start an agent workflow and return its newly-created run summary.
 *
 * The frontend uses the returned ``id`` to navigate straight to the
 * detail page, where it'll start streaming events as they arrive.
 *
 * Returns:
 * Summary of the newly-created agent run (status will be RUNNING
 * by the time this returns).
 *
 * Raises:
 * HTTPException: 403 if no org context, 400 if agent_name is unknown
 * or required fields are missing, 504 if the run row didn't
 * materialize within the deadline.
 */
export const launchAgentRunAppAgentRunsLaunchPostMutation = (options?: Partial<Options<LaunchAgentRunAppAgentRunsLaunchPostData>>): UseMutationOptions<LaunchAgentRunAppAgentRunsLaunchPostResponse, LaunchAgentRunAppAgentRunsLaunchPostError, Options<LaunchAgentRunAppAgentRunsLaunchPostData>> => {
    const mutationOptions: UseMutationOptions<LaunchAgentRunAppAgentRunsLaunchPostResponse, LaunchAgentRunAppAgentRunsLaunchPostError, Options<LaunchAgentRunAppAgentRunsLaunchPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await launchAgentRunAppAgentRunsLaunchPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Respond To Agent Run
 *
 * Signal a paused agent workflow with the user's decision.
 *
 * Scripted demos like demo_2 pause at human-in-the-loop steps via
 * ``workflow.wait_condition``; this endpoint forwards the UI's
 * response as a Temporal ``respond`` signal so the workflow can
 * advance.
 *
 * Returns:
 * ``204 No Content`` on successful signal dispatch.
 *
 * Raises:
 * HTTPException: 403 if no org context, 404 if the run is not in
 * the org, 502 if Temporal can't be reached or the workflow
 * isn't running.
 */
export const respondToAgentRunAppAgentRunsRunIdRespondPostMutation = (options?: Partial<Options<RespondToAgentRunAppAgentRunsRunIdRespondPostData>>): UseMutationOptions<RespondToAgentRunAppAgentRunsRunIdRespondPostResponse, RespondToAgentRunAppAgentRunsRunIdRespondPostError, Options<RespondToAgentRunAppAgentRunsRunIdRespondPostData>> => {
    const mutationOptions: UseMutationOptions<RespondToAgentRunAppAgentRunsRunIdRespondPostResponse, RespondToAgentRunAppAgentRunsRunIdRespondPostError, Options<RespondToAgentRunAppAgentRunsRunIdRespondPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await respondToAgentRunAppAgentRunsRunIdRespondPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAgentRunAppAgentRunsRunIdGetQueryKey = (options: Options<GetAgentRunAppAgentRunsRunIdGetData>) => createQueryKey('getAgentRunAppAgentRunsRunIdGet', options);

/**
 * Get Agent Run
 *
 * Return a single agent run plus its full event log.
 *
 * Returns:
 * The run row plus all persisted events in chronological order.
 *
 * Raises:
 * HTTPException: 403 if no org context, 404 if the run is not in the org.
 */
export const getAgentRunAppAgentRunsRunIdGetOptions = (options: Options<GetAgentRunAppAgentRunsRunIdGetData>) => queryOptions<GetAgentRunAppAgentRunsRunIdGetResponse, GetAgentRunAppAgentRunsRunIdGetError, GetAgentRunAppAgentRunsRunIdGetResponse, ReturnType<typeof getAgentRunAppAgentRunsRunIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAgentRunAppAgentRunsRunIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAgentRunAppAgentRunsRunIdGetQueryKey(options)
});

export const streamAgentRunAppAgentRunsRunIdStreamGetQueryKey = (options: Options<StreamAgentRunAppAgentRunsRunIdStreamGetData>) => createQueryKey('streamAgentRunAppAgentRunsRunIdStreamGet', options);

/**
 * Stream Agent Run
 *
 * Server-Sent Events: replay then live-tail an agent run's events.
 *
 * Returns:
 * An EventSourceResponse that emits one SSE frame per event.
 *
 * Raises:
 * HTTPException: 403 if no org context, 404 if the run is not in the org.
 */
export const streamAgentRunAppAgentRunsRunIdStreamGetOptions = (options: Options<StreamAgentRunAppAgentRunsRunIdStreamGetData>) => queryOptions<unknown, StreamAgentRunAppAgentRunsRunIdStreamGetError, unknown, ReturnType<typeof streamAgentRunAppAgentRunsRunIdStreamGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await streamAgentRunAppAgentRunsRunIdStreamGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: streamAgentRunAppAgentRunsRunIdStreamGetQueryKey(options)
});

export const getCompanyInfoAppOrganizationCompanyInfoGetQueryKey = (options?: Options<GetCompanyInfoAppOrganizationCompanyInfoGetData>) => createQueryKey('getCompanyInfoAppOrganizationCompanyInfoGet', options);

/**
 * Get Company Info
 *
 * Get company info for the current user's organization.
 *
 * Returns None if no company info exists yet.
 * Any member of the organization can view company info.
 *
 * Returns:
 * CompanyInfoResponse if found/successful, None otherwise.
 */
export const getCompanyInfoAppOrganizationCompanyInfoGetOptions = (options?: Options<GetCompanyInfoAppOrganizationCompanyInfoGetData>) => queryOptions<GetCompanyInfoAppOrganizationCompanyInfoGetResponse, DefaultError, GetCompanyInfoAppOrganizationCompanyInfoGetResponse, ReturnType<typeof getCompanyInfoAppOrganizationCompanyInfoGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompanyInfoAppOrganizationCompanyInfoGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCompanyInfoAppOrganizationCompanyInfoGetQueryKey(options)
});

/**
 * Update Company Info
 *
 * Update company info for the current user's organization.
 *
 * Only updates existing records. Only org admins can update.
 *
 * Returns:
 * CompanyInfoResponse instance.
 *
 * Raises:
 * HTTPException: If permission denied (403) or no company info exists (404).
 */
export const updateCompanyInfoAppOrganizationCompanyInfoPatchMutation = (options?: Partial<Options<UpdateCompanyInfoAppOrganizationCompanyInfoPatchData>>): UseMutationOptions<UpdateCompanyInfoAppOrganizationCompanyInfoPatchResponse, UpdateCompanyInfoAppOrganizationCompanyInfoPatchError, Options<UpdateCompanyInfoAppOrganizationCompanyInfoPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateCompanyInfoAppOrganizationCompanyInfoPatchResponse, UpdateCompanyInfoAppOrganizationCompanyInfoPatchError, Options<UpdateCompanyInfoAppOrganizationCompanyInfoPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCompanyInfoAppOrganizationCompanyInfoPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDistributorsAppOrganizationOrganizationsDistributorsGetQueryKey = (options?: Options<GetDistributorsAppOrganizationOrganizationsDistributorsGetData>) => createQueryKey('getDistributorsAppOrganizationOrganizationsDistributorsGet', options);

/**
 * Get Distributors
 *
 * Get all channel partners for the current user's organization.
 *
 * Returns both:
 * - Distributors: orgs that distribute FOR us (we are the supplier)
 * - Suppliers: orgs that supply TO us (we are the distributor)
 *
 * Any organization member can view channel partners.
 *
 * Returns:
 * list[DistributorOrganizationResponse] with direction field indicating relationship type.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const getDistributorsAppOrganizationOrganizationsDistributorsGetOptions = (options?: Options<GetDistributorsAppOrganizationOrganizationsDistributorsGetData>) => queryOptions<GetDistributorsAppOrganizationOrganizationsDistributorsGetResponse, DefaultError, GetDistributorsAppOrganizationOrganizationsDistributorsGetResponse, ReturnType<typeof getDistributorsAppOrganizationOrganizationsDistributorsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDistributorsAppOrganizationOrganizationsDistributorsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDistributorsAppOrganizationOrganizationsDistributorsGetQueryKey(options)
});

/**
 * Update Distributor Relationship
 *
 * Update a distributor relationship (e.g., set default PoC).
 *
 * Only admins of the supplier organization can update the relationship.
 * The PoC user must belong to the distributor organization.
 *
 * Returns:
 * Updated DistributorOrganizationResponse.
 *
 * Raises:
 * HTTPException: If permission denied (403), relationship not found (404),
 * or PoC user not in distributor org (400).
 */
export const updateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchMutation = (options?: Partial<Options<UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchData>>): UseMutationOptions<UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchResponse, UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchError, Options<UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchResponse, UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchError, Options<UpdateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDistributorRelationshipAppOrganizationOrganizationsDistributorsRelationshipIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAssignableUsersAppOrganizationOrganizationsAssignableUsersGetQueryKey = (options?: Options<GetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetData>) => createQueryKey('getAssignableUsersAppOrganizationOrganizationsAssignableUsersGet', options);

/**
 * Get Assignable Users
 *
 * Get all users who can be assigned to accounts.
 *
 * Returns users from:
 * - The current user's organization
 * - Related organizations (distributors if OEM, suppliers if distributor)
 *
 * This enables cross-org assignment for shared accounts.
 *
 * Returns:
 * AssignableUsersResponse with list of assignable users.
 *
 * Raises:
 * HTTPException: If user is not in an organization (403).
 */
export const getAssignableUsersAppOrganizationOrganizationsAssignableUsersGetOptions = (options?: Options<GetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetData>) => queryOptions<GetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetResponse, DefaultError, GetAssignableUsersAppOrganizationOrganizationsAssignableUsersGetResponse, ReturnType<typeof getAssignableUsersAppOrganizationOrganizationsAssignableUsersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAssignableUsersAppOrganizationOrganizationsAssignableUsersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAssignableUsersAppOrganizationOrganizationsAssignableUsersGetQueryKey(options)
});

/**
 * Update Organization
 *
 * Update organization details. Requires JWT Bearer authentication and superuser privileges.
 */
export const updateOrganizationAppOrganizationOrganizationsOrgIdPatchMutation = (options?: Partial<Options<UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchData>>): UseMutationOptions<UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchResponse, UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchError, Options<UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchResponse, UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchError, Options<UpdateOrganizationAppOrganizationOrganizationsOrgIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrganizationAppOrganizationOrganizationsOrgIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrganizationInfoAppOrganizationOrganizationsInfoGetQueryKey = (options?: Options<GetOrganizationInfoAppOrganizationOrganizationsInfoGetData>) => createQueryKey('getOrganizationInfoAppOrganizationOrganizationsInfoGet', options);

/**
 * Get Organization Info
 *
 * Get organization info including members and company details.
 *
 * Returns:
 * OrganizationInfoResponse with organization, company_info, and members.
 *
 * Raises:
 * HTTPException: If permission denied (403) or organization not found (404).
 */
export const getOrganizationInfoAppOrganizationOrganizationsInfoGetOptions = (options?: Options<GetOrganizationInfoAppOrganizationOrganizationsInfoGetData>) => queryOptions<GetOrganizationInfoAppOrganizationOrganizationsInfoGetResponse, DefaultError, GetOrganizationInfoAppOrganizationOrganizationsInfoGetResponse, ReturnType<typeof getOrganizationInfoAppOrganizationOrganizationsInfoGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationInfoAppOrganizationOrganizationsInfoGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationInfoAppOrganizationOrganizationsInfoGetQueryKey(options)
});

/**
 * Update Member Role
 *
 * Update a member's role within the organization.
 *
 * Superusers can update any user's role. Organization admins can only
 * update roles for users in their own organization.
 * Users cannot change their own role.
 *
 * Returns:
 * OrganizationMember with updated role.
 *
 * Raises:
 * HTTPException: If permission denied (403), user not found (404),
 * or user tries to change their own role (400).
 */
export const updateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchMutation = (options?: Partial<Options<UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchData>>): UseMutationOptions<UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchResponse, UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchError, Options<UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchResponse, UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchError, Options<UpdateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMemberRoleAppOrganizationOrganizationsMembersUserIdRolePatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resend Member Invitation
 *
 * Resend invitation email to an organization member.
 *
 * Only works for unverified users. For verified users, use reset-password instead.
 * Only organization admins can resend invitations.
 *
 * Raises:
 * HTTPException: If permission denied (403), user not found (404),
 * user already verified (400), or user not in organization.
 */
export const resendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostMutation = (options?: Partial<Options<ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostData>>): UseMutationOptions<ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostResponse, ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostError, Options<ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostData>> => {
    const mutationOptions: UseMutationOptions<ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostResponse, ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostError, Options<ResendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resendMemberInvitationAppOrganizationOrganizationsMembersUserIdResendInvitationPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Member
 *
 * Remove a user from the organization and deactivate their account.
 *
 * Removes the user from the organization (sets organization_id=NULL)
 * and deactivates them (sets is_active=False). The user will no longer
 * be able to log in.
 *
 * Superusers can delete any user. Organization admins can only delete
 * users in their own organization. Users cannot delete themselves.
 *
 * Raises:
 * HTTPException: If permission denied (403), user not found (404),
 * or user tries to delete themselves (400).
 */
export const deleteMemberAppOrganizationOrganizationsMembersUserIdDeleteMutation = (options?: Partial<Options<DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteData>>): UseMutationOptions<DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteResponse, DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteError, Options<DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteResponse, DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteError, Options<DeleteMemberAppOrganizationOrganizationsMembersUserIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMemberAppOrganizationOrganizationsMembersUserIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Member
 *
 * Add a new member to an organization.
 *
 * Org admins can only add to their own organization.
 * Superusers can specify any organization_id.
 *
 * Note: Org admins can assign any role including ADMIN to new members.
 *
 * Returns:
 * CreateMemberResponse with the created member.
 *
 * Raises:
 * HTTPException: If permission denied (403), seat limit exceeded (400),
 * or user already exists (409).
 */
export const createMemberAppOrganizationOrganizationsMembersPostMutation = (options?: Partial<Options<CreateMemberAppOrganizationOrganizationsMembersPostData>>): UseMutationOptions<CreateMemberAppOrganizationOrganizationsMembersPostResponse, CreateMemberAppOrganizationOrganizationsMembersPostError, Options<CreateMemberAppOrganizationOrganizationsMembersPostData>> => {
    const mutationOptions: UseMutationOptions<CreateMemberAppOrganizationOrganizationsMembersPostResponse, CreateMemberAppOrganizationOrganizationsMembersPostError, Options<CreateMemberAppOrganizationOrganizationsMembersPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMemberAppOrganizationOrganizationsMembersPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInboundConfigAppOrganizationOrganizationsMeInboundConfigGetQueryKey = (options?: Options<GetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetData>) => createQueryKey('getInboundConfigAppOrganizationOrganizationsMeInboundConfigGet', options);

/**
 * Get Inbound Config
 *
 * Return the caller org's inbound-email configuration.
 *
 * Returns:
 * Composed forwarding address, slug, and allowlist state.
 *
 * Raises:
 * HTTPException: 403 if no org context, 404 if org row missing.
 */
export const getInboundConfigAppOrganizationOrganizationsMeInboundConfigGetOptions = (options?: Options<GetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetData>) => queryOptions<GetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetResponse, DefaultError, GetInboundConfigAppOrganizationOrganizationsMeInboundConfigGetResponse, ReturnType<typeof getInboundConfigAppOrganizationOrganizationsMeInboundConfigGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInboundConfigAppOrganizationOrganizationsMeInboundConfigGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInboundConfigAppOrganizationOrganizationsMeInboundConfigGetQueryKey(options)
});

/**
 * Update Inbound Config
 *
 * Update inbound-email configuration. Admin-only.
 *
 * Only the forwarder allowlist is mutable here; the slug is fixed.
 *
 * Returns:
 * Updated configuration snapshot.
 *
 * Raises:
 * HTTPException: 403 if not admin, 404 if org missing.
 */
export const updateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutMutation = (options?: Partial<Options<UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutData>>): UseMutationOptions<UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutResponse, UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutError, Options<UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutResponse, UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutError, Options<UpdateInboundConfigAppOrganizationOrganizationsMeInboundConfigPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateInboundConfigAppOrganizationOrganizationsMeInboundConfigPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetQueryKey = (options?: Options<GetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetData>) => createQueryKey('getRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGet', options);

/**
 * Get Required Order Fields
 *
 * Return the caller-org's per-document-type required-field config.
 *
 * Visible to every authenticated org user (read is not gated to
 * admins) so the order detail panel can render the per-field
 * "Required" badge for everyone — only edits are admin-only.
 *
 * Returns:
 * Map of document type → list of camelCase field IDs that are
 * currently required.
 *
 * Raises:
 * HTTPException: 403 if no org context, 404 if org row missing.
 */
export const getRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetOptions = (options?: Options<GetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetData>) => queryOptions<GetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetResponse, DefaultError, GetRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetResponse, ReturnType<typeof getRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRequiredOrderFieldsAppOrganizationOrganizationsMeRequiredOrderFieldsGetQueryKey(options)
});

/**
 * Update Required Order Field
 *
 * Toggle one field required for ``document_type``. Admin only.
 *
 * Idempotent on re-toggle: setting required=True when already required
 * is a no-op (and vice versa). When
 * ``apply_to_all_document_types`` is true the same toggle is applied
 * to every :class:`DocumentType` in one transaction.
 *
 * Returns:
 * Updated full config snapshot.
 *
 * Raises:
 * HTTPException: 400 if ``field_id`` is not in
 * :data:`REQUIREABLE_FIELDS` (rejecting unknown / non-header
 * fields up front avoids storing config the UI can't render
 * and the review engine would silently drop). 403 if not
 * admin or no org context. 404 if org row missing.
 */
export const updateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutMutation = (options?: Partial<Options<UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutData>>): UseMutationOptions<UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutResponse, UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutError, Options<UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutData>> => {
    const mutationOptions: UseMutationOptions<UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutResponse, UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutError, Options<UpdateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateRequiredOrderFieldAppOrganizationOrganizationsMeRequiredOrderFieldsDocumentTypeFieldIdPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPersonasAppOrganizationPersonasGetQueryKey = (options?: Options<GetPersonasAppOrganizationPersonasGetData>) => createQueryKey('getPersonasAppOrganizationPersonasGet', options);

/**
 * Get Personas
 *
 * Get all personas for an organization.
 *
 * Requires organization membership.
 * Returns only non-hidden personas ordered by creation date (newest first).
 * Status is derived from Temporal workflow state.
 *
 * Returns:
 * list[PersonaResponse] instance.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const getPersonasAppOrganizationPersonasGetOptions = (options?: Options<GetPersonasAppOrganizationPersonasGetData>) => queryOptions<GetPersonasAppOrganizationPersonasGetResponse, DefaultError, GetPersonasAppOrganizationPersonasGetResponse, ReturnType<typeof getPersonasAppOrganizationPersonasGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPersonasAppOrganizationPersonasGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPersonasAppOrganizationPersonasGetQueryKey(options)
});

/**
 * Create Persona
 *
 * Create a new persona for an organization.
 *
 * Requires admin role in the organization.
 * Persona filter generation is dispatched immediately to Temporal.
 *
 * Returns:
 * PersonaResponse instance with status PENDING.
 *
 * Raises:
 * HTTPException: If permission denied (403).
 */
export const createPersonaAppOrganizationPersonasPostMutation = (options?: Partial<Options<CreatePersonaAppOrganizationPersonasPostData>>): UseMutationOptions<CreatePersonaAppOrganizationPersonasPostResponse, CreatePersonaAppOrganizationPersonasPostError, Options<CreatePersonaAppOrganizationPersonasPostData>> => {
    const mutationOptions: UseMutationOptions<CreatePersonaAppOrganizationPersonasPostResponse, CreatePersonaAppOrganizationPersonasPostError, Options<CreatePersonaAppOrganizationPersonasPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPersonaAppOrganizationPersonasPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Persona
 *
 * Delete a persona.
 *
 * Requires admin role in the organization.
 * Permanently deletes the persona.
 *
 * Raises:
 * HTTPException: If permission denied (403) or persona not found (404).
 */
export const deletePersonaAppOrganizationPersonasPersonaIdDeleteMutation = (options?: Partial<Options<DeletePersonaAppOrganizationPersonasPersonaIdDeleteData>>): UseMutationOptions<unknown, DeletePersonaAppOrganizationPersonasPersonaIdDeleteError, Options<DeletePersonaAppOrganizationPersonasPersonaIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeletePersonaAppOrganizationPersonasPersonaIdDeleteError, Options<DeletePersonaAppOrganizationPersonasPersonaIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePersonaAppOrganizationPersonasPersonaIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Distributor Relationship
 *
 * Soft delete a distributor relationship and revoke associated shares.
 *
 * Only admins of the supplier organization can delete the relationship.
 * This soft-deletes the relationship (sets deleted_at/deleted_by) and
 * revokes all account shares with the distributor organization.
 *
 * Args:
 * relationship_id: ID of the relationship to delete
 * session: Async database session
 * current_user: Authenticated user making the request
 * user_action_service: Service for logging user actions
 *
 * Raises:
 * HTTPException: If user is not an admin (403), relationship not found (404),
 * or distributor organization not found (404)
 */
export const deleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteMutation = (options?: Partial<Options<DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteData>>): UseMutationOptions<unknown, DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteError, Options<DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteError, Options<DeleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDistributorRelationshipAppOrganizationDistributorRelationshipsRelationshipIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Distributor Relationship
 *
 * Create a distributor relationship between organizations.
 *
 * Org admins can add distributors to their own organization.
 * Superusers can specify any supplier_org_id.
 *
 * Returns:
 * DistributorOrganizationResponse with the created relationship.
 *
 * Raises:
 * HTTPException: If permission denied (403), org not found (404),
 * self-relationship attempted (400), or duplicate relationship (409).
 */
export const createDistributorRelationshipAppOrganizationDistributorRelationshipsPostMutation = (options?: Partial<Options<CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostData>>): UseMutationOptions<CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostResponse, CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostError, Options<CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostResponse, CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostError, Options<CreateDistributorRelationshipAppOrganizationDistributorRelationshipsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDistributorRelationshipAppOrganizationDistributorRelationshipsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Log Activity Actions
 *
 * Log activity actions for a list of accounts.
 *
 * Uses junction table for bulk operations (1 action + N items).
 * Deduplicates CONTACTED actions: same user + same contact info within 5 minutes.
 *
 * Returns:
 * ActivityActionResponse instance.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to create activity actions.
 */
export const logActivityActionsAppAccountActionsActivityActionsPostMutation = (options?: Partial<Options<LogActivityActionsAppAccountActionsActivityActionsPostData>>): UseMutationOptions<LogActivityActionsAppAccountActionsActivityActionsPostResponse, LogActivityActionsAppAccountActionsActivityActionsPostError, Options<LogActivityActionsAppAccountActionsActivityActionsPostData>> => {
    const mutationOptions: UseMutationOptions<LogActivityActionsAppAccountActionsActivityActionsPostResponse, LogActivityActionsAppAccountActionsActivityActionsPostError, Options<LogActivityActionsAppAccountActionsActivityActionsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logActivityActionsAppAccountActionsActivityActionsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getActivityLeaderboardAppAccountActionsActivityLeaderboardGetQueryKey = (options?: Options<GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetData>) => createQueryKey('getActivityLeaderboardAppAccountActionsActivityLeaderboardGet', options);

/**
 * Get Activity Leaderboard
 *
 * Get activity leaderboard for an organization.
 *
 * Returns:
 * LeaderboardResponse instance.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the activity leaderboard.
 * HTTPException: If the organization is not found.
 */
export const getActivityLeaderboardAppAccountActionsActivityLeaderboardGetOptions = (options?: Options<GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetData>) => queryOptions<GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetResponse, GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetError, GetActivityLeaderboardAppAccountActionsActivityLeaderboardGetResponse, ReturnType<typeof getActivityLeaderboardAppAccountActionsActivityLeaderboardGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActivityLeaderboardAppAccountActionsActivityLeaderboardGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActivityLeaderboardAppAccountActionsActivityLeaderboardGetQueryKey(options)
});

export const getActivityStatsAppAccountActionsActivityStatsGetQueryKey = (options?: Options<GetActivityStatsAppAccountActionsActivityStatsGetData>) => createQueryKey('getActivityStatsAppAccountActionsActivityStatsGet', options);

/**
 * Get Activity Stats
 *
 * Get activity stats for an organization.
 *
 * Returns:
 * ActivityStatsResponse instance.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the activity stats.
 */
export const getActivityStatsAppAccountActionsActivityStatsGetOptions = (options?: Options<GetActivityStatsAppAccountActionsActivityStatsGetData>) => queryOptions<GetActivityStatsAppAccountActionsActivityStatsGetResponse, GetActivityStatsAppAccountActionsActivityStatsGetError, GetActivityStatsAppAccountActionsActivityStatsGetResponse, ReturnType<typeof getActivityStatsAppAccountActionsActivityStatsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActivityStatsAppAccountActionsActivityStatsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActivityStatsAppAccountActionsActivityStatsGetQueryKey(options)
});

export const getActivityTimelineAppAccountActionsActivityTimelineGetQueryKey = (options?: Options<GetActivityTimelineAppAccountActionsActivityTimelineGetData>) => createQueryKey('getActivityTimelineAppAccountActionsActivityTimelineGet', options);

/**
 * Get Activity Timeline
 *
 * Get activity timeline data for charting outreach over time.
 *
 * Returns daily contact counts per user/distributor for the specified period.
 *
 * Args:
 * current_user: The authenticated user.
 * leaderboard_service: Service for leaderboard queries.
 * include_distributors: Whether to include distributor organizations.
 * days: Number of days to include. None means all time.
 *
 * Returns:
 * ActivityTimelineResponse with series data for each rep/distributor.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the activity timeline.
 */
export const getActivityTimelineAppAccountActionsActivityTimelineGetOptions = (options?: Options<GetActivityTimelineAppAccountActionsActivityTimelineGetData>) => queryOptions<GetActivityTimelineAppAccountActionsActivityTimelineGetResponse, GetActivityTimelineAppAccountActionsActivityTimelineGetError, GetActivityTimelineAppAccountActionsActivityTimelineGetResponse, ReturnType<typeof getActivityTimelineAppAccountActionsActivityTimelineGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActivityTimelineAppAccountActionsActivityTimelineGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActivityTimelineAppAccountActionsActivityTimelineGetQueryKey(options)
});

export const getAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetQueryKey = (options?: Options<GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetData>) => createQueryKey('getAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGet', options);

/**
 * Get Accounts Reviewed Timeline
 *
 * Get timeline of new accounts reviewed by the platform.
 *
 * Returns daily counts of new accounts added (via CSV import, competitors widget, etc.)
 * for the specified period.
 *
 * Args:
 * current_user: The authenticated user.
 * leaderboard_service: Service for leaderboard queries.
 * days: Number of days to include. None means all time.
 *
 * Returns:
 * AccountsReviewedTimelineResponse with daily account counts.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the data.
 */
export const getAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetOptions = (options?: Options<GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetData>) => queryOptions<GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetResponse, GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetError, GetAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetResponse, ReturnType<typeof getAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccountsReviewedTimelineAppAccountActionsActivityAccountsReviewedGetQueryKey(options)
});

export const getCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetQueryKey = (options?: Options<GetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetData>) => createQueryKey('getCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGet', options);

/**
 * Get Competitors Stats
 *
 * Get stats on competitors identified by the platform.
 *
 * Returns count of competitors identified from agent runs and how many
 * have been added as accounts.
 *
 * Returns:
 * CompetitorsStatsResponse with identified and added counts.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the data.
 */
export const getCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetOptions = (options?: Options<GetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetData>) => queryOptions<GetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetResponse, DefaultError, GetCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetResponse, ReturnType<typeof getCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCompetitorsStatsAppAccountActionsActivityCompetitorsStatsGetQueryKey(options)
});

export const getResearchingAccountsCountAppAccountActionsActivityResearchingCountGetQueryKey = (options?: Options<GetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetData>) => createQueryKey('getResearchingAccountsCountAppAccountActionsActivityResearchingCountGet', options);

/**
 * Get Researching Accounts Count
 *
 * Get count of accounts currently being researched by agents.
 *
 * Returns count of accounts where processing_status is NULL (in-progress or queued).
 *
 * Returns:
 * ResearchingAccountsResponse with count.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the data.
 */
export const getResearchingAccountsCountAppAccountActionsActivityResearchingCountGetOptions = (options?: Options<GetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetData>) => queryOptions<GetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetResponse, DefaultError, GetResearchingAccountsCountAppAccountActionsActivityResearchingCountGetResponse, ReturnType<typeof getResearchingAccountsCountAppAccountActionsActivityResearchingCountGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getResearchingAccountsCountAppAccountActionsActivityResearchingCountGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getResearchingAccountsCountAppAccountActionsActivityResearchingCountGetQueryKey(options)
});

export const getActivityLogAppAccountActionsActivityLogGetQueryKey = (options?: Options<GetActivityLogAppAccountActionsActivityLogGetData>) => createQueryKey('getActivityLogAppAccountActionsActivityLogGet', options);

/**
 * Get Activity Log
 *
 * Get paginated activity log for an organization.
 *
 * Returns a paginated list of all user actions with filtering options.
 *
 * Args:
 * current_user: The authenticated user.
 * leaderboard_service: Service for leaderboard queries.
 * request: Query parameters for filtering and pagination.
 *
 * Returns:
 * ActivityLogResponse with paginated entries.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the data.
 */
export const getActivityLogAppAccountActionsActivityLogGetOptions = (options?: Options<GetActivityLogAppAccountActionsActivityLogGetData>) => queryOptions<GetActivityLogAppAccountActionsActivityLogGetResponse, GetActivityLogAppAccountActionsActivityLogGetError, GetActivityLogAppAccountActionsActivityLogGetResponse, ReturnType<typeof getActivityLogAppAccountActionsActivityLogGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActivityLogAppAccountActionsActivityLogGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActivityLogAppAccountActionsActivityLogGetQueryKey(options)
});

export const getActivityLogAppAccountActionsActivityLogGetInfiniteQueryKey = (options?: Options<GetActivityLogAppAccountActionsActivityLogGetData>): QueryKey<Options<GetActivityLogAppAccountActionsActivityLogGetData>> => createQueryKey('getActivityLogAppAccountActionsActivityLogGet', options, true);

/**
 * Get Activity Log
 *
 * Get paginated activity log for an organization.
 *
 * Returns a paginated list of all user actions with filtering options.
 *
 * Args:
 * current_user: The authenticated user.
 * leaderboard_service: Service for leaderboard queries.
 * request: Query parameters for filtering and pagination.
 *
 * Returns:
 * ActivityLogResponse with paginated entries.
 *
 * Raises:
 * HTTPException: If the actor does not have permission to view the data.
 */
export const getActivityLogAppAccountActionsActivityLogGetInfiniteOptions = (options?: Options<GetActivityLogAppAccountActionsActivityLogGetData>) => {
    const opts = infiniteQueryOptions<GetActivityLogAppAccountActionsActivityLogGetResponse, GetActivityLogAppAccountActionsActivityLogGetError, InfiniteData<GetActivityLogAppAccountActionsActivityLogGetResponse>, QueryKey<Options<GetActivityLogAppAccountActionsActivityLogGetData>>, number | Pick<QueryKey<Options<GetActivityLogAppAccountActionsActivityLogGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetActivityLogAppAccountActionsActivityLogGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getActivityLogAppAccountActionsActivityLogGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getActivityLogAppAccountActionsActivityLogGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Report Data Issue
 *
 * Report a data issue for an account.
 *
 * Creates a Plain support thread and logs a UserAction.
 *
 * Returns:
 * Response with success status and optional Plain thread ID.
 *
 * Raises:
 * HTTPException: If account not found (404) or permission denied (403).
 * PlainThreadCreationError: If Plain thread creation fails after retries.
 */
export const reportDataIssueMutation = (options?: Partial<Options<ReportDataIssueData>>): UseMutationOptions<ReportDataIssueResponse2, ReportDataIssueError, Options<ReportDataIssueData>> => {
    const mutationOptions: UseMutationOptions<ReportDataIssueResponse2, ReportDataIssueError, Options<ReportDataIssueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reportDataIssue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFeedbackQueryKey = (options: Options<GetFeedbackData>) => createQueryKey('getFeedback', options);

/**
 * Get Feedback
 *
 * Get the latest feedback for a record.
 *
 * Returns the most recent feedback from any user, or None if no feedback exists.
 *
 * Returns:
 * The latest feedback data for the specified record, or None if not found.
 *
 * Raises:
 * HTTPException: If account not found (404), permission denied (403), or invalid feedback type (400).
 */
export const getFeedbackOptions = (options: Options<GetFeedbackData>) => queryOptions<GetFeedbackResponse2, GetFeedbackError, GetFeedbackResponse2, ReturnType<typeof getFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFeedbackQueryKey(options)
});

/**
 * Leave Feedback
 *
 * Leave feedback on an account.
 *
 * Creates a new feedback record. Multiple users can leave feedback on the same
 * entity, and the most recent feedback is shown as the "latest".
 *
 * Raises:
 * HTTPException: If account not found (404), permission denied (403), or invalid feedback type (400).
 */
export const leaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostMutation = (options?: Partial<Options<LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostData>>): UseMutationOptions<unknown, LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostError, Options<LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostError, Options<LeaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await leaveFeedbackAppAccountActionsFeedbackFeedbackTypeRecordIdPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Feedback
 *
 * Delete feedback by ID.
 *
 * Raises:
 * HTTPException: If feedback not found (404) or permission denied (403).
 */
export const deleteFeedbackMutation = (options?: Partial<Options<DeleteFeedbackData>>): UseMutationOptions<unknown, DeleteFeedbackError, Options<DeleteFeedbackData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeleteFeedbackError, Options<DeleteFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate Email
 *
 * Generate a personalized outreach email using an LLM.
 *
 * Returns:
 * EmailGenerationResponse with subject and body.
 *
 * Raises:
 * HTTPException: If account/user not found, AI unavailable, or AI returns empty response.
 */
export const generateEmailAppAccountActionsEmailGenerationPostMutation = (options?: Partial<Options<GenerateEmailAppAccountActionsEmailGenerationPostData>>): UseMutationOptions<GenerateEmailAppAccountActionsEmailGenerationPostResponse, GenerateEmailAppAccountActionsEmailGenerationPostError, Options<GenerateEmailAppAccountActionsEmailGenerationPostData>> => {
    const mutationOptions: UseMutationOptions<GenerateEmailAppAccountActionsEmailGenerationPostResponse, GenerateEmailAppAccountActionsEmailGenerationPostError, Options<GenerateEmailAppAccountActionsEmailGenerationPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateEmailAppAccountActionsEmailGenerationPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Export Renewal Report
 *
 * Dispatch a renewal-report workflow and tell the client it'll be emailed.
 *
 * Returns:
 * ``RenewalReportQueuedResponse`` echoing the status and the admin's
 * email address, with HTTP 202.
 *
 * Raises:
 * HTTPException: 403 if the caller is not an org admin or has no
 * organization context.
 */
export const exportRenewalReportAppAccountActionsActivityRenewalReportExportPostMutation = (options?: Partial<Options<ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostData>>): UseMutationOptions<ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostResponse, ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostError, Options<ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostData>> => {
    const mutationOptions: UseMutationOptions<ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostResponse, ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostError, Options<ExportRenewalReportAppAccountActionsActivityRenewalReportExportPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exportRenewalReportAppAccountActionsActivityRenewalReportExportPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listBuyerProfilesAppBuyerProfilesGetQueryKey = (options?: Options<ListBuyerProfilesAppBuyerProfilesGetData>) => createQueryKey('listBuyerProfilesAppBuyerProfilesGet', options);

/**
 * List Buyer Profiles
 *
 * List all buyer profiles (tags) visible to the user.
 *
 * Returns:
 * - Tags from user's own organization (can be applied/removed)
 * - Tags from other organizations that are applied to shared accounts (read-only)
 *
 * Tags are namespaced by organization. Users can filter by any visible tag
 * but can only create/apply/remove tags belonging to their own organization.
 *
 * Returns:
 * list[BuyerProfileReturn] instance.
 *
 * Raises:
 * HTTPException: If failed to fetch buyer profiles (500).
 */
export const listBuyerProfilesAppBuyerProfilesGetOptions = (options?: Options<ListBuyerProfilesAppBuyerProfilesGetData>) => queryOptions<ListBuyerProfilesAppBuyerProfilesGetResponse, DefaultError, ListBuyerProfilesAppBuyerProfilesGetResponse, ReturnType<typeof listBuyerProfilesAppBuyerProfilesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBuyerProfilesAppBuyerProfilesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBuyerProfilesAppBuyerProfilesGetQueryKey(options)
});

/**
 * Create Buyer Profile
 *
 * Create a new buyer profile (tag).
 *
 * Requires profile_name. Automatically associates with user's organization.
 * Returns 409 if a profile with the same name already exists.
 *
 * Returns:
 * BuyerProfileReturn instance.
 *
 * Raises:
 * HTTPException: If tag with same name already exists (409) or failed to create (500).
 */
export const createBuyerProfileAppBuyerProfilesPostMutation = (options?: Partial<Options<CreateBuyerProfileAppBuyerProfilesPostData>>): UseMutationOptions<CreateBuyerProfileAppBuyerProfilesPostResponse, CreateBuyerProfileAppBuyerProfilesPostError, Options<CreateBuyerProfileAppBuyerProfilesPostData>> => {
    const mutationOptions: UseMutationOptions<CreateBuyerProfileAppBuyerProfilesPostResponse, CreateBuyerProfileAppBuyerProfilesPostError, Options<CreateBuyerProfileAppBuyerProfilesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBuyerProfileAppBuyerProfilesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Tag Associations
 *
 * Update tag associations for accounts using add/remove semantics.
 *
 * Always uses add/remove mode - only the specified tags are added or removed,
 * other existing tags are preserved.
 *
 * Important: Users can only apply/remove tags belonging to their own organization.
 * Cross-org tags are read-only (visible for filtering but cannot be modified).
 *
 * Supports two ways to specify accounts:
 * 1. Explicit account IDs
 * 2. Filter state (updates all accounts matching filters)
 *
 * Returns:
 * TagAssociationsResponse instance.
 *
 * Raises:
 * HTTPException: If missing account IDs (400), cross-org tags (403),
 * or failed to update associations (500).
 */
export const updateTagAssociationsAppBuyerProfilesAssociationsPatchMutation = (options?: Partial<Options<UpdateTagAssociationsAppBuyerProfilesAssociationsPatchData>>): UseMutationOptions<UpdateTagAssociationsAppBuyerProfilesAssociationsPatchResponse, UpdateTagAssociationsAppBuyerProfilesAssociationsPatchError, Options<UpdateTagAssociationsAppBuyerProfilesAssociationsPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateTagAssociationsAppBuyerProfilesAssociationsPatchResponse, UpdateTagAssociationsAppBuyerProfilesAssociationsPatchError, Options<UpdateTagAssociationsAppBuyerProfilesAssociationsPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTagAssociationsAppBuyerProfilesAssociationsPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Buyer Profile
 *
 * Delete a buyer profile (tag) and all its account associations.
 *
 * Only tags belonging to the user's organization can be deleted.
 * Associated account-tag links are removed via CASCADE.
 *
 * Returns:
 * Success message.
 *
 * Raises:
 * HTTPException: If tag not found (404), not owned by org (403),
 * or failed to delete (500).
 */
export const deleteBuyerProfileAppBuyerProfilesTagIdDeleteMutation = (options?: Partial<Options<DeleteBuyerProfileAppBuyerProfilesTagIdDeleteData>>): UseMutationOptions<DeleteBuyerProfileAppBuyerProfilesTagIdDeleteResponse, DeleteBuyerProfileAppBuyerProfilesTagIdDeleteError, Options<DeleteBuyerProfileAppBuyerProfilesTagIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteBuyerProfileAppBuyerProfilesTagIdDeleteResponse, DeleteBuyerProfileAppBuyerProfilesTagIdDeleteError, Options<DeleteBuyerProfileAppBuyerProfilesTagIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteBuyerProfileAppBuyerProfilesTagIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Buyer Profile
 *
 * Update a buyer profile (tag) name or description.
 *
 * Only tags belonging to the user's organization can be updated.
 *
 * Returns:
 * BuyerProfileReturn instance.
 *
 * Raises:
 * HTTPException: If tag not found (404), not owned by org (403),
 * duplicate name (409), or failed to update (500).
 */
export const updateBuyerProfileAppBuyerProfilesTagIdPatchMutation = (options?: Partial<Options<UpdateBuyerProfileAppBuyerProfilesTagIdPatchData>>): UseMutationOptions<UpdateBuyerProfileAppBuyerProfilesTagIdPatchResponse, UpdateBuyerProfileAppBuyerProfilesTagIdPatchError, Options<UpdateBuyerProfileAppBuyerProfilesTagIdPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateBuyerProfileAppBuyerProfilesTagIdPatchResponse, UpdateBuyerProfileAppBuyerProfilesTagIdPatchError, Options<UpdateBuyerProfileAppBuyerProfilesTagIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBuyerProfileAppBuyerProfilesTagIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMarketResearchReportsAppMarketResearchReportsGetQueryKey = (options?: Options<GetMarketResearchReportsAppMarketResearchReportsGetData>) => createQueryKey('getMarketResearchReportsAppMarketResearchReportsGet', options);

/**
 * Get Market Research Reports
 *
 * Get all market research reports for the organization.
 *
 * Returns reports ordered by creation date (newest first).
 *
 * Returns:
 * list[MarketResearchReportListItem] instance.
 *
 * Raises:
 * HTTPException: If failed to fetch reports (500).
 */
export const getMarketResearchReportsAppMarketResearchReportsGetOptions = (options?: Options<GetMarketResearchReportsAppMarketResearchReportsGetData>) => queryOptions<GetMarketResearchReportsAppMarketResearchReportsGetResponse, DefaultError, GetMarketResearchReportsAppMarketResearchReportsGetResponse, ReturnType<typeof getMarketResearchReportsAppMarketResearchReportsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketResearchReportsAppMarketResearchReportsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketResearchReportsAppMarketResearchReportsGetQueryKey(options)
});

/**
 * Create Market Research Report
 *
 * Create a new market research report and dispatch AI generation.
 *
 * Returns:
 * MarketResearchReportResponse instance.
 *
 * Raises:
 * HTTPException: If the user does not have permission (403).
 * HTTPException: If a report with duplicate parameters already exists (409).
 */
export const createMarketResearchReportAppMarketResearchReportsPostMutation = (options?: Partial<Options<CreateMarketResearchReportAppMarketResearchReportsPostData>>): UseMutationOptions<CreateMarketResearchReportAppMarketResearchReportsPostResponse, CreateMarketResearchReportAppMarketResearchReportsPostError, Options<CreateMarketResearchReportAppMarketResearchReportsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateMarketResearchReportAppMarketResearchReportsPostResponse, CreateMarketResearchReportAppMarketResearchReportsPostError, Options<CreateMarketResearchReportAppMarketResearchReportsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMarketResearchReportAppMarketResearchReportsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Market Research Report
 *
 * Delete a market research report.
 *
 * Raises:
 * HTTPException: If the user does not have permission (403).
 * HTTPException: If report not found (404).
 */
export const deleteMarketResearchReportAppMarketResearchReportsReportIdDeleteMutation = (options?: Partial<Options<DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteData>>): UseMutationOptions<unknown, DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteError, Options<DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteError, Options<DeleteMarketResearchReportAppMarketResearchReportsReportIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMarketResearchReportAppMarketResearchReportsReportIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMarketResearchReportAppMarketResearchReportsReportIdGetQueryKey = (options: Options<GetMarketResearchReportAppMarketResearchReportsReportIdGetData>) => createQueryKey('getMarketResearchReportAppMarketResearchReportsReportIdGet', options);

/**
 * Get Market Research Report
 *
 * Get a single market research report by ID (includes full_report and sources).
 *
 * Returns:
 * MarketResearchReportResponse instance.
 */
export const getMarketResearchReportAppMarketResearchReportsReportIdGetOptions = (options: Options<GetMarketResearchReportAppMarketResearchReportsReportIdGetData>) => queryOptions<GetMarketResearchReportAppMarketResearchReportsReportIdGetResponse, GetMarketResearchReportAppMarketResearchReportsReportIdGetError, GetMarketResearchReportAppMarketResearchReportsReportIdGetResponse, ReturnType<typeof getMarketResearchReportAppMarketResearchReportsReportIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMarketResearchReportAppMarketResearchReportsReportIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMarketResearchReportAppMarketResearchReportsReportIdGetQueryKey(options)
});

/**
 * Regenerate Market Research Report
 *
 * Regenerate an existing market research report.
 *
 * Returns:
 * MarketResearchReportResponse instance.
 *
 * Raises:
 * HTTPException: If the user does not have permission (403).
 * HTTPException: If the report is not found (404).
 */
export const regenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostMutation = (options?: Partial<Options<RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostData>>): UseMutationOptions<RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostResponse, RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostError, Options<RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostData>> => {
    const mutationOptions: UseMutationOptions<RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostResponse, RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostError, Options<RegenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await regenerateMarketResearchReportAppMarketResearchReportsReportIdRegeneratePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getNewsfeedAppInboxNewsfeedGetQueryKey = (options?: Options<GetNewsfeedAppInboxNewsfeedGetData>) => createQueryKey('getNewsfeedAppInboxNewsfeedGet', options);

/**
 * Get Newsfeed
 *
 * Get newsfeed of company events with detailed information.
 *
 * Returns company events with all available data fields for detailed formatting.
 * Supports pagination and date filtering.
 *
 * Returns:
 * Page[NewsfeedItem] instance.
 *
 * Raises:
 * HTTPException: Organization not found
 */
export const getNewsfeedAppInboxNewsfeedGetOptions = (options?: Options<GetNewsfeedAppInboxNewsfeedGetData>) => queryOptions<GetNewsfeedAppInboxNewsfeedGetResponse, GetNewsfeedAppInboxNewsfeedGetError, GetNewsfeedAppInboxNewsfeedGetResponse, ReturnType<typeof getNewsfeedAppInboxNewsfeedGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getNewsfeedAppInboxNewsfeedGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getNewsfeedAppInboxNewsfeedGetQueryKey(options)
});

export const getNewsfeedAppInboxNewsfeedGetInfiniteQueryKey = (options?: Options<GetNewsfeedAppInboxNewsfeedGetData>): QueryKey<Options<GetNewsfeedAppInboxNewsfeedGetData>> => createQueryKey('getNewsfeedAppInboxNewsfeedGet', options, true);

/**
 * Get Newsfeed
 *
 * Get newsfeed of company events with detailed information.
 *
 * Returns company events with all available data fields for detailed formatting.
 * Supports pagination and date filtering.
 *
 * Returns:
 * Page[NewsfeedItem] instance.
 *
 * Raises:
 * HTTPException: Organization not found
 */
export const getNewsfeedAppInboxNewsfeedGetInfiniteOptions = (options?: Options<GetNewsfeedAppInboxNewsfeedGetData>) => {
    const opts = infiniteQueryOptions<GetNewsfeedAppInboxNewsfeedGetResponse, GetNewsfeedAppInboxNewsfeedGetError, InfiniteData<GetNewsfeedAppInboxNewsfeedGetResponse>, QueryKey<Options<GetNewsfeedAppInboxNewsfeedGetData>>, number | Pick<QueryKey<Options<GetNewsfeedAppInboxNewsfeedGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetNewsfeedAppInboxNewsfeedGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getNewsfeedAppInboxNewsfeedGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getNewsfeedAppInboxNewsfeedGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listRecommendationsAppInboxRecommendationsGetQueryKey = (options?: Options<ListRecommendationsAppInboxRecommendationsGetData>) => createQueryKey('listRecommendationsAppInboxRecommendationsGet', options);

/**
 * List Recommendations
 *
 * List action recommendations visible to the current user.
 *
 * Returns:
 * PaginatedRecommendationsResponse sorted by created_at descending.
 */
export const listRecommendationsAppInboxRecommendationsGetOptions = (options?: Options<ListRecommendationsAppInboxRecommendationsGetData>) => queryOptions<ListRecommendationsAppInboxRecommendationsGetResponse, ListRecommendationsAppInboxRecommendationsGetError, ListRecommendationsAppInboxRecommendationsGetResponse, ReturnType<typeof listRecommendationsAppInboxRecommendationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRecommendationsAppInboxRecommendationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRecommendationsAppInboxRecommendationsGetQueryKey(options)
});

export const listRecommendationsAppInboxRecommendationsGetInfiniteQueryKey = (options?: Options<ListRecommendationsAppInboxRecommendationsGetData>): QueryKey<Options<ListRecommendationsAppInboxRecommendationsGetData>> => createQueryKey('listRecommendationsAppInboxRecommendationsGet', options, true);

/**
 * List Recommendations
 *
 * List action recommendations visible to the current user.
 *
 * Returns:
 * PaginatedRecommendationsResponse sorted by created_at descending.
 */
export const listRecommendationsAppInboxRecommendationsGetInfiniteOptions = (options?: Options<ListRecommendationsAppInboxRecommendationsGetData>) => {
    const opts = infiniteQueryOptions<ListRecommendationsAppInboxRecommendationsGetResponse, ListRecommendationsAppInboxRecommendationsGetError, InfiniteData<ListRecommendationsAppInboxRecommendationsGetResponse>, QueryKey<Options<ListRecommendationsAppInboxRecommendationsGetData>>, string | null | Pick<QueryKey<Options<ListRecommendationsAppInboxRecommendationsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListRecommendationsAppInboxRecommendationsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listRecommendationsAppInboxRecommendationsGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listRecommendationsAppInboxRecommendationsGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getRecommendationCountAppInboxRecommendationsCountGetQueryKey = (options?: Options<GetRecommendationCountAppInboxRecommendationsCountGetData>) => createQueryKey('getRecommendationCountAppInboxRecommendationsCountGet', options);

/**
 * Get Recommendation Count
 *
 * Get counts of recommendations visible to the current user.
 *
 * Returns:
 * RecommendationCountResponse with pending, actioned, dismissed, unread counts.
 */
export const getRecommendationCountAppInboxRecommendationsCountGetOptions = (options?: Options<GetRecommendationCountAppInboxRecommendationsCountGetData>) => queryOptions<GetRecommendationCountAppInboxRecommendationsCountGetResponse, DefaultError, GetRecommendationCountAppInboxRecommendationsCountGetResponse, ReturnType<typeof getRecommendationCountAppInboxRecommendationsCountGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecommendationCountAppInboxRecommendationsCountGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecommendationCountAppInboxRecommendationsCountGetQueryKey(options)
});

export const getRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetQueryKey = (options: Options<GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetData>) => createQueryKey('getRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGet', options);

/**
 * Get Recommendation By Public Id
 *
 * Get a single recommendation by its public UUID.
 *
 * Used for deep-linking from email notifications and shareable URLs.
 * Read-only — does NOT mark as read (frontend calls POST /read separately).
 * Dismissed items return 404, consistent with the list endpoint.
 *
 * Returns:
 * RecommendationResponse for the requested item.
 */
export const getRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetOptions = (options: Options<GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetData>) => queryOptions<GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetResponse, GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetError, GetRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetResponse, ReturnType<typeof getRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecommendationByPublicIdAppInboxRecommendationsByPublicIdPublicIdGetQueryKey(options)
});

/**
 * Action Recommendation
 *
 * Log outreach and mark a recommendation as actioned.
 *
 * Creates an account note on the first account and transitions the
 * recommendation to ACTIONED status (shared — visible to all users).
 *
 * Returns:
 * Updated RecommendationResponse with ACTIONED status.
 */
export const actionRecommendationAppInboxRecommendationsRecommendationIdActionPostMutation = (options?: Partial<Options<ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostData>>): UseMutationOptions<ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostResponse, ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostError, Options<ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostData>> => {
    const mutationOptions: UseMutationOptions<ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostResponse, ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostError, Options<ActionRecommendationAppInboxRecommendationsRecommendationIdActionPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await actionRecommendationAppInboxRecommendationsRecommendationIdActionPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dismiss Recommendation
 *
 * Dismiss a recommendation for the current user.
 *
 * Per-user dismissal. When all eligible users have dismissed,
 * the recommendation transitions to shared DISMISSED status so it
 * won't resurface for newly assigned users.
 *
 * Returns:
 * Updated RecommendationResponse with dismissed=True.
 */
export const dismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostMutation = (options?: Partial<Options<DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostData>>): UseMutationOptions<DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostResponse, DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostError, Options<DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostData>> => {
    const mutationOptions: UseMutationOptions<DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostResponse, DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostError, Options<DismissRecommendationAppInboxRecommendationsRecommendationIdDismissPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dismissRecommendationAppInboxRecommendationsRecommendationIdDismissPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark Read
 *
 * Mark a recommendation as read for the current user.
 *
 * Returns:
 * Updated RecommendationResponse with is_read=True.
 */
export const markReadAppInboxRecommendationsRecommendationIdReadPostMutation = (options?: Partial<Options<MarkReadAppInboxRecommendationsRecommendationIdReadPostData>>): UseMutationOptions<MarkReadAppInboxRecommendationsRecommendationIdReadPostResponse, MarkReadAppInboxRecommendationsRecommendationIdReadPostError, Options<MarkReadAppInboxRecommendationsRecommendationIdReadPostData>> => {
    const mutationOptions: UseMutationOptions<MarkReadAppInboxRecommendationsRecommendationIdReadPostResponse, MarkReadAppInboxRecommendationsRecommendationIdReadPostError, Options<MarkReadAppInboxRecommendationsRecommendationIdReadPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markReadAppInboxRecommendationsRecommendationIdReadPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark Unread
 *
 * Mark a recommendation as unread for the current user.
 *
 * Returns:
 * Updated RecommendationResponse with is_read=False.
 */
export const markUnreadAppInboxRecommendationsRecommendationIdUnreadPostMutation = (options?: Partial<Options<MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostData>>): UseMutationOptions<MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostResponse, MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostError, Options<MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostData>> => {
    const mutationOptions: UseMutationOptions<MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostResponse, MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostError, Options<MarkUnreadAppInboxRecommendationsRecommendationIdUnreadPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markUnreadAppInboxRecommendationsRecommendationIdUnreadPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetQueryKey = (options: Options<GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetData>) => createQueryKey('getGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGet', options);

/**
 * Get Generated Account Ids
 *
 * Get generation status for accounts in a multi-assignment AR.
 *
 * Returns status for accounts that have been interacted with (pending,
 * generated, or failed). Accounts not yet acted on are absent from the result.
 *
 * Status values:
 * - "generated": single-account AR exists; public_id is set
 * - "dismissed": single-account AR exists but was dismissed
 * - "pending": Temporal workflow is running
 * - "failed": Temporal workflow failed
 *
 * Returns:
 * Mapping of account ID (as string) to GeneratedAccountStatus.
 *
 * Raises:
 * HTTPException: 404 if parent recommendation not found.
 */
export const getGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetOptions = (options: Options<GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetData>) => queryOptions<GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetResponse, GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetError, GetGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetResponse, ReturnType<typeof getGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGeneratedAccountIdsAppInboxRecommendationsRecommendationIdGeneratedAccountIdsGetQueryKey(options)
});

/**
 * Generate Account Ar
 *
 * Generate a single-account AR with LLM insights from a multi-assignment.
 *
 * Creates a new ASSIGNMENT inbox item for the specified account with
 * AI-generated summary and suggested next steps. The generated AR is
 * only visible to the requesting user.
 *
 * Returns:
 * GenerateAccountARResponse with status "started", "already_exists",
 * or "already_running".
 *
 * Error responses:
 * 404 if parent recommendation not found.
 * 400 if account_id is not in the parent's account_ids, or the parent is
 * not a multi-account assignment.
 */
export const generateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostMutation = (options?: Partial<Options<GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostData>>): UseMutationOptions<GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostResponse, GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostError, Options<GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostData>> => {
    const mutationOptions: UseMutationOptions<GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostResponse, GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostError, Options<GenerateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateAccountArAppInboxRecommendationsRecommendationIdGenerateAccountArPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Email Share Recommendation
 *
 * Forward the inbox item's stored payload to chosen recipients.
 *
 * Reads ``manual_share`` config from ``AR_NOTIFICATION_REGISTRY``: the AR
 * type's email_type, role gate, and template_data key all come from there.
 * Any AR type that opts into manual_share gets this endpoint for free.
 *
 * Returns:
 * EmailShareResponse with the number of recipients the email reached.
 *
 * Error responses:
 * 404 if the AR is missing or its type does not expose manual_share,
 * or the caller isn't on the AR's user_ids list.
 * 403 if the caller's role is below ``manual_share.required_role``.
 * 400 if the AR has no rendered template_data, or recipients are invalid.
 */
export const emailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostMutation = (options?: Partial<Options<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostData>>): UseMutationOptions<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostResponse, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostError, Options<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostData>> => {
    const mutationOptions: UseMutationOptions<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostResponse, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostError, Options<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emailShareRecommendationAppInboxRecommendationsRecommendationIdEmailRenewalReportPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Email Share Recommendation
 *
 * Forward the inbox item's stored payload to chosen recipients.
 *
 * Reads ``manual_share`` config from ``AR_NOTIFICATION_REGISTRY``: the AR
 * type's email_type, role gate, and template_data key all come from there.
 * Any AR type that opts into manual_share gets this endpoint for free.
 *
 * Returns:
 * EmailShareResponse with the number of recipients the email reached.
 *
 * Error responses:
 * 404 if the AR is missing or its type does not expose manual_share,
 * or the caller isn't on the AR's user_ids list.
 * 403 if the caller's role is below ``manual_share.required_role``.
 * 400 if the AR has no rendered template_data, or recipients are invalid.
 */
export const emailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostMutation = (options?: Partial<Options<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostData>>): UseMutationOptions<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostResponse, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostError, Options<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostData>> => {
    const mutationOptions: UseMutationOptions<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostResponse, EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostError, Options<EmailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emailShareRecommendationAppInboxRecommendationsRecommendationIdEmailSharePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const chatAuthAppChatAuthGetQueryKey = (options?: Options<ChatAuthAppChatAuthGetData>) => createQueryKey('chatAuthAppChatAuthGet', options);

/**
 * Chat Auth
 *
 * Authenticate a user for the Plain chat.
 *
 * Returns:
 * ChatAuthResponse with available=True and auth details if configured,
 * or available=False with null fields if not configured (in non-prod).
 *
 * Raises:
 * HTTPException: 500 if Plain chat secret not configured in staging/production.
 */
export const chatAuthAppChatAuthGetOptions = (options?: Options<ChatAuthAppChatAuthGetData>) => queryOptions<ChatAuthAppChatAuthGetResponse, DefaultError, ChatAuthAppChatAuthGetResponse, ReturnType<typeof chatAuthAppChatAuthGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await chatAuthAppChatAuthGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: chatAuthAppChatAuthGetQueryKey(options)
});

/**
 * Transcribe Debrief
 *
 * Transcribe audio and extract meeting debrief fields.
 *
 * Returns:
 * Transcript text and AI-extracted debrief fields.
 */
export const transcribeDebriefAppDebriefTranscribePostMutation = (options?: Partial<Options<TranscribeDebriefAppDebriefTranscribePostData>>): UseMutationOptions<TranscribeDebriefAppDebriefTranscribePostResponse, TranscribeDebriefAppDebriefTranscribePostError, Options<TranscribeDebriefAppDebriefTranscribePostData>> => {
    const mutationOptions: UseMutationOptions<TranscribeDebriefAppDebriefTranscribePostResponse, TranscribeDebriefAppDebriefTranscribePostError, Options<TranscribeDebriefAppDebriefTranscribePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transcribeDebriefAppDebriefTranscribePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save Debrief
 *
 * Save a completed debrief.
 *
 * Returns:
 * The saved debrief as a history item.
 */
export const saveDebriefAppDebriefSavePostMutation = (options?: Partial<Options<SaveDebriefAppDebriefSavePostData>>): UseMutationOptions<SaveDebriefAppDebriefSavePostResponse, SaveDebriefAppDebriefSavePostError, Options<SaveDebriefAppDebriefSavePostData>> => {
    const mutationOptions: UseMutationOptions<SaveDebriefAppDebriefSavePostResponse, SaveDebriefAppDebriefSavePostError, Options<SaveDebriefAppDebriefSavePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveDebriefAppDebriefSavePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDebriefHistoryAppDebriefHistoryGetQueryKey = (options?: Options<GetDebriefHistoryAppDebriefHistoryGetData>) => createQueryKey('getDebriefHistoryAppDebriefHistoryGet', options);

/**
 * Get Debrief History
 *
 * List past debriefs for the current user's organization, newest first.
 *
 * Returns:
 * Paginated list of debrief history items.
 */
export const getDebriefHistoryAppDebriefHistoryGetOptions = (options?: Options<GetDebriefHistoryAppDebriefHistoryGetData>) => queryOptions<GetDebriefHistoryAppDebriefHistoryGetResponse, GetDebriefHistoryAppDebriefHistoryGetError, GetDebriefHistoryAppDebriefHistoryGetResponse, ReturnType<typeof getDebriefHistoryAppDebriefHistoryGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDebriefHistoryAppDebriefHistoryGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDebriefHistoryAppDebriefHistoryGetQueryKey(options)
});

export const getDebriefHistoryAppDebriefHistoryGetInfiniteQueryKey = (options?: Options<GetDebriefHistoryAppDebriefHistoryGetData>): QueryKey<Options<GetDebriefHistoryAppDebriefHistoryGetData>> => createQueryKey('getDebriefHistoryAppDebriefHistoryGet', options, true);

/**
 * Get Debrief History
 *
 * List past debriefs for the current user's organization, newest first.
 *
 * Returns:
 * Paginated list of debrief history items.
 */
export const getDebriefHistoryAppDebriefHistoryGetInfiniteOptions = (options?: Options<GetDebriefHistoryAppDebriefHistoryGetData>) => {
    const opts = infiniteQueryOptions<GetDebriefHistoryAppDebriefHistoryGetResponse, GetDebriefHistoryAppDebriefHistoryGetError, InfiniteData<GetDebriefHistoryAppDebriefHistoryGetResponse>, QueryKey<Options<GetDebriefHistoryAppDebriefHistoryGetData>>, number | Pick<QueryKey<Options<GetDebriefHistoryAppDebriefHistoryGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetDebriefHistoryAppDebriefHistoryGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getDebriefHistoryAppDebriefHistoryGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDebriefHistoryAppDebriefHistoryGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Start New Debrief Conversation
 *
 * Create a pending debrief and start a Scout voice conversation in one step.
 *
 * Returns:
 * Debrief ID, signed WebSocket URL, agent ID, and dynamic variables.
 */
export const startNewDebriefConversationAppDebriefConversationStartPostMutation = (options?: Partial<Options<StartNewDebriefConversationAppDebriefConversationStartPostData>>): UseMutationOptions<StartNewDebriefConversationAppDebriefConversationStartPostResponse, DefaultError, Options<StartNewDebriefConversationAppDebriefConversationStartPostData>> => {
    const mutationOptions: UseMutationOptions<StartNewDebriefConversationAppDebriefConversationStartPostResponse, DefaultError, Options<StartNewDebriefConversationAppDebriefConversationStartPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startNewDebriefConversationAppDebriefConversationStartPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Debrief Conversation
 *
 * Generate a signed URL to start a Scout voice conversation for an existing debrief.
 *
 * Kept for backward compatibility with the old flow.
 *
 * Returns:
 * Signed WebSocket URL, agent ID, and dynamic variables for the mobile SDK.
 *
 * Raises:
 * HTTPException: If debrief not found or not owned by user's org.
 */
export const startDebriefConversationAppDebriefDebriefIdConversationStartPostMutation = (options?: Partial<Options<StartDebriefConversationAppDebriefDebriefIdConversationStartPostData>>): UseMutationOptions<StartDebriefConversationAppDebriefDebriefIdConversationStartPostResponse, StartDebriefConversationAppDebriefDebriefIdConversationStartPostError, Options<StartDebriefConversationAppDebriefDebriefIdConversationStartPostData>> => {
    const mutationOptions: UseMutationOptions<StartDebriefConversationAppDebriefDebriefIdConversationStartPostResponse, StartDebriefConversationAppDebriefDebriefIdConversationStartPostError, Options<StartDebriefConversationAppDebriefDebriefIdConversationStartPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startDebriefConversationAppDebriefDebriefIdConversationStartPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete Debrief Conversation
 *
 * Store conversation transcript and send summary email.
 *
 * Called by the mobile app when the Scout conversation ends.
 *
 * Raises:
 * HTTPException: If debrief not found or not owned by user's org.
 */
export const completeDebriefConversationAppDebriefDebriefIdConversationCompletePostMutation = (options?: Partial<Options<CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostData>>): UseMutationOptions<CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostResponse, CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostError, Options<CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostData>> => {
    const mutationOptions: UseMutationOptions<CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostResponse, CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostError, Options<CompleteDebriefConversationAppDebriefDebriefIdConversationCompletePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeDebriefConversationAppDebriefDebriefIdConversationCompletePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete Debrief Conversation Webhook
 *
 * Webhook endpoint for ElevenLabs server tool to complete a conversation.
 *
 * Authenticates via shared secret in the Authorization Bearer header.
 *
 * Raises:
 * HTTPException: If debrief not found or webhook secret invalid.
 */
export const completeDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostMutation = (options?: Partial<Options<CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostData>>): UseMutationOptions<CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostResponse, CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostError, Options<CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostData>> => {
    const mutationOptions: UseMutationOptions<CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostResponse, CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostError, Options<CompleteDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeDebriefConversationWebhookAppDebriefDebriefIdConversationCompleteWebhookPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Merge Link Token
 *
 * Create a Merge link token for the current user.
 *
 * Returns:
 * MergeLinkTokenResponse containing the link token.
 *
 * Raises:
 * HTTPException: 403 if the organization cannot use integrations.
 * HTTPException: 500 if Merge API key not configured or API call fails.
 */
export const createMergeLinkTokenAppIntegrationsMergeLinkTokenPostMutation = (options?: Partial<Options<CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostData>>): UseMutationOptions<CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostResponse, CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostError, Options<CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostData>> => {
    const mutationOptions: UseMutationOptions<CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostResponse, CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostError, Options<CreateMergeLinkTokenAppIntegrationsMergeLinkTokenPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMergeLinkTokenAppIntegrationsMergeLinkTokenPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Exchange Token
 *
 * Exchange a public token for an account token and store the integration.
 *
 * Args:
 * body: Request containing the public_token from Merge Link.
 * session: Database session.
 * current_user: Authenticated user.
 * merge_api_key: Validated Merge API key (injected by dependency).
 *
 * Returns:
 * ExchangeTokenResponse with the created integration ID.
 *
 * Raises:
 * HTTPException: 403 if the organization cannot use integrations.
 * HTTPException: 500 if Merge API key not configured or API call fails.
 */
export const exchangeTokenAppIntegrationsMergeExchangeTokenPostMutation = (options?: Partial<Options<ExchangeTokenAppIntegrationsMergeExchangeTokenPostData>>): UseMutationOptions<ExchangeTokenAppIntegrationsMergeExchangeTokenPostResponse, ExchangeTokenAppIntegrationsMergeExchangeTokenPostError, Options<ExchangeTokenAppIntegrationsMergeExchangeTokenPostData>> => {
    const mutationOptions: UseMutationOptions<ExchangeTokenAppIntegrationsMergeExchangeTokenPostResponse, ExchangeTokenAppIntegrationsMergeExchangeTokenPostError, Options<ExchangeTokenAppIntegrationsMergeExchangeTokenPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exchangeTokenAppIntegrationsMergeExchangeTokenPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getIntegrationStatusAppIntegrationsMergeStatusGetQueryKey = (options?: Options<GetIntegrationStatusAppIntegrationsMergeStatusGetData>) => createQueryKey('getIntegrationStatusAppIntegrationsMergeStatusGet', options);

/**
 * Get Integration Status
 *
 * Get the current CRM integration status for the organization.
 *
 * Returns:
 * IntegrationStatusResponse with connection status and integration details.
 */
export const getIntegrationStatusAppIntegrationsMergeStatusGetOptions = (options?: Options<GetIntegrationStatusAppIntegrationsMergeStatusGetData>) => queryOptions<GetIntegrationStatusAppIntegrationsMergeStatusGetResponse, DefaultError, GetIntegrationStatusAppIntegrationsMergeStatusGetResponse, ReturnType<typeof getIntegrationStatusAppIntegrationsMergeStatusGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getIntegrationStatusAppIntegrationsMergeStatusGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getIntegrationStatusAppIntegrationsMergeStatusGetQueryKey(options)
});

/**
 * Sync Merge Accounts
 *
 * Start a Temporal workflow to sync accounts from the connected CRM.
 *
 * Args:
 * body: Request containing the integration_id to sync.
 * session: Database session.
 * current_user: Authenticated user.
 * temporal: Temporal client.
 * permissions_service: Permission checker.
 *
 * Returns:
 * SyncResponse with workflow ID and status message.
 *
 * Raises:
 * HTTPException: 404 if integration not found.
 */
export const syncMergeAccountsAppIntegrationsMergeSyncPostMutation = (options?: Partial<Options<SyncMergeAccountsAppIntegrationsMergeSyncPostData>>): UseMutationOptions<SyncMergeAccountsAppIntegrationsMergeSyncPostResponse, SyncMergeAccountsAppIntegrationsMergeSyncPostError, Options<SyncMergeAccountsAppIntegrationsMergeSyncPostData>> => {
    const mutationOptions: UseMutationOptions<SyncMergeAccountsAppIntegrationsMergeSyncPostResponse, SyncMergeAccountsAppIntegrationsMergeSyncPostError, Options<SyncMergeAccountsAppIntegrationsMergeSyncPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncMergeAccountsAppIntegrationsMergeSyncPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetQueryKey = (options: Options<DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetData>) => createQueryKey('downloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGet', options);

/**
 * Download Failed Accounts Csv
 *
 * Download failed accounts from a sync log as CSV.
 *
 * Args:
 * log_id: The ID of the sync log to download.
 * session: Database session.
 * current_user: Authenticated user.
 *
 * Returns:
 * StreamingResponse with CSV content.
 *
 * Raises:
 * HTTPException: 404 if log not found or doesn't belong to this org.
 */
export const downloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetOptions = (options: Options<DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetData>) => queryOptions<unknown, DownloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetError, unknown, ReturnType<typeof downloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadFailedAccountsCsvAppIntegrationsMergeLogsLogIdFailedAccountsCsvGetQueryKey(options)
});

export const getCrmUsersAppIntegrationsMergeCrmUsersGetQueryKey = (options?: Options<GetCrmUsersAppIntegrationsMergeCrmUsersGetData>) => createQueryKey('getCrmUsersAppIntegrationsMergeCrmUsersGet', options);

/**
 * Get Crm Users
 *
 * Get CRM users for the organization with their matched SUPPLYCO users.
 *
 * Returns:
 * CrmUsersResponse with list of CRM users and their matches.
 */
export const getCrmUsersAppIntegrationsMergeCrmUsersGetOptions = (options?: Options<GetCrmUsersAppIntegrationsMergeCrmUsersGetData>) => queryOptions<GetCrmUsersAppIntegrationsMergeCrmUsersGetResponse, DefaultError, GetCrmUsersAppIntegrationsMergeCrmUsersGetResponse, ReturnType<typeof getCrmUsersAppIntegrationsMergeCrmUsersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCrmUsersAppIntegrationsMergeCrmUsersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCrmUsersAppIntegrationsMergeCrmUsersGetQueryKey(options)
});

/**
 * Enrich By Linkedin Url
 *
 * Look up contact details for a LinkedIn profile URL.
 *
 * First searches the database by LinkedIn URL. If no enriched result is found,
 * falls back to Explorium's match_prospects endpoint to resolve the prospect ID
 * and looks up the enriched record by prospect ID. When the profile is unknown
 * to the DB but Explorium resolves a prospect_id, a skeleton ExploriumPerson
 * is created and enriched on the fly (same fields the web app's "Get Contact
 * Details" button populates).
 *
 * Returns 404 only when both the DB and Explorium have no match for the URL.
 *
 * Returns:
 * LinkedInContactDetails with available contact data.
 *
 * Raises:
 * HTTPException: 422 if URL is not a valid LinkedIn profile URL.
 * HTTPException: 404 if neither the DB nor Explorium can match the URL.
 */
export const enrichByLinkedinUrlAppLinkedinEnrichPostMutation = (options?: Partial<Options<EnrichByLinkedinUrlAppLinkedinEnrichPostData>>): UseMutationOptions<EnrichByLinkedinUrlAppLinkedinEnrichPostResponse, EnrichByLinkedinUrlAppLinkedinEnrichPostError, Options<EnrichByLinkedinUrlAppLinkedinEnrichPostData>> => {
    const mutationOptions: UseMutationOptions<EnrichByLinkedinUrlAppLinkedinEnrichPostResponse, EnrichByLinkedinUrlAppLinkedinEnrichPostError, Options<EnrichByLinkedinUrlAppLinkedinEnrichPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enrichByLinkedinUrlAppLinkedinEnrichPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Claim Leads
 *
 * Claim all pre-generated scout leads for the current org.
 *
 * Flips lead_status from PRE_GENERATED to None, making leads appear
 * directly in the accounts list.
 *
 * Returns:
 * ClaimLeadsResponse with claimed count and items.
 *
 * Raises:
 * HTTPException: 403 if user lacks scout leads permission.
 */
export const claimLeadsAppScoutClaimPostMutation = (options?: Partial<Options<ClaimLeadsAppScoutClaimPostData>>): UseMutationOptions<ClaimLeadsAppScoutClaimPostResponse, DefaultError, Options<ClaimLeadsAppScoutClaimPostData>> => {
    const mutationOptions: UseMutationOptions<ClaimLeadsAppScoutClaimPostResponse, DefaultError, Options<ClaimLeadsAppScoutClaimPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await claimLeadsAppScoutClaimPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDashboardAppScoutDashboardGetQueryKey = (options?: Options<GetDashboardAppScoutDashboardGetData>) => createQueryKey('getDashboardAppScoutDashboardGet', options);

/**
 * Get Dashboard
 *
 * Get scout dashboard stats.
 *
 * Returns:
 * Pre-generated lead count and latest run summary.
 *
 * Raises:
 * HTTPException: 403 if user lacks scout leads permission.
 */
export const getDashboardAppScoutDashboardGetOptions = (options?: Options<GetDashboardAppScoutDashboardGetData>) => queryOptions<GetDashboardAppScoutDashboardGetResponse, DefaultError, GetDashboardAppScoutDashboardGetResponse, ReturnType<typeof getDashboardAppScoutDashboardGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDashboardAppScoutDashboardGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDashboardAppScoutDashboardGetQueryKey(options)
});

/**
 * Parse Territory
 *
 * Parse free-text territory input into structured region list.
 *
 * Tries a fast dict-based lookup first (handles exact names, region groups,
 * and whole-country aliases). Falls back to an LLM call for fuzzier input
 * like "pacific northwest" or "all of North America" — the LLM is constrained
 * to return names from our known taxonomy, so output is always grounded.
 *
 * Returns:
 * TerritoryParseResponse with matched regions (may be empty if nothing
 * in the taxonomy matches the user's text).
 */
export const parseTerritoryAppOnboardingParseTerritoryPostMutation = (options?: Partial<Options<ParseTerritoryAppOnboardingParseTerritoryPostData>>): UseMutationOptions<ParseTerritoryAppOnboardingParseTerritoryPostResponse, ParseTerritoryAppOnboardingParseTerritoryPostError, Options<ParseTerritoryAppOnboardingParseTerritoryPostData>> => {
    const mutationOptions: UseMutationOptions<ParseTerritoryAppOnboardingParseTerritoryPostResponse, ParseTerritoryAppOnboardingParseTerritoryPostError, Options<ParseTerritoryAppOnboardingParseTerritoryPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parseTerritoryAppOnboardingParseTerritoryPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPartnersAppOnboardingPartnersGetQueryKey = (options?: Options<GetPartnersAppOnboardingPartnersGetData>) => createQueryKey('getPartnersAppOnboardingPartnersGet', options);

/**
 * Get Partners
 *
 * Return the curated partner directory for onboarding.
 *
 * Backed by a static JSON file shipped with the app. Grows when the file
 * grows; no DB queries.
 *
 * Returns:
 * List of partner directory entries, sorted by name.
 */
export const getPartnersAppOnboardingPartnersGetOptions = (options?: Options<GetPartnersAppOnboardingPartnersGetData>) => queryOptions<GetPartnersAppOnboardingPartnersGetResponse, DefaultError, GetPartnersAppOnboardingPartnersGetResponse, ReturnType<typeof getPartnersAppOnboardingPartnersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPartnersAppOnboardingPartnersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPartnersAppOnboardingPartnersGetQueryKey(options)
});

/**
 * Onboarding Complete
 *
 * Submit onboarding form and send verification email.
 *
 * Returns:
 * OnboardingCompleteResponse with status "sent".
 *
 * Raises:
 * HTTPException: If email domain is a personal email provider.
 */
export const onboardingCompleteAppOnboardingCompletePostMutation = (options?: Partial<Options<OnboardingCompleteAppOnboardingCompletePostData>>): UseMutationOptions<OnboardingCompleteAppOnboardingCompletePostResponse, OnboardingCompleteAppOnboardingCompletePostError, Options<OnboardingCompleteAppOnboardingCompletePostData>> => {
    const mutationOptions: UseMutationOptions<OnboardingCompleteAppOnboardingCompletePostResponse, OnboardingCompleteAppOnboardingCompletePostError, Options<OnboardingCompleteAppOnboardingCompletePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await onboardingCompleteAppOnboardingCompletePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const onboardingActivateAppOnboardingActivateGetQueryKey = (options: Options<OnboardingActivateAppOnboardingActivateGetData>) => createQueryKey('onboardingActivateAppOnboardingActivateGet', options);

/**
 * Onboarding Activate
 *
 * Verify email token, create org + user, redirect with exchange token.
 *
 * The exchange token is short-lived and redeemed by the frontend via
 * POST /exchange-token, which sets the auth cookie through the standard
 * CookieTransport (avoiding cross-domain cookie issues).
 *
 * Returns:
 * RedirectResponse to activated page with exchange token or error.
 */
export const onboardingActivateAppOnboardingActivateGetOptions = (options: Options<OnboardingActivateAppOnboardingActivateGetData>) => queryOptions<unknown, OnboardingActivateAppOnboardingActivateGetError, unknown, ReturnType<typeof onboardingActivateAppOnboardingActivateGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await onboardingActivateAppOnboardingActivateGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: onboardingActivateAppOnboardingActivateGetQueryKey(options)
});

/**
 * Onboarding Exchange Token
 *
 * Exchange a short-lived onboarding token for an auth cookie.
 *
 * Uses the same CookieTransport as the rest of the auth system,
 * so cookie domain/secure/samesite are handled consistently.
 *
 * Returns:
 * Response with authentication cookie set.
 *
 * Raises:
 * HTTPException: If the exchange token is invalid or expired.
 */
export const onboardingExchangeTokenAppOnboardingExchangeTokenPostMutation = (options?: Partial<Options<OnboardingExchangeTokenAppOnboardingExchangeTokenPostData>>): UseMutationOptions<unknown, OnboardingExchangeTokenAppOnboardingExchangeTokenPostError, Options<OnboardingExchangeTokenAppOnboardingExchangeTokenPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, OnboardingExchangeTokenAppOnboardingExchangeTokenPostError, Options<OnboardingExchangeTokenAppOnboardingExchangeTokenPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await onboardingExchangeTokenAppOnboardingExchangeTokenPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const joinInfoAppOnboardingJoinInfoGetQueryKey = (options: Options<JoinInfoAppOnboardingJoinInfoGetData>) => createQueryKey('joinInfoAppOnboardingJoinInfoGet', options);

/**
 * Join Info
 *
 * Decode invite JWT and return hydration payload for member onboarding.
 *
 * Does NOT consume the token — that happens at join-complete.
 *
 * Returns:
 * JoinInfoResponse with email, org name, and company territory.
 *
 * Raises:
 * HTTPException: If token is invalid or user is already verified.
 */
export const joinInfoAppOnboardingJoinInfoGetOptions = (options: Options<JoinInfoAppOnboardingJoinInfoGetData>) => queryOptions<JoinInfoAppOnboardingJoinInfoGetResponse, JoinInfoAppOnboardingJoinInfoGetError, JoinInfoAppOnboardingJoinInfoGetResponse, ReturnType<typeof joinInfoAppOnboardingJoinInfoGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await joinInfoAppOnboardingJoinInfoGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: joinInfoAppOnboardingJoinInfoGetQueryKey(options)
});

/**
 * Join Complete
 *
 * Set password, store name + territory, mark verified, return auth cookie.
 *
 * Returns:
 * Response with authentication cookie set.
 *
 * Raises:
 * HTTPException: If token is invalid or user is already verified.
 */
export const joinCompleteAppOnboardingJoinCompletePostMutation = (options?: Partial<Options<JoinCompleteAppOnboardingJoinCompletePostData>>): UseMutationOptions<unknown, JoinCompleteAppOnboardingJoinCompletePostError, Options<JoinCompleteAppOnboardingJoinCompletePostData>> => {
    const mutationOptions: UseMutationOptions<unknown, JoinCompleteAppOnboardingJoinCompletePostError, Options<JoinCompleteAppOnboardingJoinCompletePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await joinCompleteAppOnboardingJoinCompletePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Partner Invite Create
 *
 * Create a partner invite and send the invitation email.
 *
 * Returns:
 * PartnerInviteCreateResponse with invite details.
 *
 * Raises:
 * HTTPException: 403 if the actor is not in an organization.
 */
export const partnerInviteCreateAppOnboardingPartnerInviteCreatePostMutation = (options?: Partial<Options<PartnerInviteCreateAppOnboardingPartnerInviteCreatePostData>>): UseMutationOptions<PartnerInviteCreateAppOnboardingPartnerInviteCreatePostResponse, PartnerInviteCreateAppOnboardingPartnerInviteCreatePostError, Options<PartnerInviteCreateAppOnboardingPartnerInviteCreatePostData>> => {
    const mutationOptions: UseMutationOptions<PartnerInviteCreateAppOnboardingPartnerInviteCreatePostResponse, PartnerInviteCreateAppOnboardingPartnerInviteCreatePostError, Options<PartnerInviteCreateAppOnboardingPartnerInviteCreatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await partnerInviteCreateAppOnboardingPartnerInviteCreatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const partnerInviteInfoAppOnboardingPartnerInviteInfoGetQueryKey = (options: Options<PartnerInviteInfoAppOnboardingPartnerInviteInfoGetData>) => createQueryKey('partnerInviteInfoAppOnboardingPartnerInviteInfoGet', options);

/**
 * Partner Invite Info
 *
 * Return context for a partner invite link (unauthenticated).
 *
 * Returns:
 * PartnerInviteInfoResponse with invite details.
 */
export const partnerInviteInfoAppOnboardingPartnerInviteInfoGetOptions = (options: Options<PartnerInviteInfoAppOnboardingPartnerInviteInfoGetData>) => queryOptions<PartnerInviteInfoAppOnboardingPartnerInviteInfoGetResponse, PartnerInviteInfoAppOnboardingPartnerInviteInfoGetError, PartnerInviteInfoAppOnboardingPartnerInviteInfoGetResponse, ReturnType<typeof partnerInviteInfoAppOnboardingPartnerInviteInfoGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await partnerInviteInfoAppOnboardingPartnerInviteInfoGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: partnerInviteInfoAppOnboardingPartnerInviteInfoGetQueryKey(options)
});

/**
 * Demoday Signup
 *
 * Sign a prospect (and optionally their teammates) up at the conference.
 *
 * Returns:
 * ``Response`` with a ``Set-Cookie`` header from the auth backend and a
 * JSON body of ``{firstName, organizationName, emailsSent}`` — no
 * plaintext passwords. Every created user receives a DEMODAY_INVITE
 * email with a single-use set-password link.
 */
export const demodaySignupAppDemodaySignupPostMutation = (options?: Partial<Options<DemodaySignupAppDemodaySignupPostData>>): UseMutationOptions<DemodaySignupAppDemodaySignupPostResponse, DemodaySignupAppDemodaySignupPostError, Options<DemodaySignupAppDemodaySignupPostData>> => {
    const mutationOptions: UseMutationOptions<DemodaySignupAppDemodaySignupPostResponse, DemodaySignupAppDemodaySignupPostError, Options<DemodaySignupAppDemodaySignupPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await demodaySignupAppDemodaySignupPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDemodayOrgsAppDemodayOrgsGetQueryKey = (options?: Options<ListDemodayOrgsAppDemodayOrgsGetData>) => createQueryKey('listDemodayOrgsAppDemodayOrgsGet', options);

/**
 * List Demoday Orgs
 *
 * Return demoday-tagged orgs sorted by name.
 *
 * Returns:
 * Sorted list of ``DemoDayOrgEntry`` items for all orgs with a
 * ``demoday_event`` key in ``onboarding_data``.
 */
export const listDemodayOrgsAppDemodayOrgsGetOptions = (options?: Options<ListDemodayOrgsAppDemodayOrgsGetData>) => queryOptions<ListDemodayOrgsAppDemodayOrgsGetResponse, DefaultError, ListDemodayOrgsAppDemodayOrgsGetResponse, ReturnType<typeof listDemodayOrgsAppDemodayOrgsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDemodayOrgsAppDemodayOrgsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDemodayOrgsAppDemodayOrgsGetQueryKey(options)
});

/**
 * Join
 *
 * Add primary + teammates to a pre-baked demoday org and log in primary.
 *
 * Returns:
 * ``Response`` with a ``Set-Cookie`` header from the auth backend and a
 * JSON body of ``{firstName, organizationName, emailsSent}``.
 */
export const joinAppDemodayJoinPostMutation = (options?: Partial<Options<JoinAppDemodayJoinPostData>>): UseMutationOptions<JoinAppDemodayJoinPostResponse, JoinAppDemodayJoinPostError, Options<JoinAppDemodayJoinPostData>> => {
    const mutationOptions: UseMutationOptions<JoinAppDemodayJoinPostResponse, JoinAppDemodayJoinPostError, Options<JoinAppDemodayJoinPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await joinAppDemodayJoinPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDealsAppOrdersDealsGetQueryKey = (options?: Options<ListDealsAppOrdersDealsGetData>) => createQueryKey('listDealsAppOrdersDealsGet', options);

/**
 * List Deals
 *
 * Paginated deals belonging to the auth'd org.
 *
 * Returns:
 * A page of ``DealListItem`` rows with rollup fields (document count,
 * last-event kind, allowed onward transitions).
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const listDealsAppOrdersDealsGetOptions = (options?: Options<ListDealsAppOrdersDealsGetData>) => queryOptions<ListDealsAppOrdersDealsGetResponse, ListDealsAppOrdersDealsGetError, ListDealsAppOrdersDealsGetResponse, ReturnType<typeof listDealsAppOrdersDealsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDealsAppOrdersDealsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDealsAppOrdersDealsGetQueryKey(options)
});

export const listDealsAppOrdersDealsGetInfiniteQueryKey = (options?: Options<ListDealsAppOrdersDealsGetData>): QueryKey<Options<ListDealsAppOrdersDealsGetData>> => createQueryKey('listDealsAppOrdersDealsGet', options, true);

/**
 * List Deals
 *
 * Paginated deals belonging to the auth'd org.
 *
 * Returns:
 * A page of ``DealListItem`` rows with rollup fields (document count,
 * last-event kind, allowed onward transitions).
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const listDealsAppOrdersDealsGetInfiniteOptions = (options?: Options<ListDealsAppOrdersDealsGetData>) => {
    const opts = infiniteQueryOptions<ListDealsAppOrdersDealsGetResponse, ListDealsAppOrdersDealsGetError, InfiniteData<ListDealsAppOrdersDealsGetResponse>, QueryKey<Options<ListDealsAppOrdersDealsGetData>>, number | Pick<QueryKey<Options<ListDealsAppOrdersDealsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListDealsAppOrdersDealsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listDealsAppOrdersDealsGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDealsAppOrdersDealsGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Transition Deal Stage
 *
 * Move a deal to a new stage and write an audit row.
 *
 * Returns:
 * The updated stage + the new allowed transitions, so the frontend
 * can refresh the popover without a list re-fetch.
 *
 * Raises:
 * HTTPException: 403 if order inbox is disabled, 404 if the deal
 * doesn't exist or belongs to a different org, 422 if the requested
 * transition is not in the allowed set for the deal's current stage.
 */
export const transitionDealStageAppOrdersDealsDealIdStagePostMutation = (options?: Partial<Options<TransitionDealStageAppOrdersDealsDealIdStagePostData>>): UseMutationOptions<TransitionDealStageAppOrdersDealsDealIdStagePostResponse, TransitionDealStageAppOrdersDealsDealIdStagePostError, Options<TransitionDealStageAppOrdersDealsDealIdStagePostData>> => {
    const mutationOptions: UseMutationOptions<TransitionDealStageAppOrdersDealsDealIdStagePostResponse, TransitionDealStageAppOrdersDealsDealIdStagePostError, Options<TransitionDealStageAppOrdersDealsDealIdStagePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transitionDealStageAppOrdersDealsDealIdStagePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDealEventsAppOrdersDealsDealIdEventsGetQueryKey = (options: Options<GetDealEventsAppOrdersDealsDealIdEventsGetData>) => createQueryKey('getDealEventsAppOrdersDealsDealIdEventsGet', options);

/**
 * Get Deal Events
 *
 * Return the deal's hero summary + chronological event timeline.
 *
 * Returns:
 * ``DealEventsResponse`` with the detail block (everything the
 * right-column hero needs) plus a newest-first list of derived
 * events (RFQ_IN, PO_IN, EMAIL_IN/OUT, STAGE_CHANGE, ERROR).
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled, 404 if the
 * deal does not exist or belongs to a different org.
 */
export const getDealEventsAppOrdersDealsDealIdEventsGetOptions = (options: Options<GetDealEventsAppOrdersDealsDealIdEventsGetData>) => queryOptions<GetDealEventsAppOrdersDealsDealIdEventsGetResponse, GetDealEventsAppOrdersDealsDealIdEventsGetError, GetDealEventsAppOrdersDealsDealIdEventsGetResponse, ReturnType<typeof getDealEventsAppOrdersDealsDealIdEventsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDealEventsAppOrdersDealsDealIdEventsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDealEventsAppOrdersDealsDealIdEventsGetQueryKey(options)
});

/**
 * Delete Orders
 *
 * Soft-delete one or more orders by public UUID.
 *
 * Sets ``deleted_at`` and ``deleted_by`` on each row. Soft-deleted orders
 * are filtered out of every read via ``Order.active()`` and become invisible
 * to the API. The underlying inbound message stays as an audit record.
 *
 * Bulk requests are partial-success: unknown, cross-org, or already-deleted
 * ids are reported in ``skipped_ids`` rather than failing the whole request.
 *
 * Returns:
 * Deleted order summaries and skipped ids.
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const deleteOrdersAppOrdersDeleteMutation = (options?: Partial<Options<DeleteOrdersAppOrdersDeleteData>>): UseMutationOptions<DeleteOrdersAppOrdersDeleteResponse, DeleteOrdersAppOrdersDeleteError, Options<DeleteOrdersAppOrdersDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteOrdersAppOrdersDeleteResponse, DeleteOrdersAppOrdersDeleteError, Options<DeleteOrdersAppOrdersDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteOrdersAppOrdersDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrdersAppOrdersGetQueryKey = (options?: Options<ListOrdersAppOrdersGetData>) => createQueryKey('listOrdersAppOrdersGet', options);

/**
 * List Orders
 *
 * List orders for the current organization.
 *
 * Returns:
 * Paginated list of orders with total count.
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const listOrdersAppOrdersGetOptions = (options?: Options<ListOrdersAppOrdersGetData>) => queryOptions<ListOrdersAppOrdersGetResponse, ListOrdersAppOrdersGetError, ListOrdersAppOrdersGetResponse, ReturnType<typeof listOrdersAppOrdersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrdersAppOrdersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrdersAppOrdersGetQueryKey(options)
});

export const listOrdersAppOrdersGetInfiniteQueryKey = (options?: Options<ListOrdersAppOrdersGetData>): QueryKey<Options<ListOrdersAppOrdersGetData>> => createQueryKey('listOrdersAppOrdersGet', options, true);

/**
 * List Orders
 *
 * List orders for the current organization.
 *
 * Returns:
 * Paginated list of orders with total count.
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const listOrdersAppOrdersGetInfiniteOptions = (options?: Options<ListOrdersAppOrdersGetData>) => {
    const opts = infiniteQueryOptions<ListOrdersAppOrdersGetResponse, ListOrdersAppOrdersGetError, InfiniteData<ListOrdersAppOrdersGetResponse>, QueryKey<Options<ListOrdersAppOrdersGetData>>, number | Pick<QueryKey<Options<ListOrdersAppOrdersGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListOrdersAppOrdersGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listOrdersAppOrdersGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listOrdersAppOrdersGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const orderStatsAppOrdersStatsGetQueryKey = (options?: Options<OrderStatsAppOrdersStatsGetData>) => createQueryKey('orderStatsAppOrdersStatsGet', options);

/**
 * Order Stats
 *
 * Return bucket counts for the stats cards.
 *
 * Returns:
 * Total, pending, and errors counts for the current organization.
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const orderStatsAppOrdersStatsGetOptions = (options?: Options<OrderStatsAppOrdersStatsGetData>) => queryOptions<OrderStatsAppOrdersStatsGetResponse, DefaultError, OrderStatsAppOrdersStatsGetResponse, ReturnType<typeof orderStatsAppOrdersStatsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await orderStatsAppOrdersStatsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: orderStatsAppOrdersStatsGetQueryKey(options)
});

export const getInboundAddressAppOrdersInboundAddressGetQueryKey = (options?: Options<GetInboundAddressAppOrdersInboundAddressGetData>) => createQueryKey('getInboundAddressAppOrdersInboundAddressGet', options);

/**
 * Get Inbound Address
 *
 * Return the per-org inbound forwarding address.
 *
 * Composed from ``Organizations.inbound_email_slug`` and the global
 * ``settings.services.inbound_email_domain``. Resend's wildcard inbound
 * on that domain forwards every local-part to our webhook.
 *
 * Returns:
 * The inbound forwarding email address for the caller's org.
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled for the org.
 */
export const getInboundAddressAppOrdersInboundAddressGetOptions = (options?: Options<GetInboundAddressAppOrdersInboundAddressGetData>) => queryOptions<GetInboundAddressAppOrdersInboundAddressGetResponse, DefaultError, GetInboundAddressAppOrdersInboundAddressGetResponse, ReturnType<typeof getInboundAddressAppOrdersInboundAddressGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInboundAddressAppOrdersInboundAddressGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInboundAddressAppOrdersInboundAddressGetQueryKey(options)
});

/**
 * Retry Order
 *
 * Requeue an errored order's original inbound email for extraction.
 *
 * Returns:
 * The order id and Temporal workflow id for the retry run.
 *
 * Raises:
 * HTTPException: 403 if order inbox is disabled, 404 if the order is not
 * visible to the caller, 409 if the order is not in ERROR.
 */
export const retryOrderAppOrdersOrderIdRetryPostMutation = (options?: Partial<Options<RetryOrderAppOrdersOrderIdRetryPostData>>): UseMutationOptions<RetryOrderAppOrdersOrderIdRetryPostResponse, RetryOrderAppOrdersOrderIdRetryPostError, Options<RetryOrderAppOrdersOrderIdRetryPostData>> => {
    const mutationOptions: UseMutationOptions<RetryOrderAppOrdersOrderIdRetryPostResponse, RetryOrderAppOrdersOrderIdRetryPostError, Options<RetryOrderAppOrdersOrderIdRetryPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryOrderAppOrdersOrderIdRetryPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reprocess Order
 *
 * Force the full extraction workflow to run again, overwriting all data.
 *
 * Unlike ``retry_order`` (which only accepts ERROR orders), this endpoint
 * accepts an order in any status and resets it so the Temporal workflow's
 * idempotency guard (see ``_is_terminal_ready_order``) will re-run every
 * activity and overwrite the extracted fields and line items.
 *
 * Returns:
 * The order id and Temporal workflow id for the reprocess run.
 *
 * Raises:
 * HTTPException: 403 if order inbox is disabled, 404 if the order is not
 * visible to the caller.
 */
export const reprocessOrderAppOrdersOrderIdReprocessPostMutation = (options?: Partial<Options<ReprocessOrderAppOrdersOrderIdReprocessPostData>>): UseMutationOptions<ReprocessOrderAppOrdersOrderIdReprocessPostResponse, ReprocessOrderAppOrdersOrderIdReprocessPostError, Options<ReprocessOrderAppOrdersOrderIdReprocessPostData>> => {
    const mutationOptions: UseMutationOptions<ReprocessOrderAppOrdersOrderIdReprocessPostResponse, ReprocessOrderAppOrdersOrderIdReprocessPostError, Options<ReprocessOrderAppOrdersOrderIdReprocessPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reprocessOrderAppOrdersOrderIdReprocessPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrderAppOrdersOrderIdGetQueryKey = (options: Options<GetOrderAppOrdersOrderIdGetData>) => createQueryKey('getOrderAppOrdersOrderIdGet', options);

/**
 * Get Order
 *
 * Return the detailed view of a single order.
 *
 * ``order_id`` is the public ``Order.public_id`` UUID — URLs never expose
 * the integer PK.
 *
 * Returns:
 * The full order detail, including the originating email body, line
 * items, and short-lived signed URLs for any stored attachments.
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled, 404 if the order
 * does not exist or belongs to a different org, 500 if the order is
 * missing its ingestion record.
 */
export const getOrderAppOrdersOrderIdGetOptions = (options: Options<GetOrderAppOrdersOrderIdGetData>) => queryOptions<GetOrderAppOrdersOrderIdGetResponse, GetOrderAppOrdersOrderIdGetError, GetOrderAppOrdersOrderIdGetResponse, ReturnType<typeof getOrderAppOrdersOrderIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderAppOrdersOrderIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderAppOrdersOrderIdGetQueryKey(options)
});

/**
 * Update Order
 *
 * Apply a sparse manual edit to an order and its line items.
 *
 * Only fields present in the JSON payload are mutated. Explicit ``null``
 * clears nullable columns; omitted fields are left untouched.
 *
 * Returns:
 * The updated order detail response.
 */
export const updateOrderAppOrdersOrderIdPatchMutation = (options?: Partial<Options<UpdateOrderAppOrdersOrderIdPatchData>>): UseMutationOptions<UpdateOrderAppOrdersOrderIdPatchResponse, UpdateOrderAppOrdersOrderIdPatchError, Options<UpdateOrderAppOrdersOrderIdPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrderAppOrdersOrderIdPatchResponse, UpdateOrderAppOrdersOrderIdPatchError, Options<UpdateOrderAppOrdersOrderIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrderAppOrdersOrderIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrderPreviewAppOrdersOrderIdPreviewGetQueryKey = (options: Options<GetOrderPreviewAppOrdersOrderIdPreviewGetData>) => createQueryKey('getOrderPreviewAppOrdersOrderIdPreviewGet', options);

/**
 * Get Order Preview
 *
 * Serve the first-page preview image for an order's attached document.
 *
 * Returns:
 * 200 with the PNG bytes (filesystem backend) or JSON containing a
 * presigned S3 URL (s3 backend).
 *
 * Raises:
 * HTTPException: 403 if order inbox is not enabled, 404 if the order
 * does not exist, belongs to a different org, or has no preview.
 */
export const getOrderPreviewAppOrdersOrderIdPreviewGetOptions = (options: Options<GetOrderPreviewAppOrdersOrderIdPreviewGetData>) => queryOptions<unknown, GetOrderPreviewAppOrdersOrderIdPreviewGetError, unknown, ReturnType<typeof getOrderPreviewAppOrdersOrderIdPreviewGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderPreviewAppOrdersOrderIdPreviewGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderPreviewAppOrdersOrderIdPreviewGetQueryKey(options)
});

export const getOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetQueryKey = (options: Options<GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetData>) => createQueryKey('getOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGet', options);

/**
 * Get Order Attachment
 *
 * Serve the nth attachment from an order's originating email.
 *
 * Returns:
 * 200 with the file bytes (filesystem backend) or JSON containing a
 * presigned S3 URL (s3 backend).
 */
export const getOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetOptions = (options: Options<GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetData>) => queryOptions<unknown, GetOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetError, unknown, ReturnType<typeof getOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderAttachmentAppOrdersOrderIdAttachmentsAttachmentIndexGetQueryKey(options)
});

export const getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetQueryKey = (options: Options<GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetData>) => createQueryKey('getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGet', options);

/**
 * Get Order Attachment Page
 *
 * Render a single page of a PDF attachment as a PNG and stream it.
 *
 * PDF.js (the browser-side renderer) silently drops embedded images on
 * PDFs produced by some MFP firmware (Canon "Adobe PSL", certain Xerox
 * builds, etc.), leaving the user with table grid lines and no text. We
 * sidestep that by rasterizing server-side with poppler — the same path
 * the extraction pipeline uses, which is known to render every PDF we've
 * ingested correctly.
 *
 * Returns:
 * 200 with image/png bytes. Browser-caches for a day.
 *
 * Raises:
 * HTTPException: 403 if order inbox is off, 404 if the order or
 * attachment doesn't exist or isn't a PDF, 422 if the PDF is
 * password-protected, 502 if poppler errored.
 */
export const getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetOptions = (options: Options<GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetData>) => queryOptions<unknown, GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetError, unknown, ReturnType<typeof getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetQueryKey(options)
});

export const getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetInfiniteQueryKey = (options: Options<GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetData>): QueryKey<Options<GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetData>> => createQueryKey('getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGet', options, true);

/**
 * Get Order Attachment Page
 *
 * Render a single page of a PDF attachment as a PNG and stream it.
 *
 * PDF.js (the browser-side renderer) silently drops embedded images on
 * PDFs produced by some MFP firmware (Canon "Adobe PSL", certain Xerox
 * builds, etc.), leaving the user with table grid lines and no text. We
 * sidestep that by rasterizing server-side with poppler — the same path
 * the extraction pipeline uses, which is known to render every PDF we've
 * ingested correctly.
 *
 * Returns:
 * 200 with image/png bytes. Browser-caches for a day.
 *
 * Raises:
 * HTTPException: 403 if order inbox is off, 404 if the order or
 * attachment doesn't exist or isn't a PDF, 422 if the PDF is
 * password-protected, 502 if poppler errored.
 */
export const getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetInfiniteOptions = (options: Options<GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetData>) => {
    const opts = infiniteQueryOptions<unknown, GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetError, InfiniteData<unknown>, QueryKey<Options<GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetData>>, number | Pick<QueryKey<Options<GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                path: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOrderAttachmentPageAppOrdersOrderIdAttachmentsAttachmentIndexPagesPageGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetQueryKey = (options: Options<GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetData>) => createQueryKey('getOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGet', options);

/**
 * Get Order Attachment Xlsx Data
 *
 * Return the parsed sheet contents for an xlsx attachment.
 *
 * Used by the order detail preview to render the workbook as an HTML
 * table — the libreoffice PDF render clips columns past the print page
 * box, which hides part numbers / prices that the LLM actually picked
 * up out of the underlying cells.
 *
 * Returns:
 * XlsxAttachmentData with one entry per visible sheet, each
 * rendered as a padded grid of cell strings.
 *
 * Raises:
 * HTTPException: 403 if order inbox is off, 404 if the order / index
 * is missing or the attachment isn't an xlsx, 422 if the bytes are
 * not a parseable xlsx workbook.
 */
export const getOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetOptions = (options: Options<GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetData>) => queryOptions<GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetResponse, GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetError, GetOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetResponse, ReturnType<typeof getOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderAttachmentXlsxDataAppOrdersOrderIdAttachmentsAttachmentIndexXlsxDataGetQueryKey(options)
});

export const listProductsAppProductsGetQueryKey = (options?: Options<ListProductsAppProductsGetData>) => createQueryKey('listProductsAppProductsGet', options);

/**
 * List Products
 *
 * List the current org's product catalog.
 *
 * Returns:
 * The catalog rows (capped at ``limit``) and the total row count.
 *
 * Raises:
 * HTTPException: 403 if the product catalog is not enabled for this
 * org.
 */
export const listProductsAppProductsGetOptions = (options?: Options<ListProductsAppProductsGetData>) => queryOptions<ListProductsAppProductsGetResponse, ListProductsAppProductsGetError, ListProductsAppProductsGetResponse, ReturnType<typeof listProductsAppProductsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProductsAppProductsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProductsAppProductsGetQueryKey(options)
});

/**
 * Create Product
 *
 * Create a new product in the current org's catalog.
 *
 * Returns:
 * The freshly-created product.
 *
 * Raises:
 * HTTPException: 403 if not entitled, 409 if an existing product in
 * the same org already uses the given SKU.
 */
export const createProductAppProductsPostMutation = (options?: Partial<Options<CreateProductAppProductsPostData>>): UseMutationOptions<CreateProductAppProductsPostResponse, CreateProductAppProductsPostError, Options<CreateProductAppProductsPostData>> => {
    const mutationOptions: UseMutationOptions<CreateProductAppProductsPostResponse, CreateProductAppProductsPostError, Options<CreateProductAppProductsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProductAppProductsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Product
 *
 * Hard-delete a product from the catalog.
 *
 * Soft delete is over-engineering for the trial milestone; a deleted SKU
 * simply stops being matchable against future line items.
 *
 * Raises:
 * HTTPException: 403 if not entitled, 404 if the product doesn't
 * exist or belongs to another org.
 */
export const deleteProductAppProductsProductIdDeleteMutation = (options?: Partial<Options<DeleteProductAppProductsProductIdDeleteData>>): UseMutationOptions<DeleteProductAppProductsProductIdDeleteResponse, DeleteProductAppProductsProductIdDeleteError, Options<DeleteProductAppProductsProductIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<DeleteProductAppProductsProductIdDeleteResponse, DeleteProductAppProductsProductIdDeleteError, Options<DeleteProductAppProductsProductIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteProductAppProductsProductIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProductAppProductsProductIdGetQueryKey = (options: Options<GetProductAppProductsProductIdGetData>) => createQueryKey('getProductAppProductsProductIdGet', options);

/**
 * Get Product
 *
 * Return a single product from the current org's catalog.
 *
 * Returns:
 * The product row.
 *
 * Raises:
 * HTTPException: 403 if not entitled, 404 if the product doesn't
 * exist or belongs to another org.
 */
export const getProductAppProductsProductIdGetOptions = (options: Options<GetProductAppProductsProductIdGetData>) => queryOptions<GetProductAppProductsProductIdGetResponse, GetProductAppProductsProductIdGetError, GetProductAppProductsProductIdGetResponse, ReturnType<typeof getProductAppProductsProductIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductAppProductsProductIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductAppProductsProductIdGetQueryKey(options)
});

/**
 * Update Product
 *
 * Apply a partial update to a product.
 *
 * Only fields provided in the request body are modified; the rest are
 * left unchanged.
 *
 * Returns:
 * The updated product row.
 *
 * Raises:
 * HTTPException: 403 if not entitled, 404 if the product doesn't
 * exist or belongs to another org, 409 if changing the SKU would
 * collide with another product in the same org.
 */
export const updateProductAppProductsProductIdPatchMutation = (options?: Partial<Options<UpdateProductAppProductsProductIdPatchData>>): UseMutationOptions<UpdateProductAppProductsProductIdPatchResponse, UpdateProductAppProductsProductIdPatchError, Options<UpdateProductAppProductsProductIdPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateProductAppProductsProductIdPatchResponse, UpdateProductAppProductsProductIdPatchError, Options<UpdateProductAppProductsProductIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProductAppProductsProductIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTamReportsAppTamReportsGetQueryKey = (options?: Options<GetTamReportsAppTamReportsGetData>) => createQueryKey('getTamReportsAppTamReportsGet', options);

/**
 * Get Tam Reports
 *
 * Get all TAM reports for the current user's organization.
 *
 * Returns reports ordered by creation date (newest first).
 *
 * Returns:
 * List of TAM report summaries.
 */
export const getTamReportsAppTamReportsGetOptions = (options?: Options<GetTamReportsAppTamReportsGetData>) => queryOptions<GetTamReportsAppTamReportsGetResponse, DefaultError, GetTamReportsAppTamReportsGetResponse, ReturnType<typeof getTamReportsAppTamReportsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTamReportsAppTamReportsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTamReportsAppTamReportsGetQueryKey(options)
});

export const getTamReportAppTamReportsReportIdGetQueryKey = (options: Options<GetTamReportAppTamReportsReportIdGetData>) => createQueryKey('getTamReportAppTamReportsReportIdGet', options);

/**
 * Get Tam Report
 *
 * Get a single TAM report by ID (includes full tam_data).
 *
 * Returns:
 * TamReportDetail with all data.
 */
export const getTamReportAppTamReportsReportIdGetOptions = (options: Options<GetTamReportAppTamReportsReportIdGetData>) => queryOptions<GetTamReportAppTamReportsReportIdGetResponse, GetTamReportAppTamReportsReportIdGetError, GetTamReportAppTamReportsReportIdGetResponse, ReturnType<typeof getTamReportAppTamReportsReportIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTamReportAppTamReportsReportIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTamReportAppTamReportsReportIdGetQueryKey(options)
});

export const getEmailPreferencesQueryKey = (options?: Options<GetEmailPreferencesData>) => createQueryKey('getEmailPreferences', options);

/**
 * Get Email Preferences
 *
 * Get the current user's email preferences.
 *
 * Returns all configurable (non-ALWAYS_SEND) email types with the user's
 * current enabled/disabled status. Types not explicitly overridden by the
 * user default to enabled.
 *
 * Returns:
 * List of configurable email preferences with metadata.
 */
export const getEmailPreferencesOptions = (options?: Options<GetEmailPreferencesData>) => queryOptions<GetEmailPreferencesResponse, DefaultError, GetEmailPreferencesResponse, ReturnType<typeof getEmailPreferencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmailPreferences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmailPreferencesQueryKey(options)
});

/**
 * Update Email Preferences
 *
 * Update the current user's email preferences.
 *
 * Accepts a list of preferences (email_type + enabled). Only preferences
 * for types currently in the registry are persisted; stale types are
 * silently dropped. After updating, returns the full merged view (same
 * shape as GET).
 *
 * Returns:
 * List of configurable email preferences with updated status.
 */
export const updateEmailPreferencesMutation = (options?: Partial<Options<UpdateEmailPreferencesData>>): UseMutationOptions<UpdateEmailPreferencesResponse, UpdateEmailPreferencesError, Options<UpdateEmailPreferencesData>> => {
    const mutationOptions: UseMutationOptions<UpdateEmailPreferencesResponse, UpdateEmailPreferencesError, Options<UpdateEmailPreferencesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEmailPreferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImpersonationStatusSuperuserImpersonationCurrentGetQueryKey = (options?: Options<GetImpersonationStatusSuperuserImpersonationCurrentGetData>) => createQueryKey('getImpersonationStatusSuperuserImpersonationCurrentGet', options);

/**
 * Get Impersonation Status
 *
 * Get the current impersonation status.
 *
 * Returns:
 * ImpersonationStatus with is_impersonating=True and admin info if in an
 * impersonation session, otherwise is_impersonating=False.
 */
export const getImpersonationStatusSuperuserImpersonationCurrentGetOptions = (options?: Options<GetImpersonationStatusSuperuserImpersonationCurrentGetData>) => queryOptions<GetImpersonationStatusSuperuserImpersonationCurrentGetResponse, DefaultError, GetImpersonationStatusSuperuserImpersonationCurrentGetResponse, ReturnType<typeof getImpersonationStatusSuperuserImpersonationCurrentGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImpersonationStatusSuperuserImpersonationCurrentGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImpersonationStatusSuperuserImpersonationCurrentGetQueryKey(options)
});

/**
 * Start Impersonation
 *
 * Start an impersonation session for a specific user.
 *
 * Creates a new AccessToken for the target user with impersonation metadata.
 *
 * Returns:
 * Response with Set-Cookie header containing the new impersonation token.
 *
 * Raises:
 * HTTPException: 403 if not superuser, 404 if org/user not found,
 * 400 if already impersonating.
 */
export const startImpersonationSuperuserImpersonationStartPostMutation = (options?: Partial<Options<StartImpersonationSuperuserImpersonationStartPostData>>): UseMutationOptions<unknown, StartImpersonationSuperuserImpersonationStartPostError, Options<StartImpersonationSuperuserImpersonationStartPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, StartImpersonationSuperuserImpersonationStartPostError, Options<StartImpersonationSuperuserImpersonationStartPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startImpersonationSuperuserImpersonationStartPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stop Impersonation
 *
 * Stop the current impersonation session and restore admin session.
 *
 * Deletes the impersonation token and restores the original admin cookie.
 *
 * Returns:
 * Response with Set-Cookie header containing the original admin token.
 *
 * Raises:
 * HTTPException: 400 if not in impersonation session or admin session expired,
 * 500 if original token not found.
 */
export const stopImpersonationSuperuserImpersonationStopPostMutation = (options?: Partial<Options<StopImpersonationSuperuserImpersonationStopPostData>>): UseMutationOptions<unknown, DefaultError, Options<StopImpersonationSuperuserImpersonationStopPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<StopImpersonationSuperuserImpersonationStopPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stopImpersonationSuperuserImpersonationStopPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listImpersonationSessionsSuperuserImpersonationSessionsGetQueryKey = (options?: Options<ListImpersonationSessionsSuperuserImpersonationSessionsGetData>) => createQueryKey('listImpersonationSessionsSuperuserImpersonationSessionsGet', options);

/**
 * List Impersonation Sessions
 *
 * List all active impersonation sessions (superuser only).
 *
 * Returns:
 * ImpersonationSessionList containing all active impersonation sessions.
 *
 * Raises:
 * HTTPException: 403 if user is not a superuser.
 */
export const listImpersonationSessionsSuperuserImpersonationSessionsGetOptions = (options?: Options<ListImpersonationSessionsSuperuserImpersonationSessionsGetData>) => queryOptions<ListImpersonationSessionsSuperuserImpersonationSessionsGetResponse, DefaultError, ListImpersonationSessionsSuperuserImpersonationSessionsGetResponse, ReturnType<typeof listImpersonationSessionsSuperuserImpersonationSessionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listImpersonationSessionsSuperuserImpersonationSessionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listImpersonationSessionsSuperuserImpersonationSessionsGetQueryKey(options)
});

/**
 * Revoke Impersonation Session
 *
 * Force revoke an impersonation session (superuser only).
 *
 * Args:
 * token_prefix: First 8 characters of the token to revoke.
 * user: The authenticated user making the request.
 * session: Database session.
 *
 * Returns:
 * Empty response with 204 status code on success.
 *
 * Raises:
 * HTTPException: 403 if not superuser, 404 if session not found.
 */
export const revokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteMutation = (options?: Partial<Options<RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteData>>): UseMutationOptions<unknown, RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteError, Options<RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteData>> => {
    const mutationOptions: UseMutationOptions<unknown, RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteError, Options<RevokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeImpersonationSessionSuperuserImpersonationSessionsTokenPrefixDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Backfill Inbox
 *
 * Start a Temporal workflow to backfill COMPANY_EVENT inbox items for an org.
 *
 * Returns:
 * Workflow start metadata and organization info for status polling.
 *
 * Raises:
 * HTTPException: 404 when the organization does not exist, or 503 when
 * Temporal cannot start the workflow.
 */
export const startBackfillInboxSuperuserBackfillInboxPostMutation = (options?: Partial<Options<StartBackfillInboxSuperuserBackfillInboxPostData>>): UseMutationOptions<StartBackfillInboxSuperuserBackfillInboxPostResponse, StartBackfillInboxSuperuserBackfillInboxPostError, Options<StartBackfillInboxSuperuserBackfillInboxPostData>> => {
    const mutationOptions: UseMutationOptions<StartBackfillInboxSuperuserBackfillInboxPostResponse, StartBackfillInboxSuperuserBackfillInboxPostError, Options<StartBackfillInboxSuperuserBackfillInboxPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startBackfillInboxSuperuserBackfillInboxPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBackfillInboxStatusSuperuserBackfillInboxStatusGetQueryKey = (options: Options<GetBackfillInboxStatusSuperuserBackfillInboxStatusGetData>) => createQueryKey('getBackfillInboxStatusSuperuserBackfillInboxStatusGet', options);

/**
 * Get Backfill Inbox Status
 *
 * Return the current Temporal status and workflow-reported progress.
 *
 * Returns:
 * Temporal execution status plus workflow progress counters.
 *
 * Raises:
 * HTTPException: 404 when Temporal cannot find the workflow, or 500 when
 * the workflow query returns an unexpected payload.
 */
export const getBackfillInboxStatusSuperuserBackfillInboxStatusGetOptions = (options: Options<GetBackfillInboxStatusSuperuserBackfillInboxStatusGetData>) => queryOptions<GetBackfillInboxStatusSuperuserBackfillInboxStatusGetResponse, GetBackfillInboxStatusSuperuserBackfillInboxStatusGetError, GetBackfillInboxStatusSuperuserBackfillInboxStatusGetResponse, ReturnType<typeof getBackfillInboxStatusSuperuserBackfillInboxStatusGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBackfillInboxStatusSuperuserBackfillInboxStatusGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBackfillInboxStatusSuperuserBackfillInboxStatusGetQueryKey(options)
});

/**
 * Parse Validate
 *
 * Parse and validate a CSV/Excel file for superuser bulk upload.
 *
 * Args:
 * session: Database session.
 * current_user: Authenticated superuser issuing the upload.
 * redis: Stores the short-lived validation token required for execute.
 * organization_id: Organization receiving imported accounts.
 * owner_user_id: User who will own created accounts.
 * file: Uploaded CSV or Excel file.
 *
 * Returns:
 * ParseValidateResponse with validation results.
 *
 * Raises:
 * HTTPException: If org/user validation fails or parsing errors.
 */
export const parseValidateSuperuserBatchUploadsParseValidatePostMutation = (options?: Partial<Options<ParseValidateSuperuserBatchUploadsParseValidatePostData>>): UseMutationOptions<ParseValidateSuperuserBatchUploadsParseValidatePostResponse, ParseValidateSuperuserBatchUploadsParseValidatePostError, Options<ParseValidateSuperuserBatchUploadsParseValidatePostData>> => {
    const mutationOptions: UseMutationOptions<ParseValidateSuperuserBatchUploadsParseValidatePostResponse, ParseValidateSuperuserBatchUploadsParseValidatePostError, Options<ParseValidateSuperuserBatchUploadsParseValidatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await parseValidateSuperuserBatchUploadsParseValidatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Execute Batch Upload
 *
 * Execute the superuser batch upload by creating companies and accounts.
 *
 * Creates accounts owned by owner_user_id but records audit trail with the superuser's ID.
 *
 * Args:
 * request: Parsed companies plus validation_token from parse-validate.
 * session: Database session.
 * current_user: Authenticated superuser.
 * temporal: Temporal client for enrichment workflows.
 * redis: Validates the execute token from parse-validate.
 *
 * Returns:
 * ExecuteResponse with stats and created accounts.
 */
export const executeBatchUploadSuperuserBatchUploadsExecutePostMutation = (options?: Partial<Options<ExecuteBatchUploadSuperuserBatchUploadsExecutePostData>>): UseMutationOptions<ExecuteBatchUploadSuperuserBatchUploadsExecutePostResponse, ExecuteBatchUploadSuperuserBatchUploadsExecutePostError, Options<ExecuteBatchUploadSuperuserBatchUploadsExecutePostData>> => {
    const mutationOptions: UseMutationOptions<ExecuteBatchUploadSuperuserBatchUploadsExecutePostResponse, ExecuteBatchUploadSuperuserBatchUploadsExecutePostError, Options<ExecuteBatchUploadSuperuserBatchUploadsExecutePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await executeBatchUploadSuperuserBatchUploadsExecutePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Organization (Admin)
 *
 * Create a new organization with users, buyer profiles, and initial accounts. Requires JWT Bearer authentication and platform administrator privileges. Auth users must be created before calling this endpoint.
 */
export const createOrganizationSuperuserCreatePostMutation = (options?: Partial<Options<CreateOrganizationSuperuserCreatePostData>>): UseMutationOptions<CreateOrganizationSuperuserCreatePostResponse, CreateOrganizationSuperuserCreatePostError, Options<CreateOrganizationSuperuserCreatePostData>> => {
    const mutationOptions: UseMutationOptions<CreateOrganizationSuperuserCreatePostResponse, CreateOrganizationSuperuserCreatePostError, Options<CreateOrganizationSuperuserCreatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrganizationSuperuserCreatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Quick Trial Create
 *
 * Create a trial organization from just an email. Parses website, generates prospects, and sets everything up automatically. Requires JWT Bearer authentication and superuser privileges.
 */
export const quickTrialCreateSuperuserCreateQuickPostMutation = (options?: Partial<Options<QuickTrialCreateSuperuserCreateQuickPostData>>): UseMutationOptions<QuickTrialCreateSuperuserCreateQuickPostResponse, QuickTrialCreateSuperuserCreateQuickPostError, Options<QuickTrialCreateSuperuserCreateQuickPostData>> => {
    const mutationOptions: UseMutationOptions<QuickTrialCreateSuperuserCreateQuickPostResponse, QuickTrialCreateSuperuserCreateQuickPostError, Options<QuickTrialCreateSuperuserCreateQuickPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await quickTrialCreateSuperuserCreateQuickPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEnrichmentStatusSuperuserEnrichmentStatusGetQueryKey = (options?: Options<GetEnrichmentStatusSuperuserEnrichmentStatusGetData>) => createQueryKey('getEnrichmentStatusSuperuserEnrichmentStatusGet', options);

/**
 * Get Enrichment Status
 *
 * Return per-org enrichment status for superuser dashboard.
 *
 * Returns:
 * EnrichmentStatusResponse for superuser enrichment observability.
 */
export const getEnrichmentStatusSuperuserEnrichmentStatusGetOptions = (options?: Options<GetEnrichmentStatusSuperuserEnrichmentStatusGetData>) => queryOptions<GetEnrichmentStatusSuperuserEnrichmentStatusGetResponse, DefaultError, GetEnrichmentStatusSuperuserEnrichmentStatusGetResponse, ReturnType<typeof getEnrichmentStatusSuperuserEnrichmentStatusGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEnrichmentStatusSuperuserEnrichmentStatusGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEnrichmentStatusSuperuserEnrichmentStatusGetQueryKey(options)
});

export const getEnrichmentFreshnessSuperuserFreshnessGetQueryKey = (options?: Options<GetEnrichmentFreshnessSuperuserFreshnessGetData>) => createQueryKey('getEnrichmentFreshnessSuperuserFreshnessGet', options);

/**
 * Get Enrichment Freshness
 *
 * Return enrichment freshness metrics for superuser dashboard.
 *
 * Returns:
 * FreshnessDashboardResponse for superuser enrichment observability.
 */
export const getEnrichmentFreshnessSuperuserFreshnessGetOptions = (options?: Options<GetEnrichmentFreshnessSuperuserFreshnessGetData>) => queryOptions<GetEnrichmentFreshnessSuperuserFreshnessGetResponse, DefaultError, GetEnrichmentFreshnessSuperuserFreshnessGetResponse, ReturnType<typeof getEnrichmentFreshnessSuperuserFreshnessGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEnrichmentFreshnessSuperuserFreshnessGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEnrichmentFreshnessSuperuserFreshnessGetQueryKey(options)
});

export const getAllOrganizationsSuperuserOrganizationsGetQueryKey = (options?: Options<GetAllOrganizationsSuperuserOrganizationsGetData>) => createQueryKey('getAllOrganizationsSuperuserOrganizationsGet', options);

/**
 * Get All Organizations
 *
 * Get all organizations with their users (staff only).
 *
 * Requires SUPPLYCO staff authentication.
 * Returns all organizations and users with service role access.
 *
 * Returns:
 * AdminOrganizationsResponse instance.
 */
export const getAllOrganizationsSuperuserOrganizationsGetOptions = (options?: Options<GetAllOrganizationsSuperuserOrganizationsGetData>) => queryOptions<GetAllOrganizationsSuperuserOrganizationsGetResponse, DefaultError, GetAllOrganizationsSuperuserOrganizationsGetResponse, ReturnType<typeof getAllOrganizationsSuperuserOrganizationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllOrganizationsSuperuserOrganizationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllOrganizationsSuperuserOrganizationsGetQueryKey(options)
});

/**
 * Update Organization
 *
 * Update organization settings (staff only).
 *
 * Requires SUPPLYCO staff authentication.
 * Updates organization using service role.
 *
 * Returns:
 * OrganizationInfo instance.
 *
 * Raises:
 * HTTPException: If organization not found
 */
export const updateOrganizationSuperuserOrganizationsOrganizationIdPostMutation = (options?: Partial<Options<UpdateOrganizationSuperuserOrganizationsOrganizationIdPostData>>): UseMutationOptions<UpdateOrganizationSuperuserOrganizationsOrganizationIdPostResponse, UpdateOrganizationSuperuserOrganizationsOrganizationIdPostError, Options<UpdateOrganizationSuperuserOrganizationsOrganizationIdPostData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrganizationSuperuserOrganizationsOrganizationIdPostResponse, UpdateOrganizationSuperuserOrganizationsOrganizationIdPostError, Options<UpdateOrganizationSuperuserOrganizationsOrganizationIdPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrganizationSuperuserOrganizationsOrganizationIdPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetQueryKey = (options: Options<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetData>) => createQueryKey('getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGet', options);

/**
 * Get Organization Accounts For Admin
 *
 * Get paginated organization accounts for admin account sharing management.
 *
 * This endpoint:
 * - Requires admin role in the organization
 * - Returns paginated accounts in the organization with sharing information
 * - Includes owner, assignee, and sharing status for each account
 * - Supports pagination with pageIndex and pageSize parameters
 *
 * Returns:
 * Page[OrganizationAccountAdmin] instance.
 */
export const getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetOptions = (options: Options<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetData>) => queryOptions<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetResponse, GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetError, GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetResponse, ReturnType<typeof getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetQueryKey(options)
});

export const getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetInfiniteQueryKey = (options: Options<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetData>): QueryKey<Options<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetData>> => createQueryKey('getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGet', options, true);

/**
 * Get Organization Accounts For Admin
 *
 * Get paginated organization accounts for admin account sharing management.
 *
 * This endpoint:
 * - Requires admin role in the organization
 * - Returns paginated accounts in the organization with sharing information
 * - Includes owner, assignee, and sharing status for each account
 * - Supports pagination with pageIndex and pageSize parameters
 *
 * Returns:
 * Page[OrganizationAccountAdmin] instance.
 */
export const getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetInfiniteOptions = (options: Options<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetData>) => {
    const opts = infiniteQueryOptions<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetResponse, GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetError, InfiniteData<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetResponse>, QueryKey<Options<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetData>>, number | Pick<QueryKey<Options<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getOrganizationAccountsForAdminSuperuserOrganizationsAccountsOrganizationIdGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Reset User Password
 *
 * Send password reset email to a user (superuser only).
 *
 * Works for any verified user. Triggers the forgot-password flow.
 *
 * Raises:
 * HTTPException: If user not found (404), user not in organization (404),
 * or permission denied (403).
 */
export const resetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostMutation = (options?: Partial<Options<ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostData>>): UseMutationOptions<ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostResponse, ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostError, Options<ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostData>> => {
    const mutationOptions: UseMutationOptions<ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostResponse, ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostError, Options<ResetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetUserPasswordSuperuserOrganizationsOrganizationIdUsersUserIdResetPasswordPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disconnect Crm
 *
 * Disconnect an organization's CRM integration (staff only).
 *
 * Sets the active MergeIntegration status to "disconnected".
 * Does not call the Merge API — only updates the local record.
 *
 * Returns:
 * DisconnectCrmResponse with confirmation message.
 *
 * Raises:
 * HTTPException: If no active integration found (404).
 */
export const disconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostMutation = (options?: Partial<Options<DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostData>>): UseMutationOptions<DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostResponse, DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostError, Options<DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostData>> => {
    const mutationOptions: UseMutationOptions<DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostResponse, DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostError, Options<DisconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disconnectCrmSuperuserOrganizationsOrganizationIdDisconnectCrmPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync Crm
 *
 * Trigger a CRM sync for an organization (staff only).
 *
 * Starts a Temporal workflow to import CRM data.
 *
 * Returns:
 * SyncCrmResponse with workflow ID and status message.
 *
 * Raises:
 * HTTPException: If no active integration found (404) or sync already running (409).
 */
export const syncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostMutation = (options?: Partial<Options<SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostData>>): UseMutationOptions<SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostResponse, SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostError, Options<SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostData>> => {
    const mutationOptions: UseMutationOptions<SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostResponse, SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostError, Options<SyncCrmSuperuserOrganizationsOrganizationIdSyncCrmPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncCrmSuperuserOrganizationsOrganizationIdSyncCrmPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Trigger Scout Lead Generation
 *
 * Trigger manual scout lead generation for an organization (staff only).
 *
 * Creates a ScoutRun record and starts the ScoutDiscoveryWorkflow via Temporal.
 *
 * Args:
 * request: Request containing leads_needed parameter
 * organization_id: Organization to generate leads for
 * session: Database session
 * temporal: Temporal client
 *
 * Returns:
 * TriggerScoutLeadGenerationResponse with workflow ID, run ID, and status message.
 *
 * Raises:
 * HTTPException: If organization not found or workflow already running.
 */
export const triggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostMutation = (options?: Partial<Options<TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostData>>): UseMutationOptions<TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostResponse, TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostError, Options<TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostData>> => {
    const mutationOptions: UseMutationOptions<TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostResponse, TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostError, Options<TriggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triggerScoutLeadGenerationSuperuserOrganizationsOrganizationIdTriggerScoutLeadGenerationPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rollback Last Scout Claim
 *
 * Re-hide leads from the most recent SCOUT claim for demo prep.
 *
 * This rolls back the customer-facing claim action by setting the claimed
 * accounts back to PRE_GENERATED and reopening the associated inbox item.
 *
 * Returns:
 * Rollback summary.
 *
 * Raises:
 * HTTPException: If no SCOUT claim can be rolled back.
 */
export const rollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostMutation = (options?: Partial<Options<RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostData>>): UseMutationOptions<RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostResponse, RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostError, Options<RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostData>> => {
    const mutationOptions: UseMutationOptions<RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostResponse, RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostError, Options<RollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rollbackLastScoutClaimSuperuserOrganizationsOrganizationIdRollbackLastScoutClaimPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rerun Triage Analysis
 *
 * Re-run triage analysis (accounts_fit_analysis) for all accounts in an organization.
 *
 * This endpoint is SUPERUSER-ONLY. It:
 * 1. Verifies user is a SUPPLYCO superuser (via require_superuser dependency)
 * 2. Validates that the organization exists
 * 3. Optionally clears existing triage data (with audit logging)
 * 4. Starts AccountEnrichmentWorkflow for each account via Temporal
 *
 * Args:
 * session: SQLAlchemy async session for organization validation.
 * organization_id: ID of the organization to rerun triage for.
 * user: Authenticated superuser (enforced by require_superuser dependency).
 * temporal: Temporal client for starting workflows.
 * clear_triage_data: Whether to clear existing triage data before rerunning.
 *
 * Returns:
 * RerunTriageResponse with workflow start details.
 *
 * Raises:
 * HTTPException: 403 if user is not a superuser (raised by require_superuser dependency),
 * 404 if organization not found, 500 if failed to start workflows.
 */
export const rerunTriageAnalysisSuperuserRerunTriagePostMutation = (options?: Partial<Options<RerunTriageAnalysisSuperuserRerunTriagePostData>>): UseMutationOptions<RerunTriageAnalysisSuperuserRerunTriagePostResponse, RerunTriageAnalysisSuperuserRerunTriagePostError, Options<RerunTriageAnalysisSuperuserRerunTriagePostData>> => {
    const mutationOptions: UseMutationOptions<RerunTriageAnalysisSuperuserRerunTriagePostResponse, RerunTriageAnalysisSuperuserRerunTriagePostError, Options<RerunTriageAnalysisSuperuserRerunTriagePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rerunTriageAnalysisSuperuserRerunTriagePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate Tam Report
 *
 * Generate a fresh TAM report for any organization (staff only).
 *
 * Thin wrapper around create_and_dispatch_tam_report. The service handles
 * row creation, workflow dispatch, and FAILED-on-dispatch-error.
 *
 * Returns:
 * GenerateTamReportResponse with the new report id and processing status.
 *
 * Raises:
 * HTTPException: 404 if organization does not exist.
 * RuntimeError: If processing_status is None after creation (should never happen).
 */
export const generateTamReportSuperuserTamReportsPostMutation = (options?: Partial<Options<GenerateTamReportSuperuserTamReportsPostData>>): UseMutationOptions<GenerateTamReportSuperuserTamReportsPostResponse, GenerateTamReportSuperuserTamReportsPostError, Options<GenerateTamReportSuperuserTamReportsPostData>> => {
    const mutationOptions: UseMutationOptions<GenerateTamReportSuperuserTamReportsPostResponse, GenerateTamReportSuperuserTamReportsPostError, Options<GenerateTamReportSuperuserTamReportsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateTamReportSuperuserTamReportsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserSuperuserUsersUserIdGetQueryKey = (options: Options<GetUserSuperuserUsersUserIdGetData>) => createQueryKey('getUserSuperuserUsersUserIdGet', options);

/**
 * Get User
 *
 * Get any user by ID (superuser only).
 *
 * Returns:
 * SuperuserUserResponse with user data.
 *
 * Raises:
 * HTTPException: If user not found (404).
 */
export const getUserSuperuserUsersUserIdGetOptions = (options: Options<GetUserSuperuserUsersUserIdGetData>) => queryOptions<GetUserSuperuserUsersUserIdGetResponse, GetUserSuperuserUsersUserIdGetError, GetUserSuperuserUsersUserIdGetResponse, ReturnType<typeof getUserSuperuserUsersUserIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserSuperuserUsersUserIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserSuperuserUsersUserIdGetQueryKey(options)
});

/**
 * Update User
 *
 * Update any user (superuser only).
 *
 * Allows updating all user fields including email, verification status,
 * role, and organization.
 *
 * Returns:
 * SuperuserUserResponse with updated user data.
 *
 * Raises:
 * HTTPException: If user not found (404).
 */
export const updateUserSuperuserUsersUserIdPatchMutation = (options?: Partial<Options<UpdateUserSuperuserUsersUserIdPatchData>>): UseMutationOptions<UpdateUserSuperuserUsersUserIdPatchResponse, UpdateUserSuperuserUsersUserIdPatchError, Options<UpdateUserSuperuserUsersUserIdPatchData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserSuperuserUsersUserIdPatchResponse, UpdateUserSuperuserUsersUserIdPatchError, Options<UpdateUserSuperuserUsersUserIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserSuperuserUsersUserIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Auth:Cookie.Login
 */
export const authCookieLoginAuthLoginPostMutation = (options?: Partial<Options<AuthCookieLoginAuthLoginPostData>>): UseMutationOptions<AuthCookieLoginAuthLoginPostResponse, AuthCookieLoginAuthLoginPostError, Options<AuthCookieLoginAuthLoginPostData>> => {
    const mutationOptions: UseMutationOptions<AuthCookieLoginAuthLoginPostResponse, AuthCookieLoginAuthLoginPostError, Options<AuthCookieLoginAuthLoginPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authCookieLoginAuthLoginPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Auth:Cookie.Logout
 */
export const authCookieLogoutAuthLogoutPostMutation = (options?: Partial<Options<AuthCookieLogoutAuthLogoutPostData>>): UseMutationOptions<AuthCookieLogoutAuthLogoutPostResponse, DefaultError, Options<AuthCookieLogoutAuthLogoutPostData>> => {
    const mutationOptions: UseMutationOptions<AuthCookieLogoutAuthLogoutPostResponse, DefaultError, Options<AuthCookieLogoutAuthLogoutPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authCookieLogoutAuthLogoutPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Auth:Bearer.Login
 */
export const authBearerLoginAuthBearerLoginPostMutation = (options?: Partial<Options<AuthBearerLoginAuthBearerLoginPostData>>): UseMutationOptions<AuthBearerLoginAuthBearerLoginPostResponse, AuthBearerLoginAuthBearerLoginPostError, Options<AuthBearerLoginAuthBearerLoginPostData>> => {
    const mutationOptions: UseMutationOptions<AuthBearerLoginAuthBearerLoginPostResponse, AuthBearerLoginAuthBearerLoginPostError, Options<AuthBearerLoginAuthBearerLoginPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authBearerLoginAuthBearerLoginPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Auth:Bearer.Logout
 */
export const authBearerLogoutAuthBearerLogoutPostMutation = (options?: Partial<Options<AuthBearerLogoutAuthBearerLogoutPostData>>): UseMutationOptions<unknown, DefaultError, Options<AuthBearerLogoutAuthBearerLogoutPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<AuthBearerLogoutAuthBearerLogoutPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authBearerLogoutAuthBearerLogoutPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify:Request-Token
 */
export const verifyRequestTokenAuthRequestVerifyTokenPostMutation = (options?: Partial<Options<VerifyRequestTokenAuthRequestVerifyTokenPostData>>): UseMutationOptions<unknown, VerifyRequestTokenAuthRequestVerifyTokenPostError, Options<VerifyRequestTokenAuthRequestVerifyTokenPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, VerifyRequestTokenAuthRequestVerifyTokenPostError, Options<VerifyRequestTokenAuthRequestVerifyTokenPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyRequestTokenAuthRequestVerifyTokenPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify:Verify
 */
export const verifyVerifyAuthVerifyPostMutation = (options?: Partial<Options<VerifyVerifyAuthVerifyPostData>>): UseMutationOptions<VerifyVerifyAuthVerifyPostResponse, VerifyVerifyAuthVerifyPostError, Options<VerifyVerifyAuthVerifyPostData>> => {
    const mutationOptions: UseMutationOptions<VerifyVerifyAuthVerifyPostResponse, VerifyVerifyAuthVerifyPostError, Options<VerifyVerifyAuthVerifyPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyVerifyAuthVerifyPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset:Forgot Password
 */
export const resetForgotPasswordAuthForgotPasswordPostMutation = (options?: Partial<Options<ResetForgotPasswordAuthForgotPasswordPostData>>): UseMutationOptions<unknown, ResetForgotPasswordAuthForgotPasswordPostError, Options<ResetForgotPasswordAuthForgotPasswordPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, ResetForgotPasswordAuthForgotPasswordPostError, Options<ResetForgotPasswordAuthForgotPasswordPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetForgotPasswordAuthForgotPasswordPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset:Reset Password
 */
export const resetResetPasswordAuthResetPasswordPostMutation = (options?: Partial<Options<ResetResetPasswordAuthResetPasswordPostData>>): UseMutationOptions<unknown, ResetResetPasswordAuthResetPasswordPostError, Options<ResetResetPasswordAuthResetPasswordPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, ResetResetPasswordAuthResetPasswordPostError, Options<ResetResetPasswordAuthResetPasswordPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetResetPasswordAuthResetPasswordPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersCurrentUserAuthUsersMeGetQueryKey = (options?: Options<UsersCurrentUserAuthUsersMeGetData>) => createQueryKey('usersCurrentUserAuthUsersMeGet', options);

/**
 * Users:Current User
 */
export const usersCurrentUserAuthUsersMeGetOptions = (options?: Options<UsersCurrentUserAuthUsersMeGetData>) => queryOptions<UsersCurrentUserAuthUsersMeGetResponse, DefaultError, UsersCurrentUserAuthUsersMeGetResponse, ReturnType<typeof usersCurrentUserAuthUsersMeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersCurrentUserAuthUsersMeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersCurrentUserAuthUsersMeGetQueryKey(options)
});

/**
 * Users:Patch Current User
 */
export const usersPatchCurrentUserAuthUsersMePatchMutation = (options?: Partial<Options<UsersPatchCurrentUserAuthUsersMePatchData>>): UseMutationOptions<UsersPatchCurrentUserAuthUsersMePatchResponse, UsersPatchCurrentUserAuthUsersMePatchError, Options<UsersPatchCurrentUserAuthUsersMePatchData>> => {
    const mutationOptions: UseMutationOptions<UsersPatchCurrentUserAuthUsersMePatchResponse, UsersPatchCurrentUserAuthUsersMePatchError, Options<UsersPatchCurrentUserAuthUsersMePatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersPatchCurrentUserAuthUsersMePatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Users:Delete User
 */
export const usersDeleteUserAuthUsersIdDeleteMutation = (options?: Partial<Options<UsersDeleteUserAuthUsersIdDeleteData>>): UseMutationOptions<UsersDeleteUserAuthUsersIdDeleteResponse, UsersDeleteUserAuthUsersIdDeleteError, Options<UsersDeleteUserAuthUsersIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<UsersDeleteUserAuthUsersIdDeleteResponse, UsersDeleteUserAuthUsersIdDeleteError, Options<UsersDeleteUserAuthUsersIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersDeleteUserAuthUsersIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersUserAuthUsersIdGetQueryKey = (options: Options<UsersUserAuthUsersIdGetData>) => createQueryKey('usersUserAuthUsersIdGet', options);

/**
 * Users:User
 */
export const usersUserAuthUsersIdGetOptions = (options: Options<UsersUserAuthUsersIdGetData>) => queryOptions<UsersUserAuthUsersIdGetResponse, UsersUserAuthUsersIdGetError, UsersUserAuthUsersIdGetResponse, ReturnType<typeof usersUserAuthUsersIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersUserAuthUsersIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersUserAuthUsersIdGetQueryKey(options)
});

/**
 * Users:Patch User
 */
export const usersPatchUserAuthUsersIdPatchMutation = (options?: Partial<Options<UsersPatchUserAuthUsersIdPatchData>>): UseMutationOptions<UsersPatchUserAuthUsersIdPatchResponse, UsersPatchUserAuthUsersIdPatchError, Options<UsersPatchUserAuthUsersIdPatchData>> => {
    const mutationOptions: UseMutationOptions<UsersPatchUserAuthUsersIdPatchResponse, UsersPatchUserAuthUsersIdPatchError, Options<UsersPatchUserAuthUsersIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersPatchUserAuthUsersIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Magic Link
 *
 * Send a magic link to the user's email.
 *
 * Args:
 * email: The email to send the magic link to.
 * email_service: The email service.
 * secret_key: The secret key to use for generating the token.
 *
 * Raises:
 * HTTPException: If the email fails to send.
 */
export const magicLinkAuthMagicLinkPostMutation = (options?: Partial<Options<MagicLinkAuthMagicLinkPostData>>): UseMutationOptions<unknown, MagicLinkAuthMagicLinkPostError, Options<MagicLinkAuthMagicLinkPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, MagicLinkAuthMagicLinkPostError, Options<MagicLinkAuthMagicLinkPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await magicLinkAuthMagicLinkPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Magic Link Callback
 *
 * Verify a magic link.
 *
 * Be careful touching this, it's a hack around fastapi_users's verification process.
 *
 * Args:
 * token: The token to verify the magic link.
 * user_manager: The user manager.
 * strategy: The strategy to use for authentication.
 * secret_key: The secret key to use for decoding the token.
 * redis: Async Redis client for single-use token enforcement.
 * posthog: Server-side analytics client.
 *
 * Returns:
 * Response with authentication cookie set.
 *
 * Raises:
 * HTTPException: If the token is invalid.
 */
export const magicLinkCallbackAuthMagicLinkCallbackPostMutation = (options?: Partial<Options<MagicLinkCallbackAuthMagicLinkCallbackPostData>>): UseMutationOptions<unknown, MagicLinkCallbackAuthMagicLinkCallbackPostError, Options<MagicLinkCallbackAuthMagicLinkCallbackPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, MagicLinkCallbackAuthMagicLinkCallbackPostError, Options<MagicLinkCallbackAuthMagicLinkCallbackPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await magicLinkCallbackAuthMagicLinkCallbackPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetQueryKey = (options?: Options<GetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetData>) => createQueryKey('getSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGet', options);

/**
 * Get Superuser Impersonation Status
 *
 * Check if the current session is a superuser impersonation session.
 *
 * This endpoint is accessible to all authenticated users so that impersonated
 * users can see their impersonation status and the impersonation banner.
 *
 * Returns:
 * SuperuserImpersonationStatus with is_impersonating=True and admin info
 * if in an impersonation session, otherwise is_impersonating=False.
 */
export const getSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetOptions = (options?: Options<GetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetData>) => queryOptions<GetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetResponse, DefaultError, GetSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetResponse, ReturnType<typeof getSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSuperuserImpersonationStatusAuthSuperuserImpersonationStatusGetQueryKey(options)
});

/**
 * Inbound Email
 *
 * Receive an inbound email webhook from Resend.
 *
 * Returns:
 * ``{"ok": True}`` on happy path.
 * ``{"ok": True, "skipped": "unsupported_event_type"}`` if Resend
 * delivers an event other than :data:`SUPPORTED_EVENT_TYPE` to
 * this URL — a 200 keeps Resend's retry queue from filling up
 * with events we'll never act on.
 * ``{"ok": True, "skipped": "wrong_domain"|"unknown_recipient"|"blocked"}``
 * when the request was bounced at receipt without dispatching the
 * extraction workflow.
 * ``{"ok": True, "duplicate": True}`` if the message_id was already
 * ingested (idempotent no-op).
 */
export const inboundEmailWebhooksInboundEmailPostMutation = (options?: Partial<Options<InboundEmailWebhooksInboundEmailPostData>>): UseMutationOptions<InboundEmailWebhooksInboundEmailPostResponse, DefaultError, Options<InboundEmailWebhooksInboundEmailPostData>> => {
    const mutationOptions: UseMutationOptions<InboundEmailWebhooksInboundEmailPostResponse, DefaultError, Options<InboundEmailWebhooksInboundEmailPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await inboundEmailWebhooksInboundEmailPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mailpit Inbound
 *
 * Receive an inbound email webhook from Mailpit.
 *
 * Returns:
 * ``{"ok": True}`` on happy-path.
 * ``{"ok": True, "skipped": "<reason>"}`` when the message is not
 * addressed to the inbound inbox (or has no id). Always 200 so
 * Mailpit doesn't retry noisy cases.
 *
 * Raises:
 * HTTPException: 502 if the Mailpit API is unreachable or returns an
 * error fetching the full message.
 */
export const mailpitInboundWebhooksMailpitInboundPostMutation = (options?: Partial<Options<MailpitInboundWebhooksMailpitInboundPostData>>): UseMutationOptions<MailpitInboundWebhooksMailpitInboundPostResponse, DefaultError, Options<MailpitInboundWebhooksMailpitInboundPostData>> => {
    const mutationOptions: UseMutationOptions<MailpitInboundWebhooksMailpitInboundPostResponse, DefaultError, Options<MailpitInboundWebhooksMailpitInboundPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mailpitInboundWebhooksMailpitInboundPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDevUsersDevUsersGetQueryKey = (options?: Options<ListDevUsersDevUsersGetData>) => createQueryKey('listDevUsersDevUsersGet', options);

/**
 * List Dev Users
 *
 * List all users available for dev login.
 *
 * Returns all users in the database, useful for the dev user switcher UI.
 *
 * Returns:
 * DevUsersResponse with list of all users.
 */
export const listDevUsersDevUsersGetOptions = (options?: Options<ListDevUsersDevUsersGetData>) => queryOptions<ListDevUsersDevUsersGetResponse, DefaultError, ListDevUsersDevUsersGetResponse, ReturnType<typeof listDevUsersDevUsersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDevUsersDevUsersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDevUsersDevUsersGetQueryKey(options)
});

/**
 * Dev Login
 *
 * Login as any user by email without password.
 *
 * DEV ONLY - bypasses password verification for rapid user switching.
 *
 * Returns:
 * Response with authentication cookie set.
 *
 * Raises:
 * HTTPException: 404 if user not found.
 */
export const devLoginDevLoginEmailPostMutation = (options?: Partial<Options<DevLoginDevLoginEmailPostData>>): UseMutationOptions<unknown, DevLoginDevLoginEmailPostError, Options<DevLoginDevLoginEmailPostData>> => {
    const mutationOptions: UseMutationOptions<unknown, DevLoginDevLoginEmailPostError, Options<DevLoginDevLoginEmailPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await devLoginDevLoginEmailPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const healthCheckHealthGetQueryKey = (options?: Options<HealthCheckHealthGetData>) => createQueryKey('healthCheckHealthGet', options);

/**
 * Health Check
 *
 * Check the health of the application.
 *
 * Returns:
 * dict[str, Any] instance.
 */
export const healthCheckHealthGetOptions = (options?: Options<HealthCheckHealthGetData>) => queryOptions<HealthCheckHealthGetResponse, DefaultError, HealthCheckHealthGetResponse, ReturnType<typeof healthCheckHealthGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthCheckHealthGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthCheckHealthGetQueryKey(options)
});

export const healthDetailedHealthDetailedGetQueryKey = (options?: Options<HealthDetailedHealthDetailedGetData>) => createQueryKey('healthDetailedHealthDetailedGet', options);

/**
 * Health Detailed
 *
 * Detailed health check with memory and process diagnostics.
 *
 * Returns:
 * Health status with memory usage, PID, uptime, and background task count.
 */
export const healthDetailedHealthDetailedGetOptions = (options?: Options<HealthDetailedHealthDetailedGetData>) => queryOptions<HealthDetailedHealthDetailedGetResponse, DefaultError, HealthDetailedHealthDetailedGetResponse, ReturnType<typeof healthDetailedHealthDetailedGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthDetailedHealthDetailedGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthDetailedHealthDetailedGetQueryKey(options)
});
